const enUs = {
  "menu.overview": "Overview",
  "menu.sales": "Sales",
  "menu.inventory-management": "Inventory & Stock",
  "menu.crm": "Partners & CRM",
  "menu.finance": "Finance & Tax",
  "menu.utilities": "Utilities",
  "product.tax-rate": "Tax Rate",
  "table.import.tax-rate": "Tax Rate (%)",
  /* 00.General */
  "general.copyright": "Coffee Management © 2019 All Rights Reserved.",
  "general.refresh": "Refresh Lists",
  "general.btn-update": "Update",
  "general.btn-update-count": "Update Count",
  "general.btn-add": "Add",
  "general.btn-order": "Order now!",
  "general.btn-order-preview": "View product",
  "general.product-unit": "products",
  "general.btn-create-make-product": "Create Recipe",
  "general.btn-update-make-product": "Update Recipe",
  "general.btn-cancel": "Cancel",
  "role.default.cashier": "Cashier",
  "role.default.kitchen": "Bar / Kitchen",
  "role.default.table-pending-payment": "Waiter",
  "general.info": "INFOMATION",
  "general.setting": "SETTING",
  "general.function": "FUNCTION",
  timeCreated: "Time created",
  "print.cashier": "Cashier",
  "print.invoice": "Invoice",
  "print.name-product": "Name",
  "print.quantity": "Quantity",
  "print.price": "Price",
  "print.total-price": "Total",
  "print.discount": "Discount",
  "print.tax": "Tax",
  "print.fee-other": "Fee",
  "print.shipping": "Shipping",
  "print.amount-to-pay": "Amount to be paid",
  "print.info-bill": "Billing Infomation",
  "print.thank-you": "Thank you very much!",
  "print.copy-right": "Copyright of vmass.vn.",

  /* 01.Order */
  "order.to-pending": "to Kitchen",
  "order.to-done": "Move Pay",
  "order.done": "Done",
  "order.to-refund": "Refund",
  "order.to-change": "Change",
  "order.to-bill-draft": "Print provisional invoices",
  "order.to-bill": "Print bill",
  "order.to-end": "Completed",
  "order.print-bill": "Print bill",
  "order.to-excel": "Download Excel",
  "order.to-destroy": "Destroy",
  "order.transfer-table": "Transfer table",
  "order.to-bill-now": "Print",
  "order.to-bill-all": "Print All",
  "order.open-menu": "Add product",
  "order.search": "Search for invoices",
  "order.list-product-in-table": "List products in the table",

  /* 02. Profile */
  "company-uuid": "Store code",
  "company-name": "Name of the store",
  "profile.fullname": "Fullname",
  "profile.username": "Username",
  "profile.email": "Email",
  "profile.address": "Address",
  "profile.description": "Description",
  "profile.avatar": "Avatar",
  "profile.company-address": "Company Address",
  "profile.company-website": "Website",
  "profile.company-logo": "Logo Store",
  "profile.company-image": "Cover photo of the store",
  "profile.company-start-time": "Open time",
  "profile.company-end-time": "Close time",
  "profile.company-menu-hash": "Store menu code",
  "profile.company-menu-hash-create": "Add new",
  "profile.phone": "Phone",
  "profile.birth-day": "Birthday",
  "profile.btn-update": "Update",
  "pages.responsibilities": "Specialize",
  "menu.contact": "Social",
  "profile.update-personal": "Update Personal Info",
  "profile.update-company": "Update Company Info",
  "profile.companyName": "Store name",
  "profile.bankPay": "Name of bank",
  "profile.namePay": "Name of account holder",
  "profile.numberPay": "Account number",

  /* 03.User Login, Logout, Register */
  "user.login-title": "Sign in",
  "user.register": "Sign up",
  "user.forgot-password": "Forgot password",
  "user.username": "Username",
  "user.email": "Email",
  "user.phone": "Phone",
  "user.password": "Password",
  "user.re-password": "rePassword",
  "user.forgot-password-question": "Forgot password?",
  "user.reset-password-button": "Receive new code",
  "user.reset-password-button-submit": "Change password",
  "user.fullname": "Fullname",
  "user.login-button": "Login",
  "user.register-button": "Register",
  "user.no-account": "No account? ",
  "user.register-link": "Register now",
  "user.code": "Code",

  /* 04.Menu */
  "menu.partner": "Personal",
  "menu.money": "Finance",
  "menu.m": "Product",
  "menu.warehouse": "Inventory",
  "menu.invoice": "Invoice",
  "menu.sales-invoice": "Sales Invoices",
  "menu.einvoice": "E-Invoices",
  "menu.order": "Invoice",
  "menu.app": "Home",
  "menu.affiliates": "Affiliates",
  "menu.affiliate-list": "Affiliate List",
  "menu.affiliate-payouts": "Affiliate Payouts",
  "menu.affiliate-commission": "Commission Config",
  "menu.affiliate-reports": "Affiliate Reports",
  "menu.affiliate-fraud": "Fraud Control",
  "menu.calendars": "Calendar",
  "menu.analytics": "Analytics",
  "menu.faq": "FAQ",
  "menu.view": "Question & Anwser",
  "menu.default": "Tổng quát",
  "menu.content": "Content",
  "menu.product": "Product",
  "menu.menu": "Product",
  "menu.pages": "Manager",
  "menu.thumb-list": "Product",
  // 'menu.order': 'Order',
  "menu.search": "Search",
  "menu.login": "Login",
  "menu.register": "Register",
  "menu.company": "Information of store",
  "menu.profile": "Information",
  "menu.forgot-password": "Change password",
  "menu.applications": "Account",
  "menu.promotion": "Promotion",
  "menu.todo": "Event",
  "menu.category": "Type product",
  "menu.ui": "UI",
  "menu.table-setting": "Table chair",
  "menu.stock": "Stock",
  "menu.warehouse-import": "Receipt",
  "menu.warehouse-export": "Phiếu xuất kho",
  "menu.warehouse-transfer": "Delivery bill",
  "menu.make-product": "Quantitative",
  "menu.payment": "Payment waiting table",
  "menu.table-pending-payment": "Pending Payment",
  "menu.message": "Message",
  "menu.ref": "Affiliate",
  "menu.upgrade": "Upgrade",
  "menu.setting": "Setting",
  "menu.root": "VMASS",
  "menu.user-staff": "Staff",
  "menu.customer": "Customer",
  "menu.company-provider": "supplier",
  "menu.treasury": "Treasury",
  "menu.income": "Income",
  "menu.outcome": "Outcome",
  "menu.cash-flow": "Cash Flow",
  "menu.role": "Create permission",
  "menu.form-dynamic": "Customize Form",
  "menu.user-role": "Create account",
  "menu.qrcode": "Qr Code",
  "menu.companies": "Link stores together",
  "menu.shipping": "Shipping",
  "menu.facebook-settings": "Facebook Fanpage",
  "menu.zalo-settings": "Zalo OA",
  "menu.dashboards": "POS",
  "menu.calendars": "Calendars",
  "menu.booking": "Booking",
  "menu.analytics": "Analytics",
  "menu.pages": "Management",
  "menu.todo": "Todo",
  "menu.invoice": "Invoice",
  "menu.promotion": "Promotion",
  "menu.partner": "Partner",
  "menu.money": "Cash Book",
  "menu.m": "Warehouse Mgmt",
  "menu.thumb-list": "Product List",
  "menu.warehouse": "Warehouse",
  "menu.stock": "Stock",
  "menu.inventory-audit": "Inventory Audit",
  "menu.stock-return": "Stock Return",
  "menu.stock-disposal": "Stock Disposal",
  "menu.stock-out": "Stock Out",
  "stock-out.subtitle": "Manage internal issues, supplier returns, and disposal with an auditable approval flow.",
  "stock-out.create": "Create Stock-out",
  "menu.table-setting": "Table Setting",
  "menu.message": "Message",
  "menu.facebook-ads": "Facebook Ads",
  "menu.fb-ads-dashboard": "Dashboard",
  "menu.fb-ads-campaigns": "Campaigns",
  "menu.fb-ads-reports": "Reports",
  "menu.fb-ads-settings": "Settings",
  "menu.applications": "Applications",
  "menu.profile": "Profile",
  "menu.upgrade": "Upgrade",
  "menu.setting": "Setting",
  "warehouse.export": "Stock Export",
  "warehouse.transfer": "Stock Transfer",

  /* Shift Session */
  "menu.shift-session": "Shift Closing",
  "menu.tax-accounting": "Tax & Accounting",
  "menu.ai-copilot": "AI Copilot",
  "shift.title": "Shift Management",
  "shift.open": "Open Shift",
  "shift.close": "Close Shift",
  "shift.current": "Current Shift",
  "shift.history": "Shift History",
  "shift.no-open": "No shift is currently open",
  "shift.open-hint": 'Press "Open Shift" to start a new shift',
  "shift.open-modal-title": "Open Work Shift",
  "shift.close-modal-title": "Close Shift & Cash Reconciliation",
  "shift.detail-modal-title": "Shift Details",
  "shift.shift-name": "Shift Name",
  "shift.shift-name-placeholder": "E.g: Morning shift, Afternoon shift...",
  "shift.staff-name": "Staff",
  "shift.opened-at": "Opened At",
  "shift.closed-at": "Closed At",
  "shift.opening-cash": "Opening Cash",
  "shift.opening-cash-hint": "Cash in register at shift start",
  "shift.actual-cash": "Actual Cash at End of Shift",
  "shift.actual-cash-placeholder": "Enter actual cash counted",
  "shift.expected-cash": "Expected Cash",
  "shift.cash-difference": "Difference",
  "shift.total-revenue": "Total Revenue",
  "shift.total-cash": "Cash",
  "shift.total-transfer": "Bank Transfer",
  "shift.total-card": "Credit Card",
  "shift.total-credit": "Debt",
  "shift.total-orders": "Total Orders",
  "shift.total-products": "Total Products",
  "shift.note": "Note",
  "shift.note-optional": "Note (optional)",
  "shift.note-explain": "Explain cash difference",
  "shift.note-explain-required": "Required - Enter reason for cash difference",
  "shift.status": "Status",
  "shift.status-open": "Open",
  "shift.status-closed": "Closed",
  "shift.confirm-open": "Confirm Open Shift",
  "shift.confirm-close": "Confirm Close Shift",
  "shift.require-open": "Please open a shift before making sales",
  "shift.print": "Print Shift Report",
  "shift.print-title": "SHIFT CLOSING REPORT",
  "shift.revenue-in-shift": "Revenue in Shift",
  "shift.cash-reconciliation": "Cash Reconciliation",
  "shift.cash-revenue-add": "+ Cash Revenue",
  "shift.expected-cash-equals": "= Expected Cash",
  "shift.no-data": "No shift data available",
  "shift.detail": "Details",
  "shift.page-prev": "← Previous",
  "shift.page-next": "Next →",
  "shift.page-of": "Page {current} / {total}",
  "shift.open-success": "Shift opened successfully",
  "shift.close-success": "Shift closed successfully",
  "shift.open-error": "Error opening shift",
  "shift.close-error": "Error closing shift",
  "shift.close-warn-difference":
    "There is a cash difference. Please enter an explanation before closing the shift.",
  "shift.store-name": "Store",
  "shift.copyright": "Copyright vmass.vn",
  "shift.cancel": "Cancel",

  /* 05.Dashboards */
  "dashboards.pending-orders": "Receive Orders",
  "dashboards.completed-orders": "Completed Orders",
  "dashboards.refund-requests": "Refund Orders",
  "dashboards.sales": "Nhận",
  "dashboards.sales-chart": "Sales Chart",
  "dashboards.orders": "delivered",
  "dashboards.refunds": "Out of stock",
  "dashboards.calendar": "Calendar",
  "dashboards.best-sellers": "List of sold products",
  "dashboards.this-week": "Week",
  "dashboards.this-month": "Month",
  "dashboards.this-all-sales": "All revenue",
  "dashboards.recent-orders": "Recent Orders",
  "dashboards.stock-status": "Stock status",
  "dashboards.logs": "Logs",
  "dashboards.message": "Message",
  "dashboards.area": "Area",
  "dashboards.status-order": "Summary of order status",
  "dashboards.pending-order": "List of products not yet received",
  "dashboards.order-undelivery": "List of undelivered products",
  "dashboards.order-pending-payment":
    "List of tables not yet collected payment",
  "dashboards.total-order": "Total number of products ordered",
  "dashboards.product-not-receive": "product not yet receive",
  "dashboards.product-not-delivery": "product not yet delivery",
  "dashboards.table-notyet-pay": "tables not yet collected payment",
  "dashboards.product-received-full": "All products have been received",
  "dashboards.total-product-received": "Total products received",
  "dashboards.product-delivery-full": "All products have been delivered",
  "dashboards.total-table-has-customer":
    "Total table with guests during the day",
  "dashboards.table-payment-full": "The tables have been fully paid",
  "dashboards.list-empty": "List empty",
  "dashboards.total": "Total",
  "dashboards.counter": "Counter",
  "dashboards.table": "Table",
  "dashboards.ice": "Ice",
  "dashboards.sugar": "Sweetness",
  "dashboards.all": "ALL",
  "dashboards.completed": "COMPLETED",
  "dashboards.destroy": "DESTROY",
  "dashboards-empty-product": "There are no products in the list yet",

  /** Analytics */
  "analytics.dashboards": "Tổng quát",
  "analytics.user-staff": "Staff",
  "analytics.customer": "Customer",
  "analytics.company-provider": "Supplier",
  "analytics.treasury": "Treasury",
  "analytics.income": "Income",
  "analytics.outcome": "Outcome",
  "analytics.cash-flow": "Cash Flow",
  "analytics.role": "Create permission",
  "analytics.user-role": "Create account",
  "analytics.form-dynamic": "Customize Form",
  "analytics.companies": "Link stores together",
  "analytics.dashboards.outcome": "COST STATISTICS",
  "analytics.dashboards.income": "REVENUE STATISTICS",
  "analytics.dashboards.stock-log": "STATISTICS OF IMPORTED STOCKS",
  "analytics.dashboards.order-payment": "STATISTICS LIST OF SOLD PRODUCTS",
  "analytics.dashboards.debt": "DEBT STATISTICS",
  "analytics.dashboards.make-product": "STATISTICS OF STOCKS USED",
  "analytics.dashboards.order-table": "STATISTICS OF TABLE",
  "analytics.today": "Today",
  "analytics.yesterday": "Yesterday",
  "analytics.7-days-ago": "7 days ago",
  "analytics.this-week": "This week",
  "analytics.last-week": "Last week",
  "analytics.30-days-ago": "30-days ago",
  "analytics.this-month": "This month",
  "analytics.last-month": "Last month",
  "analytics.all": "All",
  "analytics.compare": "Compare",
  // 'analytics.update': 'Update',
  "analytics.revenue": "Revenue",
  "analytics.costs": "Fixed Costs",
  "analytics.profit": "Profit",
  "analytics.invoice-quantity": "Invoice quantity",
  "analytics.number-products-sold": "Number of products sold",
  "analytics.average-selling-price": "Average selling price",
  "analytics.total-product": "Total product",
  "analytics.product": "Product",
  "analytics.amount-of-inventory": "Amount of inventory",
  "analytics.items": "Items",
  "analytics.inventory-value": "Inventory value",

  /* product */
  "product.title": "Add Product",
  "product.title.update": "Update Product",
  "product.add-new": "Add 1 product",
  "product.tab.import-excel": "Import from Excel",
  "product.tab.import-image": "Import from Image",
  "product.tooltip.category":
    "This is the parent category for products. This category is created before creating products. (Note: If the parent category is deleted, all products belonging to it will also be deleted, please be careful!).",
  "product.tooltip.categories":
    "This is the parent category for products. This category is created before creating products. (Note: If the parent category is deleted, all products belonging to it will also be deleted, please be careful!).",
  "product.tooltip.price":
    'This is the selling price if "Promotion Price" is not checked.',
  "product.tooltip.topping":
    "Add extra items or add-ons and their corresponding additional costs.",
  "product.tooltip.ice":
    "Tick the 5 boxes to allow customers to choose the amount of ice.",
  "product.tooltip.sugar":
    "Tick the 5 boxes to allow customers to choose the sweetness level.",
  "product.notify.create-stock-success": "Created new stock successfully",
  "product.notify.create-stock-error": "Error creating new stock",
  "product.notify.no-detail": "Could not load product details.",
  "product.import.result": "Import Result",
  "product.import.choose-file": "Choose Excel file to import products",
  "product.import.support-format": "Supports .xlsx and .xls formats",
  "product.import.download-template": "Download Template",
  "product.validation.barcode-min":
    "Requires at least 10 characters ({count}/10)",
  "product.placeholder.select-category": "Select or create category...",
  "product.image.change": "Change Image",
  "product.image.select": "Select Image",
  "product.confirm.delete":
    "Are you sure you want to delete selected products?",
  "category.confirm.delete": "Are you sure you want to delete this category?",
  "category.confirm.delete-all":
    "Are you sure you want to delete selected categories?",
  "product.confirm.delete-category":
    "Are you sure you want to delete this category?",
  "product.confirm.apply-master":
    "Are you sure you want to apply these values to ALL variants? This will override individually entered values.",
  "product.error.invalid-data": "Invalid data",
  "product.error.name-required": "Product name is required",
  "product.error.category-required": "Product category is required",
  "product.error.price-required": "Selling price is required",
  "product.error.variant-required":
    "Please enter Price and Quantity for all variants",
  "product.error.select-size":
    "Please select at least one Size before creating.",

  /* Backend API validation messages */
  "product.api.error.price-invalid": "Product price is invalid (must be >= 0)",
  "product.api.error.promo-price-invalid": "Promotional price is invalid (must be >= 0)",
  "product.api.error.barcode-invalid": "Barcode is invalid (8-13 digits required)",
  "product.api.error.sku-duplicate": "This SKU already exists in the system",
  "product.api.error.category-not-found": "Product category does not exist",
  "product.api.error.duplicate": "This product already exists in the system",
  "product.api.error.limit-reached": "Product limit reached. Please upgrade your plan to create more!",
  "product.api.error.not-found": "Product not found or access denied",
  "product.api.error.variant-price-invalid": "Variant price is invalid (must be >= 0)",
  "product.api.error.variant-promo-invalid": "Variant promotional price is invalid (must be >= 0)",
  "product.api.error.import-missing-fields": "Product is missing Name or Category",

  /* Product OCR */
  "product.ocr.title": "Extract products from image",
  "product.ocr.description": "Upload menu/price list images, AI will auto-detect products.",
  "product.ocr.prompt-placeholder": "Leave empty = auto-detect by business type",
  "product.ocr.choose-images": "Choose images",
  "product.ocr.more-images": "more images",
  "product.ocr.show-prompt": "Customize AI prompt",
  "product.ocr.hide-prompt": "Hide custom prompt",
  "product.ocr.extract-btn": "Extract data",
  "product.ocr.extracting": "Processing...",
  "product.ocr.save-btn": "Save",
  "product.ocr.saving": "Saving...",
  "product.ocr.save-success": "Product import successful!",
  "product.ocr.items": "products",
  "product.ocr.col-name": "Product name",
  "product.ocr.col-category": "Category",
  "product.ocr.col-size": "Size",
  "product.ocr.col-price": "Price",
  "product.ocr.col-price-sale": "Sale price",
  "product.ocr.col-barcode": "Barcode",
  "product.ocr.step-upload": "Upload",
  "product.ocr.step-mapping": "Map columns",
  "product.ocr.step-preview": "Review & Save",
  "product.ocr.mapping-title": "Map data columns",
  "product.ocr.mapping-desc": "AI detected the columns on the left. Map them to the corresponding product fields on the right.",
  "product.ocr.ai-column": "AI Column",
  "product.ocr.db-field": "Data field",
  "product.ocr.status": "Status",
  "product.ocr.skip-column": "-- Skip --",
  "product.ocr.mapped": "Mapped",
  "product.ocr.rows-found": "rows found",
  "product.ocr.cols-mapped": "columns mapped",
  "product.ocr.back": "Back",
  "product.ocr.next": "Continue",
  "product.ocr.reset": "Reset",
  "product.ocr.preview-title": "Review & Save",
  "product.ocr.stat-products": "Products",
  "product.ocr.stat-categories": "Categories",
  "product.ocr.stat-with-price": "With price",
  "product.ocr.import-done": "Done!",
  "product.ocr.created": "Created",
  "product.ocr.updated": "Updated",
  "product.ocr.skipped": "Skipped",
  "product.ocr.raw-result": "Raw AI result:",
  "product.ocr.error-no-image": "Please select at least one image.",
  "product.ocr.error-no-data": "Could not extract data from image. Please try again.",
  "product.ocr.error-extract": "An error occurred while analyzing the image.",
  "product.ocr.error-empty": "No data to save.",
  "product.ocr.error-save": "An error occurred, please try again.",
  "product.ocr.error-name-required": "You must map the 'Product name' column to continue.",

  "pages.add-new": "ADD NEW",
  "pages.add-new-user-staff": "ADD NEW STAFF",
  "pages.add-new-log": "ADD ANOTHER",
  "pages.order-new": "ORDER",
  "pages.image": "Image product",
  "pages.add-new-modal-title": "Add product",
  "pages.order-new-modal-title": "Order new product",
  "pages.update-modal-title": "Update product",
  "pages.display-options": "Show options",
  "pages.orderby": "Sort: ",
  "pages.product-name": "Product name",
  "pages.product-barcode": "Barcode",
  "pages.product-sku": "Mã sản phẩm",
  "pages.category": "Type product",
  "pages.description": "Description",
  "pages.status": "Status",
  "pages.cancel": "Cancel",
  "pages.submit": "Submit",
  "pages.delete": "Delete",
  "pages.delete-forever": "Delete Forever",
  "pages.another-action": "Another action",
  "pages.update": "Update",
  "pages.price": "Price",
  "pages.select-category": "Select 1 type product",
  "pages.select-product": "Select 1 product",
  "pages.order-number": "Weight",
  "pages.no-selected": "None action",
  "pages.order-more": "Add product",
  "pages.total-order-price": "Total price",
  "pages.current-order-price": "Current order price",
  "pages.error-title": "Ooop... some error!",
  "pages.error-code": "Error",
  "pages.go-back-home": "Go back home",
  "pages.softhide": "Softhide product",
  "pages.un-softhide": "Unsofthide product",
  "pages.bestter": "Recomend using",
  "pages.un-bestter": "Off - Recomend using",
  "pages.print-tem": "In tem",
  "pages.expand": "Xem biến thể",
  "pages.collapse": "Thu gọn",

  "product.title": "Information product",
  "product.price.original": "Price",
  "product.price.sale": "Promotional price",
  "product.price.wholesale": "Wholesale Price",
  "product.price.cost": "Giá vốn",
  "product.quantity": "Số lượng",
  "product.inventory": "Tồn kho",
  "product.ice": "Amount of ice",
  "product.sugar": "Sweetness",
  "product.size": "Size",
  "product.topping": "Topping",
  "product.color": "Color",
  "product.material": "Material",
  "product.add.name": "Name",
  "product.add.value": "Extra money",
  "product.add_price": "Extra price",
  "product.update_cost": "Update cost",
  "product.edit_cost": "Edit cost",
  "product.search": "Search name of product",
  "product.variants": "Biến thể",
  "product.variant-name": "Tên biến thể",
  "product.sku": "SKU",
  "product.price": "Giá bán",
  "product.stock": "Tồn kho",
  "product.promo-time": "Thời gian khuyến mãi",

  /* 07.Category */
  "category.add-new-modal-title": "Add type of product",
  "category.update-title": "Update category of product",
  "category.title": "Name product",
  "category.thumb-list": "Type of product",
  "category.nav-tab": "CATEGORY",
  "category.add-new-category": "ADD CATEGORY",
  "category.btn-add": "Add category",

  /* 08.Todo */
  "todo.add-new": "Add new",
  "todo.thumb-list": "Event",
  "todo.add-new-modal-title": "Add new event",
  "todo.update-modal-title": "Update event",
  "todo.title": "Title of event",
  "todo.description": "Description",
  "todo.date": "Date",
  "todo.time": "Time",
  "todo.update-done": "Done",
  "todo.update-pending": "Pending",
  "todo.delete": "Delete",
  "todo.no-selected": "None action",
  "todo.update": "Update",
  "todo.date-time": "Time",
  "todo.orderby": "Sort: ",
  "todo.btn-add": "Add event",

  /*table setting */
  "table-setting.row": "Row",
  "table-setting.col": "Column",
  "table-setting.floor": "Area",
  "table-setting.btn-generate": "Tạo bàn",
  "table-setting.map": "Map",
  "table-setting.btn-save": "Save",
  "table-setting.title": "Setting table and chair model",

  /* stock */
  "stock.thumb-list": "Stocks",
  "stock.add-new-modal-title": "Add stock",
  "stock.name": "Name stock",
  "stock.unit": "Unit",
  "stock.unit-price": "Purchase price",
  "stock.unit-price-update": "Purchase price",
  "stock.unit-price-new": "New Purchase price",
  "stock.price": "Into money",
  "stock.count": "Quantity",
  "stock.count-new": "Quantity",
  "stock.delete": "Delete Stock",
  "stock.reset": "Reset to 0",
  "stock.count-update": "Update stock",
  "stock.count-edit": "Edit stock",
  "stock.count-current": "Remaining",
  "stock.count-total": "Total import",
  "stock.update-title": "Update more stock",
  "stock.search": "Search name of stock",
  "stock.btn-add": "Add stock",
  "stock.dashboard.subtitle": "Track inventory in real time",
  "stock.dashboard.category": "Category",
  "stock.dashboard.warehouse": "Warehouse",
  "stock.dashboard.min-stock-threshold": "Minimum Stock",
  "stock.dashboard.status.in-stock": "In Stock",
  "stock.dashboard.status.low-stock": "Low Stock",
  "stock.dashboard.status.out-of-stock": "Out of Stock",
  "stock.dashboard.status.no-cost": "No Cost Price",
  "stock.dashboard.status.inactive": "Discontinued",

  /* warehouse */
  "warehouse.add-new-modal-title": "Add new",
  "warehouse.phone": "Phone",
  "warehouse.address": "Address",
  "warehouse.code": "Code stock",
  "warehouse.unit": "Unit",
  "warehouse.description": "Description",
  "warehouse.btn-add": "Add",

  "warehouse.import-search": "Search name of Receipt",
  "warehouse.import": "Receipt",
  "warehouse.import-stock": "Imported item",
  "warehouse.import-title": "Update receipt",
  "warehouse.import-name": "Name of person entering the warehouse",
  "warehouse.import-quantity": "Quantity",
  "warehouse.import-price": "Price import",
  "warehouse.btn-add-import": "Create",

  "warehouse.export-search": "Search name of Delivery bill",
  "warehouse.export": "Delivery bill",
  "warehouse.export-stock": "Export item",
  "warehouse.export-title": "Update Delivery bill",
  "warehouse.export-name": "Name of the person releasing the warehouse",
  "warehouse.export-quantity": "Quantity",
  "warehouse.export-price": "Price export",
  "warehouse.btn-add-export": "Create",

  "warehouse.transfer-search": "Search name of Warehouse transfer note",
  "warehouse.transfer": "Warehouse transfer note",
  "warehouse.transfer-stock": "Transfer item",
  "warehouse.transfer-title": "Update Warehouse transfer note",
  "warehouse.transfer-name": "Name of person transferring the warehouse",
  "warehouse.transfer-quantity": "Quantity",
  "warehouse.transfer-price": "Price transfer",
  "warehouse.transfer-name-carrier": "Name of carrier",
  "warehouse.transfer-phone-carrier": "Phone of carrier",
  "warehouse.transfer-receiving-warehouse": "Move to warehouse",
  "warehouse.transportation": "Transportation",
  "warehouse.cost-transfer": "Transport fee",
  "warehouse.btn-add-transfer": "Create",

  /* make product */
  "make-product.thumb-list": "Quantitative",
  "make-product.add-new-modal-title": "Add new Quantitative",
  "make-product.name": "Name",
  "make-product.unit": "Unit",
  "make-product.count": "Quantity",
  "make-product.make-more": "Add",
  "make-product.product-name": "Name product",
  "make-product.stock-name": "Name stock",
  "make-product.select-stock": "Select 1 stock",
  "make-product.add-modal-title": "Add new",
  "make-product.update-modal-title": "Edit",
  "make-product.number-product-used": "Number of stocks used",
  "make-product.price": "Price",
  "make-product.cost": "Price cost",
  "make-product.percent-cost": "Percentage of cost/selling price",
  "make-product.btn-add": "Create",

  /* FAQ */
  "faq.title": "Hướng dẫn",
  "faq.text-title": "Câu hỏi",
  "faq.text-content": "Trả lời",
  "faq.modal-title": "Câu hỏi và Trả lời",

  /** Ref */
  "ref.name": "Name of the owner",
  "ref.companyName": "Store name",
  "ref.email": "Email",
  "ref.phone": "Phone",
  "ref.address": "Address",
  "ref.content": "Message",
  "ref.title": "Referred person information",
  "ref.sub-title":
    "Your referral commission is currently 30% of the referral's contract amount signed with VMASS. Your information will be automatically sent to VMASS based on the personal information you have provided.",
  "ref.btn-submit": "Send",

  /** Chat */
  "chat.messages": "Message",
  "chat.messages-inbox": "Inbox",
  "chat.messages-new": "Phonebook",
  "chat.start-conversation": "Start a conversation!",

  /** Discount */
  "discount.add-new-modal-title": "Add discount",
  "discount.note": "Note",
  "discount.type": "Type discount",
  "discount.value": "Value discount",
  "discount.user": "Staff",
  "discount.products": "Product",
  "discount.select-all-products": "All product",
  "discount.select-one-type": "Select type value",
  "discount.select-one-product": "Select 1 product",
  "discount.select-one-type-product": "Select 1 type product",
  "discount.to-bill": "Add another",
  "discount.add-feetax": "Add Discount, Tax, Fee",
  "discount.discount": "Discount",
  "discount.tax": "Tax",
  "discount.fee-other": "Fee-other",
  "order.adjustment.add-products-first":
    "Please add products before entering a code",
  "order.adjustment.invalid-code": "Invalid promotion code",
  "order.adjustment.apply": "Apply",
  "order.adjustment.note-optional": "Note (optional)",
  "order.adjustment.promo-code": "Promotion code",
  "order.adjustment.promo-placeholder": "Enter promotion code",
  "order.adjustment.coupon-help":
    "Enter a code and select Apply to receive the discount.",
  "order.adjustment.remove-code": "Remove promotion code",
  "order.adjustment.discount-value": "Discount value",
  "order.adjustment.estimated-discount": "Estimated discount",
  "order.adjustment.discount-note-placeholder":
    "Example: Loyal customer",
  "order.adjustment.subtotal": "Subtotal",
  "order.adjustment.total-after-discount": "Total after discount",
  "order.adjustment.tax-title": "Add tax",
  "order.adjustment.tax-rate": "Tax rate",
  "order.adjustment.other": "Other",
  "order.adjustment.tax-value": "Tax value",
  "order.adjustment.estimated-tax": "Estimated tax",
  "order.adjustment.calculation": "Calculation",
  "order.adjustment.tax-added": "Add to order",
  "order.adjustment.tax-added-help":
    "Tax will be added to the payment total.",
  "order.adjustment.tax-included": "Included in price",
  "order.adjustment.tax-included-help":
    "Tax is already included in the product or service price.",
  "order.adjustment.tax-note-placeholder": "Example: Retail VAT",
  "order.adjustment.total-payment": "Payment total",
  "order.adjustment.fee-title": "Add surcharge",
  "order.adjustment.fee-name": "Surcharge name",
  "order.adjustment.shipping-fee": "Shipping fee",
  "order.adjustment.service-fee": "Service fee",
  "order.adjustment.packing-fee": "Packing fee",
  "order.adjustment.other-fee": "Other fee",
  "order.adjustment.fee-value": "Surcharge value",
  "order.adjustment.estimated-fee": "Estimated surcharge",
  "order.adjustment.apply-on": "Apply to",
  "order.adjustment.calculation-base": "Surcharge calculation base",
  "order.adjustment.fixed-fee-base-help":
    "A fixed VND surcharge does not depend on a calculation base.",
  "order.adjustment.after-discount": "Total after discount",
  "order.adjustment.fee-note-placeholder": "Example: Local delivery",

  /** Customer */
  "customer.add-new-modal-title": "Add new",
  "customer.title": "Information",
  "customer.name": "Name",
  "customer.phone": "Phone",
  "customer.email": "Email",
  "customer.address": "Address",
  "customer.point": "Point",
  "customer.armorial": "Armorial",
  "customer.used-item": "Number of uses",
  "customer.tags": "Tags",
  "customer.info": "INFO",
  "customer.used": "USED PRODUCTS",
  "customer.setting": "SETTING",
  "customer.search": "Find by phone",
  "customer.btn-add": "Create",
  "customer.amount-spent": "Amount Spent",
  "customer.debt": "Debt",
  "customer.modern.subtitle": "Manage and care for customers",
  "customer.modern.total-customers": "Total customers",
  "customer.modern.total-spent": "Total spent",
  "customer.modern.vip": "VIP customers",
  "customer.modern.new": "New customers",
  "customer.modern.last-order": "Last purchase",
  "customer.modern.sleeping": "Inactive",

  /** Income, Outcome, Treasury */
  action: "Action",
  name: "Name",
  phone: "Phone",
  email: "Email",
  address: "Address",
  price: "Price",
  note: "Description",
  time: "Statistical",
  "time-created": "Time created",
  "user.created": "User created",
  "select-one-time": "Choose one type",
  "select-one-time-discount": "Choose 1 type discount",
  "select-one-time-gift": "Choose 1 type gift",

  "income.title": "Income",
  "income.sub_title": "Title",
  "income.add-new-modal-title": "Add new Income",
  "income.name": "Name of submitter",
  "income.search": "Search by name income",
  "income.btn-add": "Create",

  "outcome.title": "Outcome",
  "outcome.sub_title": "Title",
  "outcome.add-new-modal-title": "Add new Outcome",
  "outcome.name": "Recipient's name",
  "outcome.search": "Search by name outcome",
  "outcome.btn-add": "Create",

  "treasury.name": "Name treasury",
  "treasury.title": "Treasury",
  "treasury.add-new-modal-title": "Add new treasury",
  "treasury.timeCreated": "Time created",
  "treasury.search": "Search by name treasury",
  "treasury.btn-add": "Create",

  /** Break Event */
  "breakeven.title": "Breakeven",

  /** Company Provider */
  "company-provider.info": "Information",
  "company-provider.title": "Supplier",
  "company-provider.title-log": "Add transaction",
  "company-provider.title-log-add": "Add transaction",
  "company-provider.title-log-add-more": "Additional payment",
  "company-provider.add-new-modal-title": "Add new Supplier",
  "company-provider.name": "Name",
  "company-provider.item_name": "Items",
  "company-provider.total_price_income": "Total amount entered",
  "company-provider.total_price_outcome": "Paid",
  "company-provider.total_price_pending": "Remaining",
  "company-provider.item_product": "Supplied items",
  "company-provider.price": "Price",
  // 'company-provider.name': 'Name of supplier',
  "company-provider.search": "Search by name supplier",
  "company-provider.btn-add": "Create",
  "company-provider.transaction": "Transaction",
  "company-provider.sku": "SKU",
  "company-provider.price_new": "Price",
  "company-provider.quantity": "Quantity",
  "company-provider.debt": "Debt",
  "company-provider.total": "Total",
  "company-provider.time": "Time",
  "company-provider.action": "Action",

  /** User Staff */
  "user-staff.title": "Information Staff",
  "user-staff.add-new-modal-title": "Add new",
  "user-staff.add-new-logs-modal-title": "Add another",
  // 'user-staff.title': 'Staff',
  "user-staff.permission_name": "Job position",
  "user-staff.date_join": "Date join",
  "user-staff.date_get_salary": "Salary payment date",
  "user-staff.hour_working_on_day": "Number of working hours per day",
  "user-staff.status_working": "Work status",
  "user-staff.salary_by": "Calculate salary accordingly",
  "user-staff.salary_value": "Wage",
  "user-staff.working_hours": "Work time",
  "user-staff.current_commission": "Commission",
  "user-staff.current_bonus": "Bonus",
  "user-staff.current_overtime": "Overtime money",
  "user-staff.current_advence": "Advance money",
  "user-staff.current_fined": "Fine",
  "user-staff.current_dayoff": "Leave money",
  "user-staff.current_day_working": "Workday this month",
  "user-staff.current_salary": "Salary this month",
  "user-staff.total_salary": "Total salary",
  "user-staff.total_day_working": "Total workday",
  "user-staff.working_hours_from": "* Work from",
  "user-staff.working_hours_to": "* Work to",
  "user-staff.logs_users_staff": "Name",
  "user-staff.logs_type": "Type",
  "user-staff.logs_value_salary": "Amount of money",
  "user-staff.logs_value_hour": "Hour",
  "user-staff.overtime_coefficient": "Overtime salary coefficient",
  "user-staff.select-all-users": "Choose staff",
  "user-staff.select-one": "Choose 1 type",
  "user-staff.name": "Name",
  "user-staff.phone": "Phone",
  "user-staff.address": "Address",
  "user-staff.email": "Email",
  "user-staff.search": "Search by name staff",
  "user-staff.btn-add": "Create",
  "user-staff.add-log-title": "Add staff payroll information",
  "user-staff.kpi.total": "Total staff",
  "user-staff.kpi.active": "Working",
  "user-staff.kpi.inactive": "Inactive",
  "user-staff.kpi.manager": "Managers",
  "user-staff.kpi.revenue-today": "Revenue today",
  "user-staff.kpi.current": "Current data",
  "user-staff.kpi.current-page": "Current page",
  "user-staff.kpi.today": "Today",
  "user-staff.search-placeholder": "Search staff...",
  "user-staff.filter.position-all": "Position: All",
  "user-staff.filter.status-all": "Status: All",
  "user-staff.filter.shift-all": "Shift: All",
  "user-staff.filter.clear": "Filter",
  "user-staff.table.employee": "Employee",
  "user-staff.table.position": "Position",
  "user-staff.table.shift": "Shift",
  "user-staff.table.phone": "Phone",
  "user-staff.table.revenue-today": "Revenue today",
  "user-staff.table.bills": "Bills",
  "user-staff.table.status": "Status",
  "user-staff.table.action": "Action",
  "user-staff.action.call": "Call",
  "user-staff.action.message": "Message",
  "user-staff.action.edit": "Edit",
  "user-staff.action.more": "More",
  "user-staff.action.delete": "Delete",
  "user-staff.empty": "No staff data",
  "user-staff.detail.empty": "Select a staff member to view details",
  "user-staff.detail.tab.info": "Info",
  "user-staff.detail.tab.schedule": "Schedule",
  "user-staff.detail.tab.performance": "Performance",
  "user-staff.detail.tab.salary": "Payroll",
  "user-staff.detail.tab.permission": "Permissions",
  "user-staff.detail.basic": "Basic information",
  "user-staff.detail.staff-code": "Staff code",
  "user-staff.detail.birthday": "Birthday",
  "user-staff.detail.schedule": "Schedule",
  "user-staff.detail.performance": "Today performance",
  "user-staff.detail.salary": "Payroll",
  "user-staff.detail.permission": "Permissions",
  "user-staff.detail.dynamic-fields": "Custom fields",
  "user-staff.today.revenue": "Revenue",
  "user-staff.today.bills": "Bills",
  "user-staff.today.products": "Products served",
  "user-staff.today.revenue-per-hour": "Revenue/hour",
  "user-staff.total.revenue": "Total revenue",

  /** Role */
  "role.name": "Name Decentralization",
  "role.title": "Decentralization",
  "role.add-new-modal-title": "Add new",
  "role.btn-add": "Create",

  /** User Role */
  "user-role.title": "Edit Decentralization",
  "user-role.name": "Name of staff",
  "user-role.add-new-modal-title": "Add new",
  "user-role.select-one": "Choose a permission",
  "user-role.place-holder-password": "Leave blank if not changed",
  "user-role.btn-add": "Create",

  /** Form Dynamic */
  "form-dynamic.title": "Customize Forn",
  "form-dynamic.add-new-modal-title": "Add new",
  "form-dynamic.label": "Title",
  "form-dynamic.alias": "Type form",
  "form-dynamic.select-one-alias": "Choose 1 form",
  "form-dynamic.type": "Datatypes",
  "form-dynamic.select-one-type": "Choose 1 type",
  "form-dynamic.btn-add": "Create",

  "url.placeholder": "http:// or https://",

  /** Compananies */
  "companies.find-company-uuid": "Find code of store",
  "companies.title": "Link store together",
  "companies.add-new-modal-title": "Add new",
  "companies.name": "Name",
  "companies.type": "Type",
  "companies.unset": "None-link",
  "companies.btn-add": "Create",

  /** Promotion */
  "promotion.thumb-list": "Promotion",
  "promotion-add": "Add new",
  "promotion-update": "Update",
  "promotion-name": "Name of promotion",
  "promotion-code": "Code",
  "promotion-quantity": "Applicable quantity",
  "promotion-description": "Description",
  "promotion-max-per-customer": "Max Usage Per Customer",
  "promotion-date_start": "Time start",
  "promotion-date_end": "Time end",
  "promotion-isAutoUse": "Auto enable",

  /** Calendar */
  "calendar.add-event": "Add event",

  /** Booking */
  "menu.booking": "Booking",
  "booking.title": "Booking Management",
  "booking.add-new": "Add Booking",
  "booking.today": "Today",
  "booking.week": "This Week",
  "booking.month": "This Month",
  "booking.calendar": "Calendar",
  "booking.settings": "Settings",
  "booking.customer-name": "Customer Name",
  "booking.customer-phone": "Phone",
  "booking.customer-email": "Email",
  "booking.date": "Booking Date",
  "booking.time": "Arrival Time",
  "booking.party-size": "Party Size",
  "booking.table": "Table",
  "booking.special-requests": "Special Requests",
  "booking.notes": "Notes",
  "booking.status": "Status",
  "booking.status.pending": "Pending",
  "booking.status.confirmed": "Confirmed",
  "booking.status.cancelled": "Cancelled",
  "booking.status.completed": "Completed",
  "booking.status.no_show": "No Show",
  "booking.deposit": "Deposit",
  "booking.deposit-required": "Deposit Required",
  "booking.deposit-amount": "Deposit Amount",
  "booking.confirm": "Confirm",
  "booking.cancel": "Cancel",
  "booking.complete": "Complete",
  "booking.source": "Source",
  "booking.no-bookings": "No bookings yet",

  /** Wizard */
  "wizard.title": "Setup wizard",
  "wizard.sub-title":
    "The setup wizard will guide you through some steps to get your store up and running quickly.",
  "wizard.next": "Next",
  "wizard.prev": "Previous",
  "wizard.finish": "Finish",
  "wizard.skip": "Skip",
  "wizard.step-name-1": "Step 1",
  "wizard.step-desc-1": "Basic Information",
  "wizard.step-name-2": "Step 2",
  "wizard.step-desc-2": "Add Product",
  "wizard.step-name-3": "Step 3",
  "wizard.step-desc-3": "Payment Information",
  "wizard.content-thanks": "Thank you!",
  "wizard.registered":
    "Thông tin của bạn đã được ghi nhận, chúc bạn trải nghiệm phần mềm vui vẻ!",

  /* Facebook Settings */
  "facebook.settings-title": "Facebook Fanpage",
  "facebook.config-guide": "Webhook Configuration (For Developers):",
  "facebook.callback-url": "Callback URL:",
  "facebook.verify-token": "Verify Token:",
  "facebook.fields": "Fields:",
  "facebook.guide": "Guide",
  "facebook.guide-step-1": "Click 'Connect New Fanpage'",
  "facebook.guide-step-2": "Login to Facebook (if needed)",
  "facebook.guide-step-3": "Select Fanpage you want to connect",
  "facebook.guide-step-4": "Grant permissions to the App",
  "facebook.guide-step-5": "Done!",
  "facebook.connect-new": "Connect New Fanpage",
  "facebook.description":
    "Connect Fanpage to receive and reply to customer messages from Facebook Messenger.",
  "facebook.how-to-connect": "How to connect Fanpage:",
  "facebook.upgrade-warning":
    "You need to upgrade to Basic package to connect Fanpage.",
  "facebook.upgrade-now": "Upgrade Now",
  "facebook.connect-new-locked": "Connect New Fanpage (Basic Package Required)",
  "facebook.loading": "Loading...",
  "facebook.no-pages": "No Fanpages connected yet.",
  "facebook.page-name": "Page Name",
  "facebook.page-id": "Page ID",
  "facebook.connected-date": "Connected Date",
  "facebook.action": "Action",
  "facebook.disconnect": "Disconnect",
  "facebook.go-to-messenger": "Go to Chat",
  "facebook.manual.btn": "Manual Token",
  "facebook.manual.title": "Connect with Page Access Token",
  "facebook.manual.desc":
    "Paste your Page Access Token below. You can get it from Facebook Developer Tools or Business Suite.",
  "facebook.manual.guide": "How to get Token",
  "facebook.manual.guide-title": "How to get Page Access Token:",
  "facebook.manual.guide-step-1":
    "Go to Facebook Graph API Explorer (developers.facebook.com/tools/explorer)",
  "facebook.manual.guide-step-2":
    "Select your App and the Fanpage to connect",
  "facebook.manual.guide-step-3":
    "Grant permissions: pages_show_list, pages_messaging, pages_read_engagement",
  "facebook.manual.guide-step-4":
    "Click 'Generate Access Token' and copy the token",
  "facebook.manual.placeholder": "Paste Page Access Token here...",
  "facebook.manual.connect-btn": "Connect",
  "facebook.manual.connecting": "Connecting...",
  "facebook.manual.error-empty": "Please enter Page Access Token",
  "facebook.manual.error-failed": "Connection failed. Please check your token.",
  "facebook.manual.error-no-selection": "Please select at least 1 Fanpage to connect",
  "facebook.manual.check-btn": "Check",
  "facebook.manual.checking": "Checking...",
  "facebook.manual.select-pages": "Select Fanpages to connect:",
  "facebook.manual.select-all": "Select all",
  "facebook.manual.deselect-all": "Deselect all",
  "facebook.manual.pages-selected": "pages selected",

  /* Settings - General */
  "settings.general": "General Settings",
  "settings.general.ui-title": "UI Appearance",
  "settings.general.font-size-label": "Font Size",
  "settings.general.font-size-small": "Small",
  "settings.general.font-size-large": "Large",
  "settings.general.preview-text":
    "Preview: This is a sample text with font size {size}px",
  "settings.general.report-title": "Report Configuration",
  "settings.general.daily-report-time": "Daily Report Time",
  "settings.general.select-time-placeholder": "Select time...",
  "settings.general.report-note":
    "(System will send revenue report email at selected times)",

  /* Settings - Invoice */
  "settings.invoice.title": "Invoice Settings",
  "settings.invoice.section-1": "1. Customer Invoice Settings",
  "settings.invoice.print-at-counter": "Print invoice when ordering at counter",
  "settings.invoice.section-2": "2. Kitchen Ticket Settings",
  "settings.invoice.print-kitchen":
    'Print kitchen ticket when cashier clicks "Send to Kitchen"',
  "settings.invoice.section-3": "3. Order Process Workflow",
  "settings.invoice.process-1": "Order and Complete immediately",
  "settings.invoice.process-2": "Order > Kitchen > Complete",
  "settings.invoice.process-3": "Order > Payment > Complete",
  "settings.invoice.process-4": "Order > Cashier > Bar/Kitchen > Complete",
  "settings.invoice.process-4-title": "4. Order process flow via QrCode",
  "settings.invoice.process-4-flow":
    "Order > To Kitchen > To Payment > Completed",

  /* Settings - Email */
  "settings.email.title": "Email Configuration",
  "settings.email.guide-title": "How to create Gmail App Password:",
  "settings.email.guide-step-1": "Go to Google Account",
  "settings.email.guide-step-2": "Security → Turn on 2-Step Verification",
  "settings.email.guide-step-3": 'Search for "App Password" or click here',
  "settings.email.guide-step-4":
    'Select App: Mail, Device: Other, enter "VMASS"',
  "settings.email.guide-step-5": "Copy 16-character password",
  "settings.email.smtp-custom-title": "Custom SMTP:",
  "settings.email.description":
    "Configure custom email to send notifications to customers from your shop's email address instead of VMASS default.",
  "settings.email.mode-default": "Use VMASS default email",
  "settings.email.mode-custom": "Use custom email",
  "settings.email.default-note":
    "System will send email from vmass.vn@gmail.com. Disable to configure custom email.",
  "settings.email.type-label": "Email Type",
  "settings.email.type-gmail": "Gmail (App Password)",
  "settings.email.type-smtp": "Custom SMTP (Zoho, Office 365...)",
  "settings.email.address-label": "Email Address",
  "settings.email.password-label": "Email Password",
  "settings.email.app-password-label": "App Password",
  "settings.email.create-app-password": "Create App Password here",
  "settings.email.smtp-server-config": "SMTP Server Configuration",
  "settings.email.smtp-host": "SMTP Host",
  "settings.email.smtp-port": "Port",
  "settings.email.smtp-secure": "Security",
  "settings.email.quick-config": "Quick Config:",
  "settings.email.test-button": "Send Test Email",
  "settings.email.save-button": "Save Config",
  "settings.email.saving": "Saving...",
  "settings.email.success": "Email configuration saved successfully!",
  "settings.email.guide-button": "Guide",

  /* Settings - Shipping */
  "settings.shipping.title": "Shipping Settings",
  "settings.shipping.subtitle":
    "Connect with shipping providers to automatically generate delivery orders",
  "settings.shipping.upgrade-warn":
    "You need to upgrade to Basic package to use Shipping Connection feature.",
  "settings.shipping.upgrade-btn": "Upgrade Now",
  "settings.shipping.business-type-label": "Your Business Type:",
  "settings.business.cafe": "Cafe",
  "settings.business.restaurant": "Restaurant",
  "settings.business.retail": "Retail",
  "settings.business.other": "Other",
  "settings.shipping.business-fit":
    "The following shipping providers are suitable for your business",
  "settings.shipping.connected-title": "Connected Providers",
  "settings.shipping.edit-btn": "Edit",
  "settings.shipping.disconnect-btn": "Disconnect",
  "settings.shipping.available-title": "Available Providers",
  "settings.shipping.status-connected": "Connected",
  "settings.shipping.connect-btn": "Connect Now",
  "settings.shipping.guide-title": "Instructions",
  "settings.shipping.modal.connect-title": "Connect {name}",
  "settings.shipping.modal.token": "API Token",
  "settings.shipping.modal.shop-id": "Shop ID",
  "settings.shipping.modal.client-id": "Client ID",
  "settings.shipping.modal.secret-key": "Secret Key",
  "settings.shipping.modal.token-placeholder": "Enter API Token from provider",
  "settings.shipping.modal.shop-id-placeholder": "Enter Shop ID (if any)",
  "settings.shipping.modal.client-id-placeholder": "Enter Client ID",
  "settings.shipping.modal.secret-key-placeholder": "Enter Secret Key",
  "settings.shipping.modal.current-token":
    "Current Token: {token} (leave blank to keep unchanged)",
  "settings.shipping.modal.sandbox-label":
    "Sandbox Mode (test) - Uncheck for production",
  "settings.shipping.modal.origin-title": "Shop Origin Address",
  "settings.shipping.modal.origin-desc":
    "This information is used to calculate accurate shipping fees",
  "settings.shipping.modal.province": "Province/City",
  "settings.shipping.modal.district": "District",
  "settings.shipping.modal.ward": "Ward",
  "settings.shipping.modal.select-province": "Select Province/City",
  "settings.shipping.modal.select-district": "Select District",
  "settings.shipping.modal.select-ward": "Select Ward",
  "settings.shipping.modal.cancel": "Cancel",
  "settings.shipping.modal.connect": "Connect",
  "settings.shipping.modal.connecting": "Connecting...",
  "settings.shipping.alert.missing-token": "Please enter API Token",
  "settings.shipping.alert.connect-success": "Connected successfully",
  "settings.shipping.alert.connect-error": "Connection error",
  "settings.shipping.alert.disconnect-confirm":
    "Are you sure you want to disconnect this shipping provider?",
  "settings.shipping.alert.disconnect-success": "Disconnected successfully",
  "settings.shipping.alert.disconnect-error": "Disconnect error",
  "settings.shipping.guide.ghn.step1": "Go to api.ghn.vn",
  "settings.shipping.guide.ghn.step2": "Register/Login account",
  "settings.shipping.guide.ghn.step3": 'Go to "Documents" to get Token',
  "settings.shipping.guide.ghn.step4": "Enter Token and Shop ID into form",
  "settings.shipping.guide.ghtk.step1":
    "Login to khachhang.giaohangtietkiem.vn",
  "settings.shipping.guide.ghtk.step2": 'Go to "Shop Info" or "API Management"',
  "settings.shipping.guide.ghtk.step3": "Copy API Token",
  "settings.shipping.guide.viettel.step1": "Login to partner.viettelpost.vn",
  "settings.shipping.guide.viettel.step2": 'Go to "Account Configuration"',
  "settings.shipping.guide.viettel.step3": "Copy API Token",
  "settings.shipping.guide.jt.step1": "Contact J&T to register as partner",
  "settings.shipping.guide.jt.step2": "Get Client ID and Secret Key",
  "settings.shipping.modal.token-guide.ghn":
    "Get token at: api.ghn.vn → Documents",
  "settings.shipping.modal.token-guide.ghtk":
    "Get token at: khachhang.giaohangtietkiem.vn → Shop Info",
  "settings.shipping.modal.token-guide.viettel":
    "Get token at: partner.viettelpost.vn → Account Config",
  "settings.shipping.modal.token-guide.jt": "Contact J&T to get API account",

  /* Settings - Customer */
  "settings.customer.tier.bronze": "Bronze",
  "settings.customer.tier.silver": "Silver",
  "settings.customer.tier.gold": "Gold",
  "settings.customer.tier.diamond": "Diamond",
  "settings.customer.alert.success": "Settings saved successfully!",
  "settings.customer.alert.error": "Error saving settings",
  "settings.customer.alert.missing-info": "Please fill in all information",
  "settings.customer.alert.min-tiers": "Must have at least 1 customer tier",
  "settings.customer.loading": "Loading...",
  "settings.customer.saving": "Saving...",
  "settings.customer.point-rule": "Point Accumulation Rules",
  "settings.customer.point-value": "1 point =",
  "settings.customer.currency": "VND",
  "settings.customer.tier-title": "Points Milestones & Customer Tiers",
  "settings.customer.add-tier": "Add Tier",
  "settings.customer.new-tier": "New Tier",
  "settings.customer.table.color": "Color",
  "settings.customer.table.name": "Tier Name",
  "settings.customer.table.points": "Min Points",
  "settings.customer.table.actions": "Actions",
  "settings.customer.placeholder.name": "Tier Name",
  "settings.customer.placeholder.points": "Points",
  "settings.customer.points-suffix": "points",
  "settings.customer.note-title": "Note:",
  "settings.customer.note-content":
    "Customer tiers will automatically update based on total accumulated points. Tiers are sorted by minimum points from low to high.",
  "settings.customer.save-btn": "Save Changes",

  /* Settings - Staff */
  "settings.staff.alert.load-error": "Unable to load settings",
  "settings.staff.alert.save-success": "Settings saved successfully!",
  "settings.staff.alert.save-error": "Unable to save settings",
  "settings.staff.alert.position-exists": "This position already exists",
  "settings.staff.shift-title": "Work Shift Configuration",
  "settings.staff.shift-desc":
    'Set default work shifts. Click "Save Settings" to save to system.',
  "settings.staff.add-shift": "Add Shift",
  "settings.staff.from": "From",
  "settings.staff.to": "To",
  "settings.staff.delete": "Delete",
  "settings.staff.position-title": "Job Positions",
  "settings.staff.position-desc":
    "List of job titles/positions. Click × to remove position.",
  "settings.staff.add-position": "Add New Position",
  "settings.staff.position-placeholder": "Enter position name...",
  "settings.staff.save-btn": "Save Settings",
  "settings.staff.saving": "Saving...",

  /* Settings - Partner & API */
  "settings.partner.title": "API Key",
  "settings.partner.doc-btn": "Integration Docs",
  "settings.partner.create-btn": "+ Create API Key",
  "settings.partner.alert.empty":
    'No API Keys found. Click "+ Create API Key" to start.',
  "settings.partner.alert.create-error": "Please enter API Key name",
  "settings.partner.alert.create-success": "API Key created successfully!",
  "settings.partner.alert.create-fail": "API Key creation failed",
  "settings.partner.alert.revoke-title": "Delete API Key",
  "settings.partner.alert.revoke-confirm":
    "Are you sure you want to delete this API Key? This action cannot be undone!",
  "settings.partner.alert.revoke-success": "API Key revoked",
  "settings.partner.alert.revoke-fail": "Revoke API Key failed: ",
  "settings.partner.alert.regenerate-title": "Regenerate API Key",
  "settings.partner.alert.regenerate-confirm":
    "Are you sure you want to regenerate this API Key? The old key will be disabled immediately!",
  "settings.partner.alert.regenerate-success":
    "API Key regenerated successfully!",
  "settings.partner.alert.regenerate-fail": "API Key regeneration failed",
  "settings.partner.alert.update-fail": "API Key update failed",
  "settings.partner.analytics.total": "Total requests",
  "settings.partner.analytics.today": "Today",
  "settings.partner.analytics.success-rate": "Success rate",
  "settings.partner.analytics.avg-time": "Avg. Time",
  "settings.partner.table.name": "Name",
  "settings.partner.table.keys": "API Keys",
  "settings.partner.table.permissions": "Permissions",
  "settings.partner.table.note": "Note",
  "settings.partner.table.action": "Actions",
  "settings.partner.modal.create.title": "Create New API Key",
  "settings.partner.modal.create.name": "API Key Name *",
  "settings.partner.modal.create.name-placeholder":
    "Ex: n8n Automation, App Mobile...",
  "settings.partner.modal.create.permissions": "Permissions",
  "settings.partner.modal.create.permissions-desc":
    "Select permissions and click × to remove",
  "settings.partner.modal.create.permissions-placeholder":
    "Select permissions...",
  "settings.partner.modal.create.env": "API Environment",
  "settings.partner.modal.create.env-test": "Test (Sandbox)",
  "settings.partner.modal.create.env-live": "Live (Production)",
  "settings.partner.modal.create.desc": "Description",
  "settings.partner.modal.create.desc-placeholder":
    "Describe the purpose of this API Key...",
  "settings.partner.modal.create.cancel": "Cancel",
  "settings.partner.modal.create.submit": "Create API Key",
  "settings.partner.modal.create.submitting": "Creating...",
  "settings.partner.modal.result.title": "API Key Created",
  "settings.partner.modal.result.important":
    "Important! Save this API Key now. It will only be shown once!",
  "settings.partner.modal.result.copy": "Copy",
  "settings.partner.modal.result.copied": "✓ Copied!",
  "settings.partner.modal.result.copy-alert": "API Key copied to clipboard!",
  "settings.partner.modal.result.expires": "Expires:",
  "settings.partner.modal.result.close": "Saved",

  /* Partner Permissions */
  "settings.partner.perm.orders-read": "Read Orders",
  "settings.partner.perm.orders-write": "Write Orders",
  "settings.partner.perm.products-read": "Read Products",
  "settings.partner.perm.products-write": "Write Products",
  "settings.partner.perm.inventory-read": "Read Inventory",
  "settings.partner.perm.inventory-write": "Write Inventory",
  "settings.partner.perm.recipes-read": "Read Recipes",
  "settings.partner.perm.recipes-write": "Write Recipes",
  "settings.partner.perm.customers-read": "Read Customers",
  "settings.partner.perm.customers-write": "Write Customers",
  "settings.partner.perm.user-read": "Read User Info",

  "settings.partner.env.test-desc":
    "Used for API testing. Created data will be marked as is_test=true and will not affect revenue reports.",
  "settings.partner.env.live-desc":
    "Used for production environment. All data will be recorded in the real system and affect reports.",
  "settings.partner.env.live-label": "Live:",
  "settings.partner.create-btn-pro-auto": "+ Create API Key (Pro Auto)",
  "settings.partner.list-title": "API Key List",
  "settings.partner.pro-feature-tooltip":
    "Feature requires Pro Auto plan or higher",
  "settings.partner.upgrade-alert.text": "You need to upgrade to",
  "settings.partner.upgrade-alert.action":
    "plan to create and manage API Keys.",
  "settings.partner.upgrade-alert.link": "Upgrade now",
  "settings.partner.modal.confirm.cancel": "Cancel",
  "settings.partner.modal.confirm.confirm": "Confirm",

  "settings.webhook.title": "Webhook Subscriptions",
  "settings.webhook.doc-btn": "API Docs",
  "settings.webhook.create-btn": "+ Create Webhook",
  "settings.webhook.create-btn-pro-auto": "+ Create Webhook (Pro Auto)",
  "settings.webhook.pro-feature-tooltip":
    "Feature requires Pro Auto plan or higher",
  "settings.webhook.upgrade-alert.text": "You need to upgrade to",
  "settings.webhook.upgrade-alert.action": "plan to use Webhooks.",
  "settings.webhook.upgrade-alert.link": "Upgrade now",

  "settings.webhook.alert.empty":
    'No webhooks found. Click "+ Create Webhook" to start receiving automated notifications.',
  "settings.webhook.alert.create-success": "Webhook created successfully!",
  "settings.webhook.alert.create-error": "Please check your information.",
  "settings.webhook.alert.create-fail": "Create webhook failed",
  "settings.webhook.alert.delete-success": "Webhook deleted",
  "settings.webhook.alert.delete-fail": "Delete webhook failed",
  "settings.webhook.alert.update-fail": "Update webhook failed",
  "settings.webhook.alert.rotate-confirm":
    "Are you sure you want to regenerate the Secret Key? The old key will be invalidated immediately!",
  "settings.webhook.alert.rotate-success":
    "Secret Key regenerated successfully!",
  "settings.webhook.alert.rotate-fail": "Regenerate Secret Key failed",
  "settings.webhook.alert.delete-confirm":
    "Are you sure you want to delete this webhook? This action cannot be undone!",

  "settings.webhook.table.url": "URL",
  "settings.webhook.table.events": "Events",
  "settings.webhook.table.status": "Status",
  "settings.webhook.table.last-triggered": "Last Triggered",
  "settings.webhook.table.action": "Action",
  "settings.webhook.status.active": "Active",
  "settings.webhook.status.inactive": "Inactive",

  "settings.webhook.modal.create.title": "Create New Webhook",
  "settings.webhook.modal.create.desc":
    "Webhooks allow VMASS to send automated notifications to your URL when events occur (new order, payment, etc.).",
  "settings.webhook.modal.create.url-label": "Webhook URL *",
  "settings.webhook.modal.create.url-placeholder":
    "https://your-server.com/webhook",
  "settings.webhook.modal.create.url-help":
    "URL must be HTTPS and accept POST requests",
  "settings.webhook.modal.create.events-label": "Select Events *",
  "settings.webhook.modal.create.events-placeholder": "Select events...",
  "settings.webhook.modal.create.events-help":
    "Click × to remove selected events",
  "settings.webhook.modal.create.cancel": "Cancel",
  "settings.webhook.modal.create.submit": "Create Webhook",
  "settings.webhook.modal.create.submitting": "Creating...",

  "settings.webhook.modal.secret.title": "Webhook Secret Key",
  "settings.webhook.modal.secret.important":
    "Important! Save this Secret Key now. It will only be shown once!",
  "settings.webhook.modal.secret.label":
    "Secret Key (for signature verification)",
  "settings.webhook.modal.secret.copy": "Copy",
  "settings.webhook.modal.secret.copied": "✓ Copied!",
  "settings.webhook.modal.secret.verify-guide": "How to verify signature:",
  "settings.webhook.modal.secret.close": "Secret Key Saved",

  "settings.webhook.modal.logs.title": "Webhook Delivery History",
  "settings.webhook.modal.logs.empty": "No logs found",
  "settings.webhook.modal.logs.time": "Time",
  "settings.webhook.modal.logs.event": "Event",
  "settings.webhook.modal.logs.status": "Status",
  "settings.webhook.modal.logs.response-time": "Response Time",
  "settings.webhook.modal.logs.close": "Close",

  "settings.webhook.modal.confirm.title": "Confirm",
  "settings.webhook.modal.confirm.cancel": "Cancel",
  "settings.webhook.modal.confirm.confirm": "Confirm",

  "settings.webhook.event.order.created": "New Order Created",
  "settings.webhook.event.order.paid": "Order Paid",
  "settings.webhook.event.order.shipped": "Order Shipped",
  "settings.webhook.event.order.completed": "Order Completed",
  "settings.webhook.event.order.cancelled": "Order Cancelled",
  "settings.webhook.event.product.updated": "Product Updated",
  "settings.webhook.event.inventory.low_stock": "Low Stock",
  "settings.webhook.event.inventory.expiring": "Inventory Expiring",
  "settings.webhook.event.customer.created": "New Customer",
  "settings.webhook.event.payment.received": "Payment Received",

  "settings.ai.title": "AI Assistant Integration (Multi-Agent)",
  "settings.ai.switch.on": "Enabled",
  "settings.ai.switch.off": "Disabled",
  "settings.ai.switch.desc":
    "When enabled, AI will automatically reply to messages instead of the standard Auto-reply.",
  "settings.ai.provider.label": "Primary Provider",
  "settings.ai.provider.gemini": "Google Gemini (Recommended - Free/Cheap)",
  "settings.ai.provider.openai": "OpenAI (GPT-4o - Smarter/Paid)",
  "settings.ai.failover.label": "Automatic Failover",
  "settings.ai.failover.desc":
    "If the primary provider fails (Quota exceeded, Server error), the system will automatically switch to the backup provider.",
  "settings.ai.gemini.label": "Gemini API Key",
  "settings.ai.gemini.placeholder": "Enter Google Gemini API Key...",
  "settings.ai.gemini.help.text": "Get key at ",
  "settings.ai.gemini.help.link": "Google AI Studio",
  "settings.ai.openai.label": "OpenAI API Key",
  "settings.ai.openai.placeholder": "Enter OpenAI API Key (sk-...)...",
  "settings.ai.openai.help.text": "Get key at ",
  "settings.ai.openai.help.link": "OpenAI Dashboard",
  "settings.ai.persona.label": "Persona",
  "settings.ai.persona.desc":
    'Define the AI\'s personality. E.g: "You are a helpful support agent who uses emojis."',
  "settings.ai.knowledge.label": "Knowledge Base",
  "settings.ai.knowledge.placeholder":
    "Example:\n- Wifi: CoffeeHouse / pass: 12345678\n- Opening hours: 7am - 10pm\n- Address: 123 Nguyen Van Linh...",
  "settings.ai.knowledge.desc":
    "AI will use this information to answer general customer questions.",
  "settings.ai.save": "Save Configuration",

  /* Shipping Providers */
  "settings.shipping.provider.ghn.name": "Giao Hang Nhanh (GHN)",
  "settings.shipping.provider.ghn.desc":
    "Fast delivery in urban areas and nationwide",
  "settings.shipping.provider.ghtk.name": "Giao Hang Tiet Kiem (GHTK)",
  "settings.shipping.provider.ghtk.desc": "Cost-effective delivery nationwide",
  "settings.shipping.provider.viettelpost.name": "Viettel Post",
  "settings.shipping.provider.viettelpost.desc":
    "Viettel postal service nationwide",
  "settings.shipping.provider.jt.name": "J&T Express",
  "settings.shipping.provider.jt.desc": "J&T Express delivery",

  /* Quick Reply Settings */
  "settings.quickreply.title": "Quick Reply Templates",
  "settings.quickreply.add": "Add Template",
  "settings.quickreply.empty.title": "No templates found",
  "settings.quickreply.create-first": "Create First Template",
  "settings.quickreply.col.title": "Title",
  "settings.quickreply.col.content": "Content",
  "settings.quickreply.col.shortcut": "Shortcut",
  "settings.quickreply.col.category": "Category",
  "settings.quickreply.col.action": "Action",
  "settings.quickreply.modal.title-add": "Add Quick Reply",
  "settings.quickreply.modal.title-edit": "Edit Quick Reply",
  "settings.quickreply.modal.label.title": "Title *",
  "settings.quickreply.modal.placeholder.title": "Ex: Thank you",
  "settings.quickreply.modal.label.content": "Content *",
  "settings.quickreply.modal.placeholder.content":
    "Message content to be sent...",
  "settings.quickreply.modal.label.shortcut": "Shortcut",
  "settings.quickreply.modal.placeholder.shortcut": "Ex: /thanks",
  "settings.quickreply.modal.help.shortcut": "Type shortcut to find quickly",
  "settings.quickreply.modal.label.category": "Category",
  "settings.quickreply.cat.general": "General",
  "settings.quickreply.cat.greeting": "Greeting",
  "settings.quickreply.cat.thanks": "Thanks",
  "settings.quickreply.cat.faq": "FAQ",
  "settings.quickreply.cat.promotion": "Promotion",
  "settings.quickreply.modal.cancel": "Cancel",
  "settings.quickreply.modal.save": "Create",
  "settings.quickreply.modal.update": "Update",
  "settings.quickreply.notify.load-error": "Cannot load templates",
  "settings.quickreply.notify.input-error": "Please enter title and content",
  "settings.quickreply.notify.update-success": "Template updated",
  "settings.quickreply.notify.create-success": "Template created",
  "settings.quickreply.notify.save-error": "Cannot save template",
  "settings.quickreply.notify.delete-confirm":
    "Are you sure you want to delete this template?",
  "settings.quickreply.notify.delete-success": "Template deleted",
  "settings.quickreply.notify.delete-error": "Cannot delete template",

  /* Auto Reply Settings */
  "settings.autoreply.title": "Auto Reply Rules",
  "settings.autoreply.add": "Add Rule",
  "settings.autoreply.empty.title": "No auto reply rules found",
  "settings.autoreply.create-first": "Create First Rule",
  "settings.autoreply.col.enable": "Enable",
  "settings.autoreply.col.name": "Rule Name",
  "settings.autoreply.col.keyword": "Keywords",
  "settings.autoreply.col.response": "Response",
  "settings.autoreply.col.page": "Fanpage",
  "settings.autoreply.col.match": "Matched",
  "settings.autoreply.col.action": "Action",
  "settings.autoreply.modal.title-add": "Add Auto Reply Rule",
  "settings.autoreply.modal.title-edit": "Edit Auto Reply Rule",
  "settings.autoreply.modal.label.name": "Rule Name *",
  "settings.autoreply.modal.placeholder.name": "Ex: Welcome new customer",
  "settings.autoreply.modal.label.page": "Apply to Fanpage",
  "settings.autoreply.modal.option.all-pages": "All Fanpages",
  "settings.autoreply.modal.label.trigger": "Trigger Keywords",
  "settings.autoreply.modal.placeholder.trigger":
    "hello, hi, welcome (separated by comma)",
  "settings.autoreply.modal.help.trigger":
    "Bot replies when message contains any keyword",
  "settings.autoreply.modal.label.response": "Response Content *",
  "settings.autoreply.modal.placeholder.response":
    "Hello! Thanks for contacting us...",
  "settings.autoreply.modal.label.priority": "Priority",
  "settings.autoreply.modal.help.priority":
    "Higher number = Higher priority (when multiple rules match)",
  "settings.autoreply.modal.cancel": "Cancel",
  "settings.autoreply.modal.save": "Create",
  "settings.autoreply.modal.update": "Update",
  "settings.autoreply.test.placeholder": "Enter message to test auto-reply...",
  "settings.autoreply.test.button": "Test",
  "settings.autoreply.test.matched": "Matched!",
  "settings.autoreply.test.no-match": "No match",
  "settings.autoreply.test.rule": "Rule:",
  "settings.autoreply.test.response": "Response:",
  "settings.autoreply.notify.load-error": "Cannot load rules",
  "settings.autoreply.notify.input-error": "Please enter name and response",
  "settings.autoreply.notify.update-success": "Rule updated",
  "settings.autoreply.notify.create-success": "Rule created",
  "settings.autoreply.notify.save-error": "Cannot save rule",
  "settings.autoreply.notify.delete-confirm":
    "Are you sure you want to delete this rule?",
  "settings.autoreply.notify.delete-success": "Rule deleted",
  "settings.autoreply.notify.delete-error": "Cannot delete rule",
  "settings.autoreply.notify.toggle-error": "Cannot toggle rule status",

  /* Upgrade Page */
  "upgrade.title": "Upgrade Account",
  "upgrade.subtitle": "Choose the plan that suits your business needs",
  "upgrade.current-package": "Current Plan",
  "upgrade.expired": "Expired",
  "upgrade.remaining-days": "{days} days remaining",
  "upgrade.lifetime": "Lifetime",
  "upgrade.activated": "ACTIVATED",
  "upgrade.renew": "RENEW",
  "upgrade.downgrade": "DOWNGRADE",
  "upgrade.upgrade": "UPGRADE",
  "upgrade.contact": "CONTACT",
  "upgrade.using": "USING",
  "upgrade.best-value": "Best Value",

  "upgrade.feature.accounts": "Cashier, Kitchen & Server Accounts",
  "upgrade.feature.sales": "Full Sales Management Suite",
  "upgrade.feature.products": "Product Management",
  "upgrade.feature.materials": "Material Management",
  "upgrade.feature.staff": "Staff Management & Timekeeping",
  "upgrade.feature.chain": "Multi-branch Management",
  "upgrade.feature.reports": "Revenue & Profit Reports",
  "upgrade.feature.social": "Social Media Connection",
  "upgrade.feature.shipping": "Shipping Connection",
  "upgrade.feature.ecommerce": "TikTok Shop / Shopee Connection",
  "upgrade.feature.einvoice": "E-Invoice",
  "upgrade.feature.api": "Webhook / API Integration",
  "upgrade.feature.api-limit": "API Request Limit",
  "upgrade.feature.automation": "Automation System",
  "upgrade.feature.support": "Technical Support & Setup",

  "upgrade.value.products.free": "30 products",
  "upgrade.value.products.basic": "Unlimited",
  "upgrade.value.materials.free": "30 materials",
  "upgrade.value.materials.basic": "Unlimited",
  "upgrade.value.staff.free": "2 staff",
  "upgrade.value.unlimited": "Unlimited",
  "upgrade.value.reports.basic": "Today's Reports",
  "upgrade.value.reports.detailed": "Real-time Revenue Reports",
  "upgrade.value.reports.advanced": "Advanced Profit Reports",
  "upgrade.value.api.limit": "30,000 / month",
  "upgrade.value.api.custom": "Custom",
  "upgrade.value.support.docs": "Documents",
  "upgrade.value.support.online": "Online 24/7",
  "upgrade.value.support.priority": "Priority 1-1",

  "upgrade.package.free.title": "FREE PLAN",
  "upgrade.package.basic.title": "BASIC PLAN",
  "upgrade.package.pro.title": "PRO PLAN",
  "upgrade.package.pro-auto.title": "PRO + AUTOMATION",
  "upgrade.package.enterprise.title": "ENTERPRISE",

  "upgrade.time.1m": "1 month",
  "upgrade.time.6m": "6 months",
  "upgrade.time.1y": "1 year",
  "upgrade.time.2y": "2 years",
  "upgrade.time.5y": "5 years",

  "upgrade.modal.payment.title": "Payment Information",
  "upgrade.modal.payment.instant-title": "Eligible for Instant Activation",
  "upgrade.modal.payment.deduct-intro":
    "Total deduction value ({amount} VND) is enough to pay for this package.",
  "upgrade.modal.payment.deduct-note":
    "You do not need to pay extra. The system will activate immediately.",
  "upgrade.modal.payment.instruction":
    "Select the duration you want to upgrade, then transfer to the account below with the corresponding amount and content. After transfer, the software will upgrade automatically!",
  "upgrade.modal.payment.term": "Duration:",
  "upgrade.modal.payment.scan-note": "Scan to pay",
  "upgrade.modal.payment.owner": "Account Holder:",
  "upgrade.modal.payment.account": "Account Number:",
  "upgrade.modal.payment.bank": "Bank:",
  "upgrade.modal.payment.amount": "Amount:",
  "upgrade.modal.payment.content": "Content:",
  "upgrade.modal.payment.remaining": "(Remaining Balance)",
  "upgrade.modal.payment.wallet": "(Wallet)",
  "upgrade.modal.payment.original-price": "Original price:",
  "upgrade.modal.payment.total": "Amount due:",
  "upgrade.modal.payment.btn-instant": "Confirm & Activate now",
  "upgrade.modal.payment.btn-submit": "Confirm payment & Request upgrade",
  "upgrade.modal.payment.surplus-refund": "Surplus refund to wallet:",
  "upgrade.promo.title": "Promo code",
  "upgrade.promo.placeholder": "Enter promo code",
  "upgrade.promo.apply": "Apply",
  "upgrade.promo.remove": "Remove",
  "upgrade.promo.btn-create": "Create code",
  "upgrade.promo.empty": "No promo codes yet",
  "upgrade.promo.modal-create": "Create promo code",
  "upgrade.promo.modal-edit": "Edit promo code",
  "upgrade.promo.col-code": "Code",
  "upgrade.promo.col-desc": "Description",
  "upgrade.promo.col-discount": "Discount",
  "upgrade.promo.col-packages": "Packages",
  "upgrade.promo.col-usage": "Used / Max",
  "upgrade.promo.col-date": "Date range",
  "upgrade.promo.col-status": "Status",
  "upgrade.promo.discount-type": "Discount type",
  "upgrade.promo.discount-value": "Value",
  "upgrade.promo.max-discount": "Max discount (đ)",
  "upgrade.promo.max-uses": "Max uses",
  "upgrade.promo.start-date": "Start date",
  "upgrade.promo.end-date": "End date",
  "menu.upgrade-promo": "Upgrade Promo Codes",
  "upgrade.modal.payment.manual-note":
    "Just scan the QR code to pay. After successful payment, the software will automatically upgrade immediately!",

  "upgrade.modal.downgrade.title": "Confirm Downgrade",
  "upgrade.modal.downgrade.intro":
    "The system will convert the remaining value of the current package:",
  "upgrade.modal.downgrade.remaining-value": "Remaining Value:",
  "upgrade.modal.downgrade.equivalent": "(Equivalent to {days} days)",
  "upgrade.modal.downgrade.exchange": "Convert to new package:",
  "upgrade.modal.downgrade.refund": "Refund amount to wallet:",
  "upgrade.modal.downgrade.warning":
    "Note: This action cannot be undone. The new package will be activated immediately.",
  "upgrade.modal.downgrade.calculating": "Calculating...",
  "upgrade.modal.downgrade.cancel": "Cancel",
  "upgrade.modal.downgrade.confirm": "Confirm Downgrade",
  "upgrade.modal.downgrade.ineligible": "Ineligible (Under 1 month)",

  "upgrade.modal.success.title": "Upgrade Successful!",
  "upgrade.modal.success.msg": "Congratulations on successfully upgrading!",
  "upgrade.modal.success.lifetime": "Your account has been upgraded for life",
  "upgrade.modal.success.new-expiry": "New Expiry Date:",
  "upgrade.modal.success.close": "Close",

  "profile.fullname": "Full Name",
  "profile.description": "Description",
  "profile.address": "Address",
  "profile.phone": "Phone",
  "profile.email": "Email",
  "profile.company-name": "Shop Name",
  "profile.company-address": "Shop Address",
  "profile.company-website": "Website",
  "profile.company-start-time": "Open Time",
  "profile.company-end-time": "Close Time",
  "profile.company-menu-hash": "Online Menu",
  "profile.bankPay": "Bank",
  "profile.namePay": "Account Owner",
  "profile.numberPay": "Account Number",
  "profile.update-personal": "UPDATE PERSONAL INFO",
  "profile.update-company": "UPDATE SHOP INFO",
  "profile.placeholder.fullname": "Ex: John Doe",
  "profile.placeholder.description": "Ex: Enthusiastic staff, love coffee...",
  "profile.placeholder.address": "Ex: 123 Street, District 1, HCMC",
  "profile.placeholder.phone": "Ex: 0901 234 567",
  "profile.placeholder.email": "Ex: johndoe@gmail.com",
  "profile.placeholder.hotline": "Ex: 1900 1234",
  "profile.placeholder.website": "Ex: vmass.vn",
  "profile.placeholder.bank": "Select Bank",
  "profile.placeholder.account-name": "Ex: JOHN DOE",
  "profile.placeholder.account-number": "Ex: 0123456789",
  "profile.business-type.cafe": "Coffee, Milk Tea",
  "profile.business-type.restaurant": "Restaurant, Eatery",
  "profile.business-type.retail": "Retail",
  "profile.business-type.grocery": "Grocery, Minimart",
  "profile.business-type.pharmacy": "Pharmacy, Drugstore",
  "profile.business-type.electronics": "Electronics, Technology",
  "profile.business-type.spa": "Spa, Salon, Beauty Clinic",
  "profile.business-type.fashion": "Fashion",
  "profile.business-type.cosmetics": "Cosmetics",
  "profile.business-type.unknown": "Unknown",
  "profile.business-type.label": "Business Type",
  "profile.payment-info.title": "PAYMENT INFORMATION",

  /* Affiliate List */
  "affiliate.col.name": "Name",
  "affiliate.col.email": "Email",
  "affiliate.col.phone": "Phone",
  "affiliate.col.bank": "Bank",
  "affiliate.col.status": "Status",
  "affiliate.col.date": "Registered Date",
  "affiliate.col.action": "Action",
  "affiliate.empty": "No data available",
  "affiliate.status.approved": "Approved",
  "affiliate.status.pending": "Pending",
  "affiliate.status.deactivated": "Deactivated",

  /* Guest View & Orders */
  "guest.cart": "Cart",
  "guest.price": "Unit Price",
  "guest.quantity": "Quantity",
  "guest.total": "Total",
  "guest.product": "Product",
  "guest.total-amount": "Total Amount",
  "guest.payment": "Payment",
  "guest.call-service": "Call Service",
  "guest.call-service-cooldown": "Call again in {seconds}s",
  "guest.request-payment": "Request Payment",
  "guest.invoice": "Invoice",

  /* Order Summary */
  "order.summary.discount": "Discount",
  "order.summary.tax": "Tax",
  "order.summary.fee": "Other Fee",
  "order.summary.gift": "Gift",
  "order.summary.total-payment": "Total Payment",

  /* Product Management Tools */
  "product.tooltip.category":
    'The parent category of this product. E.g., "Coffee" is the parent for "Iced Milk Coffee".',
  "product.tooltip.price":
    'This is the selling price if "Promotion Price" is not checked.',
  "product.tooltip.topping":
    "Add extra items or add-ons and their corresponding additional costs.",
  "product.tooltip.ice":
    "Tick the 5 boxes to allow customers to choose the amount of ice.",
  "product.tooltip.sugar":
    "Tick the 5 boxes to allow customers to choose the sweetness level.",
  /* Recipe Builder */
  "recipe.unit.default": "Pcs, box, pack...",
  "recipe.unit.cafe": "Cup, glass, plate...",
  "recipe.unit.fashion": "Pcs, pair, set...",
  "recipe.unit.cosmetics": "Bottle, tube, jar...",
  "recipe.unit.retail": "Pcs, pack, box, kg...",
  "recipe.unit.grocery": "Pcs, pack, box, kg...",
  "recipe.unit.pharmacy": "Box, blister, pill, tube...",
  "recipe.unit.electronics": "Pcs, piece, set, carton...",
  "recipe.unit.spa": "Session, service, turn, item...",
  "recipe.unit.generic": "unit",
  "recipe.title": "Recipe / Ingredients",
  "recipe.count-badge": "ingredients",
  "recipe.empty-state": 'No ingredients yet. Click "Add Ingredient" to start.',
  "recipe.label.name": "Ingredient Name",
  "recipe.placeholder.select": "Select or create new...",
  "recipe.create-label": 'Create "{val}"',
  "recipe.label.usage": "Usage Qty",
  "recipe.label.total": "Subtotal",
  "recipe.btn.delete": "Remove row",
  "recipe.btn.delete-tooltip": "Remove ingredient",
  "recipe.new-stock.title": "Import New Stock:",
  "recipe.label.unit": "Unit",
  "recipe.label.import-qty": "Import Qty",
  "recipe.label.cost-price": "Cost Price",
  "recipe.unit.per-unit": " / unit",
  "recipe.label.paid": "Paid",
  "recipe.label.provider": "Supplier",
  "recipe.create-provider": 'Create "{val}"',
  "recipe.label.debt": "Debt",
  "recipe.btn.add": "Add Ingredient",
  "recipe.footer.total-cost": "Total Cost:",
  "recipe.footer.expected-profit": "Est. Profit:",

  "product.name": "Product Name",
  "product.price": "Price",
  "product.promotion-price": "Promotion Price",
  "product.price.cost": "Cost Price",
  "product.image": "Image",
  "label.enter-barcode": "Enter barcode",
  "label.enter-product-name": "Enter product name",
  "stock.unit": "Unit",
  "label.select-or-create": "Select or create...",
  "label.create-new": "Create new",
  "label.select-create-provider": "Select or create provider...",
  "unit.placeholder.default": "Pcs, box, pack...",
  "unit.placeholder.cafe": "Cup, glass, plate...",
  "unit.placeholder.fashion": "Pcs, pair, set...",
  "unit.placeholder.cosmetics": "Bottle, tube, jar...",
  "unit.placeholder.retail": "Pcs, pack, box, kg...",
  "unit.placeholder.grocery": "Pcs, pack, box, kg...",
  "unit.placeholder.pharmacy": "Box, blister, pill, tube...",
  "unit.placeholder.electronics": "Pcs, piece, set, carton...",
  "unit.placeholder.spa": "Session, service, turn, item...",
  "modal.stock.stt": "No.",
  "modal.product.unit": "Recipe",
  "modal.product.combo": "Combo",
  "product.edit_cost": "Edit Quant",
  "tooltip.enable-combo": "Enable Combo",
  "modal.product.variant": "Variations",
  "tooltip.not-for-combo": "Not for Combo",
  "modal.stock.supplier": "Supplier",
  "modal.product.paid": "Paid",
  "modal.stock.remaining": "Debt",
  "modal.product.image": "Image",
  "tooltip.unit-hint": "Product unit",
  "warehouse.import-quantity": "Import Qty",

  "product.add-title": "Add Product",
  "product.import-excel": "Import from Excel",
  "product.import-image": "Import from Image",
  "product.notify.stock-success": "New stock created successfully",
  "product.sku": "SKU Code",
  "product.barcode": "Barcode",
  "product.stock-count": "Stock",

  "breakeven.title": "Break-Even",
  "breakeven.period.day": "Day",
  "breakeven.period.month": "Month",
  "breakeven.period.quarter": "Quarter",
  "breakeven.period.year": "Year",
  "breakeven.fallback.active":
    "Using estimated data from previous period or product list",
  "breakeven.fallback.inactive":
    "Enable to use estimated data when no orders exist",
  "breakeven.fallback.has-data":
    "Actual data available in period, no need for estimation",
  "breakeven.fixed-costs.title": "Fixed Costs (VND)",
  "breakeven.fixed-costs.rent": "Rent Cost",
  "breakeven.fixed-costs.salary": "Fixed Salary",
  "breakeven.fixed-costs.depreciation": "Equipment Depreciation",
  "breakeven.fixed-costs.management": "Management & Marketing",
  "breakeven.fixed-costs.other": "Other Fixed Costs",
  "breakeven.product.title": "Product Information",
  "breakeven.product.price": "Avg Selling Price/Unit",
  "breakeven.product.variable-cost": "Avg Cost Price/Unit",
  "breakeven.product.profit-margin": "Profit Margin %",
  "breakeven.product.price.tooltip.no-data":
    "No orders in period, cannot calculate avg selling price",
  "breakeven.product.variable-cost.tooltip.no-data":
    "This metric is calculated based on sold products",
  "breakeven.product.profit-margin.tooltip.no-data":
    "Selling price and cost price needed to calculate margin",
  "breakeven.product.profit-margin.tooltip.desc":
    "Margin = (Price - Cost) / Price × 100%",
  "breakeven.loading": "Loading data...",
  "breakeven.empty.title": "Cannot calculate break-even point",
  "breakeven.empty.desc":
    "At least 1 order in period is needed to determine actual profit margin.",
  "breakeven.empty.sub": "Will appear after the first order.",
  "breakeven.result.fixed-cost": "Total Fixed Costs",
  "breakeven.result.revenue": "Current Revenue",
  "breakeven.result.gross-profit": "Current Gross Profit",
  "breakeven.result.sold-quantity": "Sold Quantity",
  "breakeven.result.breakeven-units": "Break-Even Units",
  "breakeven.result.breakeven-revenue": "Break-Even Revenue",
  "breakeven.table.title": "Profit Analysis Detail Table",
  "breakeven.table.volume": "Volume",
  "breakeven.table.revenue": "Revenue",
  "breakeven.table.variable-cost": "Variable Cost",
  "breakeven.table.fixed-cost": "Fixed Cost",
  "breakeven.table.total-cost": "Total Cost",
  "breakeven.table.profit": "Profit",
  "breakeven.error.price-invalid": "Avg selling price must be greater than 0.",
  "breakeven.error.cost-invalid": "Variable cost cannot be negative.",
  "breakeven.error.margin-invalid":
    "Selling price must be greater than unit variable cost.",
  "breakeven.error.fetch-fail": "Cannot fetch data",
  "breakeven.error.connect-fail": "Connection error: ",
  "breakeven.chart.title": "Break-Even Analysis Chart",
  "breakeven.chart.revenue": "Revenue (TR)",
  "breakeven.chart.total-cost": "Total Cost (TC)",
  "breakeven.chart.fixed-cost": "Fixed Cost (FC)",
  "breakeven.chart.x-axis": "Units (Q)",
  "breakeven.chart.y-axis": "Value (VND)",
  "profile.validate.required":
    "Please fill in all information marked with * for the best functionality!",
  "profile.success": "Success",
  "profile.error": "An error occurred, please try again.",
  "company-uuid": "UUID",

  "upgrade.notify.payment-received":
    "Received payment {amount} VND from {gateway}",
  "upgrade.notify.success":
    "Account upgraded successfully! Please check expiration date.",

  /* Navigation Tabs */
  "settings.nav.general": "General Settings",
  "settings.nav.invoice": "Invoice Settings",
  "settings.nav.social": "Social Connections",
  "settings.nav.shipping": "Shipping Connections",
  "settings.nav.staff": "Staff Settings",
  "settings.nav.customer": "Customer Settings",
  "settings.nav.ecommerce": "E-commerce Connections",
  "settings.nav.einvoice": "E-Invoice",
  "settings.nav.apikeys": "API Keys",
  "settings.nav.webhooks": "Webhooks",
  "settings.nav.email": "Email Configuration",
  "settings.nav.ai": "AI Assistant",

  /* Notifications & Confirms */
  "settings.notification.no-data": "No data available",
  "settings.notification.saved": "Configuration saved!",
  "settings.notification.error": "An error occurred",
  "settings.social.fb.disconnect-success": "Page disconnected!",
  "settings.social.fb.disconnect-error": "Error disconnecting Page",
  "settings.social.fb.confirm-disconnect":
    "Are you sure you want to disconnect this Page?",
  "settings.social.zalo.disconnect-success": "Zalo OA disconnected!",
  "settings.social.zalo.disconnect-error": "Error disconnecting Zalo OA",
  "settings.social.zalo.confirm-disconnect":
    "Are you sure you want to disconnect this Zalo OA?",
  "settings.ecommerce.shopee.connect-error": "Error connecting Shopee",
  "settings.ecommerce.shop.disconnect-success": "Shop disconnected!",
  "settings.ecommerce.shop.disconnect-error": "Error disconnecting Shop",
  "settings.ecommerce.shop.confirm-disconnect":
    "Are you sure you want to disconnect this Shop?",
  "settings.ecommerce.tiktok.connect-error": "Error connecting TikTok Shop",
  "settings.ecommerce.tiktok.disconnect-success": "TikTok Shop disconnected!",
  "settings.ecommerce.tiktok.disconnect-error":
    "Error disconnecting TikTok Shop",
  "settings.ecommerce.product-import-success": "Products imported!",
  "settings.ecommerce.product-import-error": "Error importing products",
  "settings.ecommerce.order-sync-success": "Orders synced!",
  "settings.ecommerce.order-sync-error": "Error syncing orders",
  "settings.einvoice.save-success": "E-Invoice configuration saved!",
  "settings.einvoice.save-error": "Error saving E-Invoice configuration",
  "settings.email.save-success": "Email configuration saved!",
  "settings.email.save-error": "Error saving email configuration",
  "settings.email.test-success": "Test email sent!",
  "settings.email.test-error": "Error sending test email",

  /* Social Settings (Zalo) */
  "settings.zalo.title": "Zalo Official Account",
  "settings.zalo.guide": "Guide",
  "settings.zalo.guide.title": "How to connect Zalo OA:",
  "settings.zalo.guide.step1": "Click 'Connect new Zalo OA'",
  "settings.zalo.guide.step2": "Login to Zalo (if needed)",
  "settings.zalo.guide.step3": "Select OA to connect",
  "settings.zalo.guide.step4": "Grant permissions",
  "settings.zalo.guide.step5": "Done!",
  "settings.zalo.desc":
    "Connect Zalo OA to receive and reply to customer messages from Zalo.",
  "settings.zalo.upgrade-warning":
    "You need to upgrade to Basic plan to connect Zalo OA.",
  "settings.zalo.upgrade-btn": "Upgrade Now",
  "settings.zalo.connect-locked": "Connect new Zalo OA (Basic plan required)",
  "settings.zalo.connect-btn": "Connect new Zalo OA",
  "settings.zalo.loading": "Loading...",
  "settings.zalo.no-oa": "No Zalo OA connected.",
  "settings.zalo.table.name": "Zalo OA Name",
  "settings.zalo.table.id": "OA ID",
  "settings.zalo.table.date": "Connected Date",
  "settings.zalo.table.action": "Action",
  "settings.zalo.disconnect-btn": "Disconnect",

  /* Ecommerce Settings (Shopee/TikTok) */
  "settings.ecommerce.shopee.guide": "Guide",
  "settings.ecommerce.shopee.guide.title": "How to connect Shopee:",
  "settings.ecommerce.shopee.guide.step1": "Click 'Connect new Shop'",
  "settings.ecommerce.shopee.guide.step2": "Login to Shopee (if needed)",
  "settings.ecommerce.shopee.guide.step3": "Select Shop to connect",
  "settings.ecommerce.shopee.guide.step4": "Grant permissions",
  "settings.ecommerce.shopee.guide.step5": "Done!",
  "settings.ecommerce.shopee.desc":
    "Connect Shopee to sync orders, products, and inventory.",
  "settings.ecommerce.upgrade-warning":
    "You need to upgrade to Basic plan to connect.",
  "settings.ecommerce.connect-locked": "Connect new Shop (Basic plan required)",
  "settings.ecommerce.connect-btn": "Connect new Shop",
  "settings.ecommerce.loading": "Loading...",
  "settings.ecommerce.no-shop": "No Shop connected.",
  "settings.ecommerce.table.name": "Shop Name",
  "settings.ecommerce.table.id": "Shop ID",
  "settings.ecommerce.table.region": "Region",
  "settings.ecommerce.table.date": "Connected Date",
  "settings.ecommerce.table.action": "Action",
  "settings.ecommerce.action.syncing": "Syncing...",
  "settings.ecommerce.action.import-product": "Import Products",
  "settings.ecommerce.action.sync-order": "Sync Orders",
  "settings.ecommerce.action.disconnect": "Disconnect",
  "settings.ecommerce.tiktok.guide": "Guide",
  "settings.ecommerce.tiktok.guide.title": "How to connect TikTok Shop:",
  "settings.ecommerce.tiktok.desc":
    "Connect TikTok Shop to sync orders, products, and inventory.",

  /* E-Invoice Settings */
  "settings.einvoice.title": "E-Invoice Configuration",
  "settings.einvoice.upgrade-warning":
    "You need to upgrade to Pro plan to use E-Invoice.",
  "settings.einvoice.provider": "E-Invoice Provider",
  "settings.einvoice.vat-rate": "Default VAT Rate (%)",
  "settings.einvoice.api-info": "API Credentials",
  "settings.einvoice.username": "Username",
  "settings.einvoice.password": "Password",
  "settings.einvoice.company-info": "Company Information",
  "settings.einvoice.tax-id": "Tax ID",
  "settings.einvoice.company-name": "Company Name",
  "settings.einvoice.address": "Address",
  "settings.einvoice.phone": "Phone",
  "settings.einvoice.email": "Email",
  "settings.einvoice.series": "Invoice Series",
  "settings.einvoice.bank-info": "Bank Information (Optional)",
  "settings.einvoice.bank-account": "Account Number",
  "settings.einvoice.bank-name": "Bank Name",
  "settings.einvoice.save-btn": "Save Configuration",
  "settings.einvoice.saving": "Saving...",
  "settings.einvoice.api-url": "API URL",
  "settings.einvoice.api-url-help":
    "Use Test for testing, Production for real operations",
  "settings.einvoice.signing-method": "Invoice Signing Method",
  "settings.einvoice.sign-type": "Signing Type",
  "settings.einvoice.sign-type-help":
    "USB Token (manual), HSM (auto server), eSign (remote via CA)",
  "settings.einvoice.esign-config": "Advanced eSign Configuration",
  "settings.einvoice.esign-provider": "CA Provider",
  "settings.einvoice.esign-username": "eSign Username",
  "settings.einvoice.esign-password": "eSign Password",
  "settings.einvoice.esign-serial": "Certificate Serial Number",
  "settings.einvoice.test-connection": "Test Connection",
  "settings.einvoice.testing": "Testing...",
  "settings.einvoice.test-success": "Connection successful!",
  "settings.einvoice.test-fail": "Cannot connect to server",
  "settings.ai.saving-btn": "Saving...",
  "settings.ai.notification.success":
    "AI Agent configuration saved successfully!",
  "settings.ai.notification.error": "Error saving configuration",
  "settings.ai.notification.success-title": "Success",
  "settings.ai.notification.error-title": "Error",

  "facebook.go-to-messenger": "Go to Chat",

  "settings.shipping.alert.connect-success": "Connected successfully",
  "settings.shipping.alert.connect-error": "Connection error",
  "settings.shipping.alert.disconnect-confirm":
    "Are you sure you want to disconnect this shipping provider?",
  "settings.shipping.alert.disconnect-success": "Disconnected successfully",
  "settings.shipping.alert.disconnect-error": "Disconnect error",

  "warehouse.transfer-search": "Search name of Transfer",
  "warehouse.transfer": "Transfer Note",
  "warehouse.transfer-stock": "Transferred Item",
  "warehouse.transfer-title": "Update transfer note",
  "warehouse.transfer-name": "Name of person transferring",
  "warehouse.transfer-quantity": "Quantity",
  "warehouse.transfer-price": "Transfer Price",

  /* Inventory Audit */
  "audit.title": "Inventory check and stock adjustment",
  "audit.button.create": "Create Audit",
  "audit.modal.detail.title": "Audit Details",
  "audit.date": "Date",
  "audit.status": "Status",
  "audit.note": "Note",
  "audit.table.stock": "Material",
  "audit.table.system": "System",
  "audit.table.actual": "Actual",
  "audit.table.discrepancy": "Discrepancy",
  "audit.table.reason": "Reason",
  "audit.total-discrepancy": "Total Discrepancy Value",
  "audit.button.continue": "Continue Audit",
  "audit.status.completed": "Completed",
  "audit.status.pending": "InProgress",

  /* Stock Return */
  "return.title": "Return to supplier",
  "return.button.create": "Create Return",
  "return.modal.detail.title": "Return Details",
  "return.date": "Date",
  "return.status": "Status",
  "return.reason": "Reason",
  "return.table.stock": "Material",
  "return.table.quantity": "Quantity",
  "return.table.price": "Price",
  "return.table.provider": "Supplier",
  "return.table.total": "Total",
  "return.total-value": "Total Value",
  "return.status.completed": "Completed",
  "return.status.pending": "Processing",

  /* Stock Disposal */
  "disposal.title": "Dispose of expired or damaged materials",
  "disposal.button.create": "Create Disposal",
  "disposal.modal.detail.title": "Disposal Details",
  "disposal.date": "Date",
  "disposal.type": "Type",
  "disposal.status": "Status",
  "disposal.type.expired": "Expired",
  "disposal.type.damaged": "Damaged",
  "disposal.type.other": "Other",
  "disposal.status.completed": "Completed",
  "disposal.status.pending": "Pending",
  "disposal.status.rejected": "Rejected",
  "disposal.table.stock": "Material",
  "disposal.table.quantity": "Quantity",
  "disposal.table.unit": "Unit",
  "disposal.table.provider": "Supplier",
  "disposal.table.refundable": "Refundable",
  "disposal.table.price": "Price",
  "disposal.table.total": "Total",
  "disposal.table.reason": "Reason",
  "disposal.total": "Total",
  "disposal.button.close": "Close",
  "disposal.refundable.yes": "Yes",
  "disposal.refundable.no": "No",

  /* Invoice (Order) */
  "invoice.title": "Invoice",
  "invoice.tab.info": "General Info",
  "invoice.tab.deleted": "DELETED INVOICES",
  "invoice.empty": "No data available...",
  "invoice.menu.restore": "Restore Invoice",
  "invoice.menu.destroy": "Delete Forever",
  "invoice.badge.id": "Invoice ID",
  "invoice.badge.no-print": "Not Printed",
  "invoice.discount": "Discount",
  "invoice.tax": "Tax",
  "invoice.fee": "Fee",
  "invoice.no-permission": "You do not have permission to use this feature!",
  "invoice.confirm.destroy":
    "Are you sure you want to permanently delete this invoice?",
  "invoice.success.restore": "Invoice restored successfully",
  "invoice.error.unknown": "An unknown error occurred.",

  /* Home Page (Dashboard) */
  "home.wizard.title": "Initial Setup",
  "home.warning.add-product": "Please add your first product",
  "home.warning.update-info": "Please update store information",
  "home.warning.update-payment": "Please update payment information",
  "home.warning.dismiss-template": "You are viewing sample data. Please hide or remove sample data before live usage",
  "home.warning.dismiss-btn": "Hide sample data",
  "home.warning.dismiss-confirm": "Are you sure you want to hide all sample data?",
  "home.warning.dismiss-success": "Sample data hidden successfully!",
  "home.warning.here": "here",
  "home.status-order": "Order Status",
  "home.btn.order-preview": "Order Preview",
  "home.table.title-orders": "ORDER ITEMS",
  "home.table.title-adjust": "ADJUST ORDER",
  "home.btn.save-provisional": "Save Temporary",
  "home.btn.provisional-invoice": "Draft Invoices",
  "home.btn.return-order": "Return Order",

  "home.header.product": "Product Name",
  "home.header.quantity": "Qty",
  "home.header.price": "Price",
  "home.header.total": "Total",
  "home.header.delete": "Delete",
  "home.empty": "No items ordered yet!",
  "home.summary.total": "Subtotal",
  "home.summary.discount": "Discount",
  "home.summary.tax": "Tax/Fee",
  "home.summary.fee-other": "Other Fee",
  "home.summary.shipping": "Shipping Fee",
  "home.summary.payment-total": "Total Amount to Pay",
  "home.shipping.ghn": "Giao Hang Nhanh (GHN)",
  "home.shipping.ghtk": "Giao Hang Tiet Kiem (GHTK)",
  "home.shipping.viettelpost": "Viettel Post",
  "home.shipping.vnpost": "VN Post",
  "home.shipping.ahamove": "Ahamove",
  "home.shipping.lalamove": "Lalamove",
  "home.shipping.grabexpress": "GrabExpress",
  "home.shipping.shopeexpress": "Shopee Xpress",
  "home.shipping.jtexpress": "J&T Express",
  "home.shipping.ninjavan": "Ninja Van",
  "home.shipping.bestexpress": "BEST Express",
  "home.shipping.kerryexpress": "Kerry Express",
  "home.summary.customer-pay": "Customer Paid",
  "home.summary.refund": "Change",
  "home.summary.missing": "Missing",
  "home.order.ice": "Ice",
  "home.order.sugar": "Sugar",

  "home.placeholder.customer-name": "Customer Name",
  "home.placeholder.phone": "Phone Number",
  "home.btn.complete-adjust": "Complete Adjustment",
  "home.tooltip.missing-amount":
    'The missing amount will be recorded in "Customer Debt". Please enter the customer\'s name and phone number below.',
  "home.tooltip.done-pay":
    'When checking this box, the total invoice will be recorded in "Customer Debt". Please enter the customer\'s name and phone number below.',
  "home.tooltip.discount":
    "This amount will be deducted from the Total Amount.",
  "home.tooltip.tax-fee": "This amount will be added to the Total Amount.",
  "home.tooltip.fee-other": "This amount will be added to the Total Amount.",
  "home.notify.no-products": "No products ordered. Add at least 1 product.",
  "general.loading": "Loading...",
  "general.done": "Done",
  "general.not-yet": "Not yet",
  "general.error.title": "Error!",
  "home.btn.close": "Close",
  "home.btn.order": "Order (F9)",
  "home.btn.payment": "Complete Payment (F9)",
  "home.btn.print-provisional": "Print Draft (F8)",
  "home.btn.calculating": "Calculating...",

  "home.alert.call-payment": "Guest calling for payment!",
  "home.alert.call-service": "Guest calling for service!",
  "home.alert.stock-warning": "Stock running low warning",
  "home.notify.no-order-discount": "No order to apply discount",
  "home.notify.open-menu-print":
    'Please open "Other" menu to print draft invoice',
  "home.notify.no-order-print": "No order to print",
  "home.notify.no-payment-btn": "Payment button not found",
  "home.notify.no-order-pay": "No order to pay",
  "home.notify.save-not-supported": "Temporary save feature not supported yet",
  "home.notify.no-order-save": "No order to save temporarily",
  "home.notify.scan-success": "Scan successful",
  "home.notify.updated": "Updated",
  "home.notify.success": "Success",
  "home.notify.update-failed": "Update failed",
  "home.notify.error": "Error",
  "home.notify.no-permission":
    "You do not have permission to use this feature!",
  "general.setting": "Settings",
  "general.error.invalid-data": "Invalid data",
  "home.summary.no-info": "No information",
  "home.summary.no-setup": "Not set up",
  "home.summary.no-data": "No data available...",
  "home.btn.save-all": "Save all changes",
  "home.notify.transfer-success": "Table transfer successful",
  "home.notify.transfer-failed": "Table transfer failed",
  "home.notify.save-error":
    "Error occurred while saving discount/tax/fee details",
  "home.notify.status-error": "Error occurred while updating order status.",

  /* Shortcuts */
  "home.shortcut.f1": "Open Guide",
  "home.shortcut.f2": "Search Product",
  "home.shortcut.f3": "Product Management",
  "home.shortcut.f4": "Discount / Tax / Fee",
  "home.shortcut.f8": "Print Draft Invoice",
  "home.shortcut.f9": "Order / Payment",
  "home.shortcut.f10": "Save Draft Invoice",
  "home.shortcut.title": "Keyboard Shortcuts",
  "home.shortcut.close": "Press ESC to close",

  /* Provisional Invoice (Drafts) */
  "home.provisional.title": "Draft Invoices",
  "home.provisional.empty": "No draft invoices saved!",
  "home.provisional.btn-reorder": "RE-ORDER",
  "home.provisional.btn-cancel": "CANCEL",
  "home.provisional.counter": "Counter",

  /* Order History & Return */
  "home.history.title": "Order History Lookup",
  "home.history.search": "Search",
  "home.history.empty": "No orders found in the selected period.",
  "home.history.loading": "Loading data...",
  "home.history.error": "Error loading data. Please try again.",
  "home.history.invoice": "Invoice",
  "home.history.sku": "SKU",
  "home.history.btn-return": "Return",
  "home.history.confirm-return": "Are you sure you want to return this item?",
  "home.history.return-success": "Return and stock restoration successful.",

  /* Common Labels & Options */
  "home.label.product-name": "Product Name",
  "home.label.quantity": "Quantity",
  "home.label.price": "Price",
  "home.label.total": "Total",
  "home.label.delete": "Delete",
  "home.label.customer-name": "Customer Name",
  "home.label.phone": "Phone Number",
  "home.btn.order-now": "Order Now !",
  "home.msg.preview-detail": "Preview Detail",

  "home.option.payment.cash": "Cash",
  "home.option.payment.transfer": "Bank Transfer",
  "home.option.payment.card": "Credit Card",
  "home.option.payment.credit": "Debt",
  "home.option.shipping.select": "Select Carrier",
  "home.placeholder.staff": "Sales Staff",
  "home.placeholder.shipping": "Shipping Carrier",
  "home.placeholder.payment": "Payment Method",

  /* Analytics */
  "analytics.tabs.overview": "Overview",
  "analytics.tabs.products": "Products",
  "analytics.tabs.materials": "Materials",
  "analytics.tabs.customers": "Customers",
  "analytics.tabs.staff": "Staff",
  "analytics.tabs.debt": "Suppliers",
  "analytics.tabs.payment": "Payment",
  "analytics.tabs.other": "Other",

  "analytics.summary.total_products": "Total Products",
  "analytics.summary.products_with_variants": "Products with Variants",
  "analytics.summary.products_on_sale": "On Sale",
  "analytics.summary.products_without_recipe": "Without Recipe",
  "analytics.summary.unsold_products_count": "Unsold Products",
  "analytics.summary.avg_profit_margin": "Avg Profit Margin",
  "analytics.summary.total_materials": "Total Materials",
  "analytics.summary.low_stock": "Low Stock (<20% | <10%)",
  "analytics.summary.unassigned_materials": "Unassigned Materials",
  "analytics.summary.total_inventory_value": "Total Level Value",
  "analytics.summary.import_value": "Import Value",
  "analytics.summary.import_count": "Import Count",
  "analytics.summary.total_new_customers": "New Customers",
  "analytics.summary.total_returning_customers": "Returning Customers",
  "analytics.summary.total_spent": "Total Spent",
  "analytics.summary.avg_spent_per_customer": "Avg Spent/Customer",
  "analytics.summary.customer_debt": "Customer Debt",
  "analytics.summary.return_rate": "Return Rate",
  "analytics.summary.total_sales": "Total Sales",
  "analytics.summary.total_bills": "Total Bills",
  "analytics.summary.total_items": "Total Items",
  "analytics.summary.avg_revenue_per_hour": "Avg Revenue/Hour",
  "analytics.summary.active_staff": "Active Staff",

  "analytics.table.top_selling": "TOP SELLING PRODUCTS",
  "analytics.table.top_slow": "SLOW MOVING PRODUCTS",
  "analytics.table.payment_method": "PAYMENT METHODS",

  "analytics.error.agency": "Error fetching AGENCY data",
  "analytics.error.activity": "Error fetching ACTIVITY data",
  "analytics.error.outcome": "Error fetching OUTCOME data",
  "analytics.error.income": "Error fetching INCOME data",
  "analytics.error.sold_products": "Error fetching SOLD PRODUCTS data",
  "analytics.error.material_import": "Error fetching IMPORTED MATERIALS data",
  "analytics.error.debt": "Error fetching DEBT data",
  "analytics.error.material_usage": "Error fetching MATERIAL USAGE data",
  "analytics.error.table": "Error fetching TABLE data",
  "analytics.error.payment_method": "Error fetching PAYMENT METHOD data",
  "analytics.error.top_products": "Error fetching TOP PRODUCTS data",
  "analytics.error.best_selling": "Error fetching BEST SELLING PRODUCTS data",
  "analytics.error.customer": "Error fetching CUSTOMER data",
  "analytics.error.staff": "Error fetching STAFF data",
  "analytics.error.booking": "Error fetching BOOKING data",
  "analytics.error.materials": "Error fetching MATERIALS data",
  "analytics.dashboards.outcome": "OUTCOME",
  "analytics.dashboards.income": "INCOME",
  "analytics.dashboards.stock-log": "STOCK LOG",
  "analytics.dashboards.make-product": "MAKE PRODUCT",
  "analytics.dashboards.order-table": "Table Statistics",
  "analytics.dashboards.debt": "DEBT",
  "analytics.chart.income": "Revenue",
  "analytics.chart.outcome": "Expense",
  "analytics.filter.my_store": "My Store",
  "analytics.filter.all": "All",
  "analytics.filter.today": "Today",
  "analytics.upgrade.notification":
    "Your current plan only allows viewing today's report. Please upgrade to view history!",
  "analytics.upgrade.title": "Plan Limit",
  "analytics.profit": "Profit",
  "analytics.imported-stock-quantity": "Imported Stock Quantity",
  "analytics.total-stock-value": "Total Stock Value",
  "analytics.pnl.title": "Detailed P&L Report",
  "analytics.pnl.revenue-header": "💰 REVENUE",
  "analytics.pnl.sales-revenue": "Sales Revenue",
  "analytics.pnl.gross-revenue": "Gross Revenue",
  "analytics.pnl.discount": "(-) Discount",
  "analytics.pnl.tax": "(+) Tax",
  "analytics.pnl.other-fees": "(+) Other Fees",
  "analytics.pnl.other-income": "Other Income",
  "analytics.pnl.total-revenue": "TOTAL REVENUE",
  "analytics.pnl.cost-header": "📉 EXPENSES",
  "analytics.pnl.cogs": "Cost of Goods Sold (COGS)",
  "analytics.pnl.material-cost": "Material Cost",
  "analytics.pnl.gross-profit": "Gross Profit",
  "analytics.pnl.operating-expenses": "Operating Expenses",
  "analytics.pnl.fixed-costs": "Fixed Costs (Electricity, Water, Staff...)",
  "analytics.pnl.gift-cost": "🎁 Promotional Gift Cost",
  "analytics.pnl.total-expenses": "TOTAL EXPENSES",
  "analytics.pnl.net-profit": "💰 NET PROFIT",
  "analytics.pnl.net-loss": "📉 NET LOSS",

  "analytics.table.stt": "No.",
  "analytics.table.name": "Name",
  "analytics.table.quantity": "Quantity",
  "analytics.table.total": "Total",
  "analytics.table.price": "Price",
  "analytics.table.product": "Product",
  "analytics.table.sold_quantity": "Sold Qty",
  "analytics.table.revenue": "Revenue",
  "analytics.table.cogs": "COGS",
  "analytics.table.profit": "Profit",
  "analytics.table.ratio": "Ratio",
  "analytics.table.material": "Material",
  "analytics.table.stock": "Stock",
  "analytics.table.total_import": "Total Import",
  "analytics.table.value": "Value",
  "analytics.table.remaining": "Remaining",
  "analytics.table.gift": "Gift",
  "analytics.table.discount": "Discount",
  "analytics.table.method": "Method",
  "analytics.table.order_count": "Orders",
  "analytics.table.product_count": "Products",
  "analytics.table.total_amount": "Total Amount",
  "analytics.table.stock_status.critical": "Critical",
  "analytics.table.stock_status.warning": "Warning",
  "analytics.table.stock_status.normal": "Normal",
  "analytics.table.unit_price": "Unit Price",

  "analytics.staff.rank": "Rank",
  "analytics.staff.name": "Staff",
  "analytics.staff.position": "Position",
  "analytics.staff.sales": "Sales",
  "analytics.staff.bill_count": "Orders",
  "analytics.staff.product_count": "Products",
  "analytics.staff.revenue_per_hour": "Rev/h",
  "analytics.staff.commission": "Commission",
  "analytics.staff.bonus": "Bonus",
  "analytics.staff.overtime": "Overtime (h)",
  "analytics.staff.advance": "Advance",
  "analytics.staff.fined": "Fine",
  "analytics.staff.no_data": "No staff data available",
  "analytics.staff.top": "🏆 Top",

  "analytics.booking.title": "Booking Statistics",
  "analytics.booking.summary.total": "Total Bookings",
  "analytics.booking.summary.pending": "Pending",
  "analytics.booking.summary.confirmed": "Confirmed",
  "analytics.booking.summary.completed": "Completed",
  "analytics.booking.summary.cancelled": "Cancelled",
  "analytics.booking.summary.guests": "Total Guests",
  "analytics.booking.source.phone": "Phone",
  "analytics.booking.source.walk_in": "Walk-in",
  "analytics.booking.source.website": "Website",
  "analytics.booking.source.app": "App",
  "analytics.booking.source.facebook": "Facebook",
  "analytics.booking.source.zalo": "Zalo",
  "analytics.booking.table.stt": "#",
  "analytics.booking.table.date": "Date",
  "analytics.booking.table.time": "Time",
  "analytics.booking.table.customer": "Customer",
  "analytics.booking.table.phone": "Phone",
  "analytics.booking.table.party_size": "Guests",
  "analytics.booking.table.status": "Status",
  "analytics.booking.table.source": "Source",
  "analytics.booking.table.no_data": "No booking data available",

  "analytics.customer.name": "Customer",
  "analytics.customer.phone": "Phone",
  "analytics.customer.order_count": "Orders",
  "analytics.customer.products_purchased": "Products Purchased",
  "analytics.customer.total_spent": "Total Spent",
  "analytics.customer.point": "Points",
  "analytics.customer.debt": "Debt",
  "analytics.customer.created_at": "Created At",
  "analytics.customer.no_data": "No data available",

  "chat.permission_denied": "You do not have permission to use this feature!",
  "chat.internal_msg": "General Messages",
  "chat.search_placeholder": "Search",
  "chat.max_files_error": "Maximum 3 files allowed",
  "chat.no_file_guest_error": "Sending files to guests is not supported",
  "chat.file_size_error": "Maximum size 100 MB / file",

  "chat.facebook.messenger": "Messenger",
  "chat.facebook.syncing": "Syncing messages from Facebook...",
  "chat.facebook.synced_success": "Synced {count} conversations",
  "chat.facebook.sync_failed": "Sync failed",
  "chat.facebook.sync_error": "Error syncing messages",
  "chat.facebook.all_pages": "All Pages",
  "chat.facebook.customer": "Customer",
  "chat.facebook.no_messages": "No messages yet",
  "chat.facebook.outside_24h": "Outside 24h - Select Message Tag to send:",
  "chat.facebook.select_tag": "-- Select Tag --",
  "chat.facebook.tag.human_agent": "Customer Support (7 days)",
  "chat.facebook.tag.post_purchase": "Order Update",
  "chat.facebook.tag.account_update": "Account Update",
  "chat.facebook.tag.event_update": "Event Update",
  "chat.facebook.send": "Send",
  "chat.facebook.send_file_error": "Cannot send message",
  "chat.facebook.sync_btn": "Refresh",
  "chat.facebook.processing": "Loading...",
  "chat.facebook.search_customer": "Search customers...",
  "chat.facebook.send_error": "Cannot send file",
  "chat.facebook.token_expired_title": "⚠️ Facebook token expired! Messages cannot be sent/received.",
  "chat.facebook.token_reconnect_btn": "Reconnect Facebook",
  "fb.comment.no-posts": "No posts found",
  "fb.comment.no-posts-hint": "Data is automatically loaded from Fanpage",
  "fb.comment.loading-comments": "Loading comments...",
  "fb.comment.no-comments": "No comments found",
  "fb.comment.select-post": "Select a post to view comments",
  "fb.comment.post-detail": "Post Details",
  "fb.comment.view-on-fb": "View on Facebook",
  "fb.comment.like": "Like",
  "fb.comment.reply": "Reply",
  "fb.comment.hide": "Hide",
  "fb.comment.unhide": "Unhide",
  "fb.comment.hidden": "Hidden",
  "fb.comment.reply-placeholder": "Enter reply...",
  "fb.comment.edit": "Edit",
  "fb.comment.delete": "Delete",
  "fb.comment.filter-all": "All",
  "fb.comment.filter-unread": "Unread",
  "fb.comment.filter-unreplied": "Unreplied",
  "fb.comment.status-replied": "Replied",
  "fb.comment.loading-posts": "Loading posts...",
  "fb.comment.no-pages-desc": "No Fanpages connected to VMASS yet. Please use Fanpage Access Tokens to start managing comments.",
  "fb.comment.unknown": "Unknown",
  "fb.comment.page-badge": "Page",
  "fb.comment.unread": "Unread",
  "fb.comment.error-hide": "Error hiding comment",
  "fb.comment.error-delete": "Error deleting comment",
  "fb.comment.error-edit": "Error editing comment",
  "fb.comment.error-like": "Error liking comment",
  "fb.comment.error-sync": "Error loading data",
  "fb.comment.delete-confirm": "Are you sure you want to delete this comment?",

  "topnav.search.placeholder.default": "Search...",
  "topnav.search.placeholder.dashboard": "Search products...",
  "topnav.search.placeholder.product": "Search products...",
  "topnav.search.placeholder.stock": "Search materials...",
  "topnav.search.placeholder.customer": "Search customers...",
  "topnav.search.placeholder.order": "Search orders...",
  "topnav.search.placeholder.staff": "Search staff...",
  "topnav.search.placeholder.promotion": "Search promotions...",
  "topnav.search.placeholder.provider": "Search providers...",
  "topnav.search.placeholder.income": "Search income...",
  "topnav.search.placeholder.outcome": "Search expenses...",
  "topnav.search.placeholder.cash-flow": "Search income and expenses...",
  "topnav.search.placeholder.treasury": "Search assets...",
  "topnav.search.placeholder.warehouse_export": "Search export slips...",
  "topnav.search.placeholder.warehouse_import": "Search import slips...",
  "topnav.search.placeholder.warehouse_transfer": "Search transfer slips...",
  "topnav.search.placeholder.todo": "Search tasks...",

  "topnav.menu.account": "Account",
  "topnav.menu.cashier": "Cashier",
  "topnav.menu.waiter": "Waiter",
  "topnav.menu.kitchen": "Kitchen / Bartender",
  "topnav.menu.settings": "Settings",
  "topnav.menu.logout": "Logout",

  "topnav.noti.todo.message": "Check 'To Do' now",
  "topnav.noti.todo.title": "Reminder",
  "topnav.noti.order.message": "New product ordered. Check now!",
  "topnav.noti.stock_down.message": "Material level is low!",
  "topnav.noti.stock_down.title": "Suggestion to buy more",

  "page.heading.excel": "Excel",
  "page.heading.add_from_image": "Add products from image",
  "page.heading.create_quantitative": "Create quantitative",
  "page.heading.add_bulk": "Add products in bulk",
  "page.heading.add_quantitative_one": "Create quantitative",
  "page.heading.best_seller": "Recommended",
  "page.heading.un_best_seller": "Un-recommend",
  "page.heading.mark_best_seller": "Mark as recommended",
  "page.heading.soft_hide_mixed": "Hide/Show products",
  "page.heading.soft_hide_show": "Show products",
  "page.heading.soft_hide_hide": "Hide products",
  "page.heading.print_sticker": "Print stickers",
  "page.heading.import_excel_title": "Import data from excel file",
  "page.heading.import_result": "Import Results",
  "page.heading.import_btn": "Import",
  "page.heading.error.limit":
    "Your current plan has reached the product limit. Please upgrade to add more!",
  "page.heading.error.limit_title": "Plan Limit",

  "product.confirm.delete": "Are you sure you want to delete these products?",
  "product.error.invalid-data": "Invalid data",
  "product.error.variant-required": "Variants require price and quantity",

  "product.multi.name": "Product Name",
  "product.multi.barcode": "Barcode",
  "product.multi.sku": "SKU",
  "product.multi.unit": "Unit",
  "product.multi.category": "Category",
  "product.multi.hot": "Hot",
  "product.multi.price": "Price",
  "product.multi.price_sale": "Sale Price",
  "product.multi.active_sale": "Sale On",
  "product.multi.recipe": "Recipe",
  "product.multi.variant": "Variant",
  "product.multi.image": "Image",
  "product.multi.soft_hide": "Hide",

  "product.variant.default": "Default Attribute",
  "product.variant.coming_soon": "Coming soon from {date}",
  "product.variant.starts_from": "Starts from {date}",
  "product.variant.name": "Variant Name",
  "product.variant.sku": "SKU",
  "product.variant.price": "Price",
  "product.variant.stock": "Stock",
  "product.variant.promo_time": "Promo Time",
  "product.variants": "Variants",

  "customer.export.stt": "No.",
  "customer.export.name": "Customer Name",
  "customer.export.phone": "Phone",
  "customer.export.email": "Email",
  "customer.export.address": "Address",
  "customer.export.used": "Used Count",
  "customer.export.point": "Points",
  "customer.export.armorial": "Badge",
  "customer.export.tags": "Tags",
  "customer.export.debt": "Debt",
  "customer.export.total_spent": "Total Spent",
  "customer.export.created_at": "First Used",
  "customer.export.updated_at": "Updated At",
  "customer.export.filename": "Customer List",

  "stock.export.stt": "No.",
  "stock.export.id": "ID",
  "stock.export.name": "Material Name",
  "stock.export.sku": "SKU",
  "stock.export.unit": "Unit",
  "stock.export.category": "Category",
  "stock.export.warehouse": "Warehouse",
  "stock.export.min_stock_threshold": "Minimum Stock",
  "stock.export.batch_code": "Batch Code",
  "stock.export.storage_location": "Storage Location",
  "stock.export.stock_note": "Stock Note",
  "stock.export.price_new": "Import Price",
  "stock.export.inventory": "Inventory",
  "stock.export.total": "Total Amount",
  "stock.export.created_at": "Created At",
  "stock.export.updated_at": "Updated At",
  "stock.export.filename": "Material List",

  "income.export.stt": "No.",
  "income.export.name": "Income Name",
  "income.export.value": "Value",
  "income.export.address": "Address",
  "income.export.note": "Note",
  "income.export.created_at": "Created At",
  "income.export.statistic": "Statistic",
  "income.statistic.exclude": "Excluded",
  "income.statistic.include": "Included",
  "income.export.creator": "Creator",
  "income.export.filename": "Income List",

  "outcome.export.stt": "No.",
  "outcome.export.name": "Outcome Name",
  "outcome.export.value": "Value",
  "outcome.export.address": "Address",
  "outcome.export.note": "Note",
  "outcome.export.created_at": "Created At",
  "outcome.export.statistic": "Statistic",
  "outcome.statistic.exclude": "Excluded",
  "outcome.statistic.include": "Included",
  "outcome.export.creator": "Creator",
  "outcome.export.filename": "Outcome List",

  "todo.export.filename": "Todo List",
  "page.heading.excel.tooltip": "Download data to Excel file",
  "analytics.export.name": "Name",
  "analytics.export.quantity": "Quantity",
  "analytics.export.total_price": "Total Amount",
  "analytics.export.product": "Product",
  "analytics.export.revenue": "Revenue",
  "analytics.export.method": "Method",
  "analytics.export.order_count": "Order Count",
  "analytics.export.supplier": "Supplier",
  "analytics.export.customer": "Customer",
  "analytics.export.phone": "Phone",
  "analytics.export.spent": "Spent",
  "analytics.export.created_at": "Created At",
  "analytics.export.material": "Material",
  "analytics.export.unit": "Unit",
  "analytics.export.table": "Table",
  "analytics.export.discount": "Discount",
  "analytics.export.stock": "Stock",
  "analytics.export.min_stock": "Min Stock",
  "analytics.export.date": "Date",
  "analytics.export.time": "Time",
  "analytics.export.party_size": "Party Size",
  "analytics.export.status": "Status",
  "analytics.export.source": "Source",
  "analytics.export.sheet.sold_products": "Sold Products",
  "analytics.export.sheet.top_spenders": "Top Spenders",
  "analytics.export.sheet.imported_materials": "Imported Materials",
  "analytics.export.sheet.used_materials": "Used Materials",
  "analytics.export.sheet.booking": "Booking",
  "analytics.export.success": "Excel export successful!",

  /* AI Configuration */
  "settings.ai.default_persona": "You are a friendly customer support agent.",

  /* Upgrade */
  "upgrade.price.currency": "{price} VND",
  "upgrade.feature.billing": "Billing & Calculations",
  "upgrade.feature.print_invoice": "Invoice Printing",
  "upgrade.feature.accounts": "Staff Accounts",
  "upgrade.feature.sales": "Sales Management",
  "upgrade.feature.products": "Products & Inventory",
  "upgrade.value.products.free": "30 Products",
  "upgrade.value.products.basic": "Unlimited",
  "upgrade.value.unlimited": "Unlimited",
  "upgrade.time.1m": "1 Month",
  "upgrade.features": "Features",
  "make-product.select-or-create": "Select or create new",
  "make-product.unit": "Unit",
  "make-product.no-recipe": "This product has no recipe yet!",
  "make-product.cost-price": "Cost Price",
  "make-product.cost-ratio": "Cost / Price Ratio",
  "general.add": "Add",

  "stock.header.material_name": "Material Name",
  "stock.header.unit": "Unit",
  "stock.header.total_import": "Total Import",
  "stock.header.new_quantity": "New Quantity",
  "stock.header.inventory": "Inventory",
  "stock.header.below_20": "Below 20%",
  "stock.header.below_10": "Below 10%",
  "stock.header.true": "True",
  "stock.header.false": "False",

  "income.header.name": "Income Name",
  "income.header.payer": "Payer Name",
  "income.header.address": "Address",
  "income.header.amount": "Amount",
  "income.header.description": "Description",
  "income.header.status": "Status",
  "income.header.statistic": "Statistic",
  "income.header.creator": "Values Creator",
  "income.header.created_at": "Created At",

  "outcome.header.name": "Outcome Name",
  "outcome.header.receiver": "Receiver Name",
  "outcome.header.amount": "Amount",
  "outcome.header.description": "Description",
  "outcome.header.address": "Address",
  "outcome.header.status": "Status",
  "outcome.header.statistic": "Statistic",
  "outcome.header.creator": "Creator",
  "outcome.header.created_at": "Created At",

  "customer.header.name": "Customer Name",
  "customer.header.phone": "Phone",
  "customer.header.email": "Email",
  "customer.header.address": "Address",
  "customer.header.points": "Points",
  "customer.header.used_count": "Used Count",
  "customer.header.total_spent": "Total Spent",
  "customer.header.rank": "Rank",
  "customer.header.debt": "Debt",
  "customer.header.created_at": "First Used",
  "customer.header.updated_at": "Updated At",

  "provider.header.name": "Provider Name",
  "provider.header.phone": "Phone",
  "provider.header.email": "Email",
  "provider.header.address": "Address",
  "provider.header.total_import": "Total Import",
  "provider.header.paid": "Paid",
  "provider.header.remaining": "Remaining",

  "warehouse.transfer.header.item": "Transferred Item",
  "warehouse.transfer.header.quantity": "Transferred Quantity",
  "warehouse.transfer.header.price": "Transfer Price",
  "warehouse.transfer.header.description": "Description",
  "warehouse.transfer.header.status": "Status",
  "warehouse.transfer.header.sender": "Sender",
  "warehouse.transfer.header.phone": "Phone",
  "warehouse.transfer.header.carrier": "Carrier",
  "warehouse.transfer.header.carrier_phone": "Carrier Phone",
  "warehouse.transfer.header.destination": "To Warehouse",
  "warehouse.transfer.header.transport": "Transportation",
  "warehouse.transfer.header.shipping_cost": "Shipping Cost",
  "warehouse.transfer.header.creator": "Creator",
  "warehouse.transfer.header.created_at": "Created At",

  "warehouse.import.header.item": "Imported Item",
  "warehouse.import.header.unit": "Unit",
  "warehouse.import.header.quantity": "Import Quantity",
  "warehouse.import.header.price": "Import Price",
  "warehouse.import.header.status": "Status",
  "warehouse.import.header.importer": "Importer",
  "warehouse.import.header.phone": "Phone",
  "warehouse.import.header.address": "Address",
  "warehouse.import.header.created_at": "Created At",

  "warehouse.export.header.item": "Exported Item",
  "warehouse.export.header.quantity": "Export Quantity",
  "warehouse.export.header.price": "Export Price",
  "warehouse.export.header.status": "Status",
  "warehouse.export.header.description": "Description",
  "warehouse.export.header.creator": "Creator",
  "warehouse.export.header.created_at": "Created At",

  "treasury.header.name": "Asset Name",
  "treasury.header.value": "Value",
  "treasury.header.note": "Note",
  "treasury.header.statistic": "Statistic",
  "treasury.header.creator": "Creator",
  "treasury.header.created_at": "Created At",

  "modal.stock.stt": "No.",
  "modal.stock.sku": "SKU",
  "modal.stock.barcode": "Barcode",
  "modal.stock.supplier": "Supplier",
  "modal.stock.remaining": "Remaining",
  "modal.stock.expired": "Expiry Date",

  "table.import.sku": "SKU",
  "table.import.barcode": "Barcode",
  "table.import.price_sale": "Sale Price",
  "table.import.price_promotion": "Promotion Price",
  "table.import.apply_promotion": "Apply Promotion",
  "table.import.image": "Image",
  "table.import.image_sub": "Sub Image",
  "table.import.recommend": "Recommended",
  "table.import.hidden": "Hidden",
  "table.import.description": "Description",
  "table.import.size": "Size",
  "table.import.topping": "Topping",
  "table.import.ice": "Ice Amount",
  "table.import.sugar": "Sugar Level",
  "table.import.color": "Color",
  "table.import.material": "Material",
  "table.import.result": "Import Result",
  "table.import.reason": "Error Reason",

  "modal.product.stt": "#",
  "modal.product.barcode_enter": "Barcode (Enter)",
  "modal.product.unit": "Quantitative",
  "modal.product.combo": "Combo/Mfg",
  "modal.product.variant": "Variant",
  "modal.product.supplier": "Supplier",
  "modal.product.paid": "Paid",
  "modal.product.remaining": "Remaining",
  "modal.product.image": "Image",
  "modal.product.hot": "Hot",
  "modal.product.delete": "Delete",
  "modal.auto-generate": "Auto Generate",
  "modal.stock.confirm-import": "Confirm Import",
  "modal.add-row": "Add Row",
  "tooltip.not-for-combo": "Not applicable for Combo items",
  "tooltip.unit-hint":
    "Enter the smallest unit of this product, e.g., use Pack instead of Box",
  "tooltip.enable-combo":
    "Enable Quantitative Mode: Allows selecting multiple component ingredients (Combo/SX). Cost price and Import quantity will be calculated based on the recipe instead of direct input.",
  "label.create-new": "Create New",
  "label.select-or-create": "Select or create...",
  "label.enter-product-name": "Enter product name...",
  "label.enter-barcode": "Enter barcode...",
  "label.select-create-provider": "Select/Create Provider...",
  "menu.product.recommended": "Recommended Products",
  "menu.product.discount": "Discount",
  "menu.product.recipe": "Recipe",
  "menu.stock.inventory": "Inventory",
  "menu.stock.less-than-50": "Less than 50%",
  "menu.stock.less-than-20": "Less than 20%",
  "menu.stock.less-than-10": "Less than 10%",
  "menu.stock.cost-price": "Cost Price",
  "menu.stock.cost-price-done": "Cost Price Entered",
  "menu.stock.cost-price-not-yet": "Cost Price Missing",
  "menu.stock.import-time": "Import Time",
  "menu.stock.recent-5-days": "Recent 5 days",
  "menu.stock.recent-10-days": "Recent 10 days",
  "todo.tasks": "Tasks",
  "todo.today": "Today",
  "todo.this-week": "This Week",
  "todo.this-month": "This Month",
  "todo.upcoming": "Upcoming",
  "todo.next-1-hour": "Next 1 Hour",
  "todo.next-3-hours": "Next 3 Hours",
  "todo.next-6-hours": "Next 6 Hours",
  "todo.past": "Past",
  "todo.past-7-days": "Past 7 Days",
  "todo.past-30-days": "Past 30 Days",
  "todo.past-6-months": "Past 6 Months",
  "chat.broadcast-all-stores": "Send to all stores",
  "menu.customer.debt": "Debt",
  "menu.customer.no-debt": "No Debt",
  "menu.customer.have-debt": "Have Debt",
  "menu.customer.badge": "Badge",
  "menu.customer.no-badge": "No Badge",
  "menu.customer.bronze": "Bronze",
  "menu.customer.gold": "Gold",
  "menu.customer.platinum": "Platinum",
  "menu.customer.tags": "Tags",
  "menu.provider.transaction": "Transaction",
  "menu.provider.paid-all": "Paid All",
  "menu.provider.debt": "Debt",
  "menu.provider.no-transaction": "No Transaction",
  "menu.provider.products": "Products",
  "menu.staff.work-status": "Work Status",
  "menu.staff.working": "Working",
  "menu.staff.quit": "Quit",
  "menu.staff.position": "Position",
  "price.under-1m": "Under 1 Million",
  "price.1m-to-10m": "1 Million - 10 Million",
  "price.over-10m": "Over 10 Million",
  "menu.finance.include-statistics": "Include in Statistics",
  "menu.finance.price-range": "Price Range",
  "menu.finance.creator": "Creator",
  "menu.stock.status": "Status",
  "status.draft": "Draft",
  "status.in-progress": "In Progress",
  "status.completed": "Completed",
  "menu.stock.time": "Time",
  "general.this-month": "This Month",
  "general.last-month": "Last Month",
  "menu.audit.result": "Result",
  "menu.audit.has-discrepancy": "Has Discrepancy",
  "status.pending": "Pending",
  "status.approved": "Approved",
  "status.rejected": "Rejected",
  "menu.disposal.type": "Disposal Type",
  "disposal.expired": "Expired",
  "disposal.damaged": "Damaged",
  "menu.stock.statistics": "Statistics",
  "menu.stock.total-tickets": "Total Tickets",
  "menu.stock.total-value": "Total Value",
  "status.processing": "Processing",
  "menu.warehouse.status": "Status",
  "menu.warehouse.quantity-range": "Quantity",
  "menu.warehouse.unit": "Unit",
  "quantity.under-10": "Under 10",
  "quantity.10-to-50": "10 - 50",
  "quantity.over-50": "Over 50",

  "table.import.success": "Import Successful",
  "table.import.failed": "Failed",
  "table.import.error_reason": "Error Reason",

  "modal.alert.min-one-material": "Please enter at least one material.",
  "modal.alert.check-required": "Please check the required fields:\n\n",
  "modal.alert.missing-unit": 'Row {index} - "{name}": Missing unit',
  "modal.alert.price-must-positive":
    'Row {index} - "{name}": Price must be > 0',
  "modal.alert.quantity-must-positive":
    'Row {index} - "{name}": Quality must be > 0',
  "modal.alert.barcode-duplicate-list":
    "Duplicate Barcode in the list. Please check again.",
  "modal.alert.barcode-duplicate-db":
    'Barcode "{barcode}" already exists for material "{name}". Please use another code.',
  "chat.all_messages": "All Messages",

  "unit.placeholder.cafe": "Cup, glass, plate...",
  "unit.placeholder.fashion": "Piece, pair, set...",
  "unit.placeholder.cosmetics": "Bottle, tube, jar...",
  "unit.placeholder.retail": "Piece, pack, box, kg...",
  "unit.placeholder.grocery": "Piece, pack, box, kg...",
  "unit.placeholder.pharmacy": "Box, blister, pill, tube...",
  "unit.placeholder.electronics": "Piece, piece, set, carton...",
  "unit.placeholder.spa": "Session, service, turn, item...",
  "unit.placeholder.default": "Piece, box, pack...",

  "product.price.cost": "Cost Price",
  "product.promotion-price": "Promotion Price",

  "general.all": "All",
  "general.yes": "Yes",
  "general.no": "No",

  "modal.stock.stt": "No.",
  "modal.stock.sku": "SKU",
  "modal.stock.barcode": "Barcode",
  "modal.stock.supplier": "Supplier",
  "modal.stock.remaining": "Remaining",
  "modal.stock.expired": "Expiry Date",
  "modal.stock.confirm-import": "Confirm Import",
  "modal.add-row": "Add Row",
  "modal.auto-generate": "Auto Generate",

  "tooltip.unit-hint": "Enter unit (e.g., kg, box...)",
  "tooltip.not-for-combo": "Not applicable for Combo items",
  "tooltip.enable-combo": "Enable Combo (Quantitative)",

  "label.select-or-create": "Select or create...",
  "label.create-new": "Create new",
  "label.select-create-provider": "Select or create supplier...",
  "label.enter-barcode": "Enter barcode",
  "label.enter-product-name": "Enter product name",

  "modal.product.combo": "Combo",
  "modal.product.paid": "Paid",
  "page.heading.export-filename": "Product List",
  "product.alert.create-variant-missing-unit":
    "Please enter Unit before creating variants.",
  "product.alert.sync-stock-confirm":
    "Import quantity in main form ({mainFormQuantity}) differs from total variant quantity ({totalVariantQuantity}).\n\nDo you want to update main form quantity to {totalVariantQuantity}?",
  "product.validation.missing-name": "Product Name",
  "product.validation.missing-category": "Category",
  "product.validation.missing-price": "Price",
  "product.validation.missing-unit": "Unit",
  "product.validation.missing-import-quantity": "Import Quantity",
  "product.validation.missing-cost-price": "Cost Price",
  "product.validation.barcode-duplicate-list":
    'Barcode "{barcode}" is duplicated in this list',
  "product.validation.barcode-duplicate-system":
    'Barcode "{barcode}" already exists in the system',
  "product.alert.validation-check-info":
    "Please check the information again:\n",
  "label.create-new-value": 'Create "{value}"',
  "product.template.default": "Product_Import_Template.xlsx",
  "product.template.cafe": "Cafe_Product_Template.xlsx",
  "product.template.restaurant": "Restaurant_Product_Template.xlsx",
  "product.template.fashion": "Fashion_Product_Template.xlsx",
  "product.template.retail": "Retail_Product_Template.xlsx",
  "product.template.cosmetics": "Cosmetics_Product_Template.xlsx",

  VD: "Eg",
  "analytics.export.stt": "No.",
  "analytics.export.total": "Total",
  "analytics.update": "Update Analysis",
  "product.btn-add": "Add Product",
  "product.tab.add-multiple": "Add Multiple",
  "product.tab.add-one": "Add One",
  "settings.invoice.process-3-old": "Process 3 (Old)",
  "settings.invoice.process-4-old": "Process 4 (Old)",

  /* Missing Keys Added */
  "todo.detail": "Detail",
  "todo.cancel": "Cancel",
  "todo.submit": "Submit",
  "todo.status": "Status",
  "todo.all-tasks": "All Tasks",
  "todo.pending-tasks": "Pending Tasks",
  "todo.completed-tasks": "Completed Tasks",
  "todo.categories": "Categories",
  "todo.labels": "Labels",
  "menu.charts": "Charts",
  "menu.chat": "Chat",
  "menu.survey": "Survey",
  "input.to": "To",
  "input.email": "Enter email",
  "product.name": "Product Name",
  "modal.alert.warning": "Warning",
  "general.done": "Done",
  "general.not-yet": "Not Yet",
  "product.add.quantity": "Add Quantity",
  "user-staff.date_start": "Start Date",
  "user-staff.date_end": "End Date",
  "general.other": "Other",
  "stock.inventory": "Inventory",
  "stock.total-import": "Total Import",

  "settings.email.placeholder.gmail-email": "Enter Gmail",
  "settings.email.placeholder.smtp-email": "Enter SMTP Email",
  "profile.edit": "Edit Profile",
  "menu.blank-page": "Blank Page",
  "action.success": "Success",
  "promotion-discount-add": "Add Discount Code",
  "settings.ai.save-btn": "Save AI Config",
  "settings.partner.env.test-label": "Test Environment",
  "chat.files": "Files",
  "chat.filters": "Filters",
  "chat.unread_only": "Unread Only",
  "chat.tags": "Tags",
  "chat.tag_important": "Important",
  "chat.tag_pending": "Pending",
  "chat.tag_customer": "Customer",
  "chat.tag_new_lead": "New Lead",
  "chat.tag_closed": "Closed",
  "invoice.tab.einvoice": "E-Invoice",
  "einvoice.list.title": "E-Invoice List",
  "einvoice.status.draft": "Draft",
  "einvoice.status.issued": "Issued",
  "einvoice.status.signed": "Signed",
  "einvoice.status.sent": "Sent",
  "einvoice.status.cancelled": "Cancelled",
  "einvoice.status.error": "Error",
  "einvoice.status.processing": "Processing",
  "einvoice.action.view-pdf": "View PDF",
  "einvoice.action.download-pdf": "Download PDF",
  "einvoice.action.send-email": "Send Email",
  "einvoice.action.cancel": "Cancel Invoice",
  "einvoice.action.check-status": "Check Status",
  "einvoice.correction.adjust": "Adjust",
  "einvoice.correction.replace": "Replace",
  "einvoice.correction.edit-draft": "Edit SePay draft",
  "einvoice.correction.modal-adjust-title": "SePay adjustment invoice",
  "einvoice.correction.modal-replace-title": "SePay replacement invoice",
  "einvoice.correction.submit": "Send to SePay",
  "einvoice.mapping.preview": "VMASS mapping preview",
  "einvoice.mapping.applied": "Applied",
  "einvoice.mapping.pending": "Pending apply",
  "einvoice.mapping.conflict": "Conflict; create a new document",
  "einvoice.mapping.failed": "Technical failure; will retry",
  "einvoice.mapping.inventory": "Invoice inventory",
  "einvoice.mapping.inventory-applied": "Ingredients: {restored} restore, {deducted} deduct operations; variants: {variantsRestored} restored, {variantsDeducted} deducted",
  "einvoice.correction.save-draft": "Save draft at SePay",
  "einvoice.correction.issue-now": "Issue now",
  "einvoice.action.issue-official": "Issue Official",
  "einvoice.action.reissue": "Re-issue",
  "einvoice.cancel.reason": "Cancel Reason",
  "einvoice.email.placeholder": "Enter recipient email",
  "einvoice.alert.cancel-confirm":
    "Are you sure you want to cancel this invoice?",
  "einvoice.alert.email-success": "Email sent successfully!",
  "einvoice.action.edit": "Edit Invoice",
  "einvoice.edit.title": "Edit Invoice Details",
  "einvoice.edit.customer-name": "Company / Buyer Name",
  "einvoice.edit.email": "Invoice Email",
  "einvoice.edit.payment-method": "Payment Method",
  "einvoice.edit.note": "Notes",
  "einvoice.edit.placeholder.customer-name": "Company name or customer full name",
  "einvoice.edit.placeholder.tax-id": "Business tax ID number",
  "einvoice.edit.placeholder.address": "Business registration address",
  "einvoice.edit.placeholder.email": "email@company.com",
  "einvoice.edit.placeholder.phone": "Phone number for invoice delivery",
  "einvoice.edit.placeholder.note": "Additional notes on invoice",
  "button.save-changes": "Save Changes",
  "einvoice.notification.status-updated": "Invoice status updated",
  "einvoice.notification.email-required": "Please enter an email address",
  "einvoice.notification.cancel-reason-required": "Please enter a cancellation reason",
  "einvoice.notification.cancel-success": "Invoice cancelled successfully",
  "einvoice.notification.issue-official-success": "Official invoice issued successfully",
  "einvoice.notification.customer-name-required": "Please enter company/buyer name",
  "einvoice.notification.update-success": "Invoice information updated successfully",
  "einvoice.notification.missing-contact-info": "Invoice is missing Email and Phone. Please select 'Edit Invoice' to add them before re-issuing.",

  /* Table Headers - E-Invoice */
  "table.invoice-no": "Invoice No",
  "table.customer": "Customer",
  "table.date": "Date",
  "table.total": "Total",
  "table.status": "Status",
  "table.action": "Action",
  "table.no-data": "No data",
  "button.refresh": "Refresh",
  "button.cancel": "Cancel",
  "einvoice.checkbox.issue": "Issue E-Invoice",
  "einvoice.success.issued": "E-Invoice issued successfully",
  "einvoice.error.issue-failed": "Failed to issue E-Invoice",
  "table.phone": "Phone",
  "table.address": "Address",
  "table.email": "Email",
  "table.discount": "Discount",
  "table.payment_method": "Payment Method",
  "table.note": "Note",
  "table.tax": "Tax ID",
  "settings.einvoice.sepay-client-id": "Client ID",
  "settings.einvoice.sepay-client-secret": "Client Secret",
  "settings.einvoice.sepay-template-code": "Invoice Template Code",
  "settings.einvoice.automation": "Automation Configuration",
  "settings.einvoice.auto-issue":
    "Always tick 'Issue Invoice' checkbox (Default: Off)",
  "settings.einvoice.auto-draft":
    "Always issue draft invoice when not selected (Default: On)",
  "settings.email.placeholder.gmail-email": "Enter Gmail",
  "settings.email.placeholder.smtp-email": "Enter SMTP Email",
  "settings.einvoice.title": "E-Invoice",
  "settings.einvoice.save-success": "Configuration saved successfully",
  "settings.einvoice.save-error": "Error saving configuration",
  "settings.einvoice.test-success": "Connection successful",
  "settings.einvoice.test-fail": "Connection failed",
  "settings.email.save-success": "Email configuration saved successfully",
  "settings.email.save-error": "Error saving email configuration",
  "settings.email.test-success": "Test email sent successfully",
  "settings.email.test-error": "Error sending test email",
  /* Shopee Management Page */
  "menu.ecommerce": "E-Commerce",
  "menu.shopee": "Shopee",
  "menu.tiktok-shop": "TikTok Shop",
  "menu.lazada": "Lazada",
  "menu.tiki": "Tiki",
  "ecommerce.coming-soon": "Coming Soon",
  "ecommerce.coming-soon-desc": "This feature is under development. We will support this platform soon!",
  "shopee.tab.connection": "Connection",
  "shopee.tab.orders": "Orders",
  "shopee.tab.products": "Products",
  "shopee.tab.inventory": "Inventory",
  "shopee.connection.title": "Shopee Shop Connection",
  "shopee.connection.desc": "Connect your Shopee shops to sync orders, products and inventory.",
  "shopee.connect.btn": "Connect new Shop",
  "shopee.connect.error": "Error connecting to Shopee",
  "shopee.disconnect.btn": "Disconnect",
  "shopee.disconnect.confirm": "Are you sure you want to disconnect this shop?",
  "shopee.disconnect.success": "Shop disconnected successfully",
  "shopee.disconnect.error": "Error disconnecting shop",
  "shopee.oauth.success": "Shopee shop connected successfully.",
  "shopee.oauth.error.missing-params": "Shopee did not return all required authorization details.",
  "shopee.oauth.error.invalid-state": "The Shopee connection session is invalid or expired. Please try again.",
  "shopee.oauth.error.not-configured": "Shopee Partner credentials are not configured.",
  "shopee.oauth.error.shop-already-connected": "This Shopee shop is connected to another VMASS account.",
  "shopee.oauth.error.callback-failed": "The Shopee connection could not be completed. Please try again.",
  "shopee.oauth.error.upgrade-required": "Upgrade your plan to use the Shopee integration.",
  "shopee.oauth.error.generic": "Shopee rejected the connection request. Please try again.",
  "shopee.no-shop": "No Shopee shop connected. Click 'Connect new Shop' to get started.",
  "shopee.select-shop": "Select shop",
  "shopee.table.name": "Shop Name",
  "shopee.table.id": "Shop ID",
  "shopee.table.region": "Region",
  "shopee.table.token-expires": "Token Status",
  "shopee.table.connected": "Connected Date",
  "shopee.token.expired": "Expired",
  "shopee.token.active": "Active",
  "shopee.orders.filter.all": "All Status",
  "shopee.orders.sync-btn": "Sync from Shopee",
  "shopee.orders.bulk-sync": "Sync all to VMASS",
  "shopee.orders.sync.error": "Error syncing orders from Shopee",
  "shopee.orders.sync-to-bill": "Sync to VMASS",
  "shopee.orders.sync-bill.error": "Error syncing order to billing system",
  "shopee.orders.load.error": "Error loading orders",
  "shopee.orders.empty": "No orders found. Click 'Sync from Shopee' to fetch orders.",
  "shopee.orders.col.sn": "Order #",
  "shopee.orders.col.status": "Status",
  "shopee.orders.col.buyer": "Buyer",
  "shopee.orders.col.amount": "Amount",
  "shopee.orders.col.date": "Date",
  "shopee.orders.col.synced": "Synced",
  "shopee.synced": "Synced",
  "shopee.not-synced": "Not synced",
  "shopee.products.mapped": "Product Mappings",
  "shopee.products.view-shopee": "View Shopee Products",
  "shopee.products.import-btn": "Import from Shopee",
  "shopee.products.load.error": "Error loading products from Shopee",
  "shopee.products.import.error": "Error importing products",
  "shopee.products.empty": "No product mappings found. Click 'Import from Shopee' to fetch products.",
  "shopee.products.col.name": "Product Name",
  "shopee.products.col.sku": "SKU",
  "shopee.products.col.price": "Price",
  "shopee.products.col.stock": "Stock",
  "shopee.products.col.vmass": "VMASS Link",
  "shopee.products.linked": "Linked",
  "shopee.products.not-linked": "Not linked",
  "shopee.products.map-btn": "Link",
  "shopee.products.map.success": "Product linked successfully",
  "shopee.products.map.error": "Error linking product",
  "shopee.products.map-modal.title": "Link Shopee Product to VMASS",
  "shopee.products.map-modal.select": "Select VMASS product",
  "shopee.products.map-modal.placeholder": "Choose a product",
  "shopee.products.map-modal.save": "Save",
  "shopee.cancel": "Cancel",
  "shopee.inventory.title": "Inventory Sync",
  "shopee.inventory.desc": "Push VMASS stock to Shopee for linked products.",
  "shopee.inventory.sync-btn": "Sync Inventory to Shopee",
  "shopee.inventory.sync.error": "Error syncing inventory",
  "shopee.inventory.no-linked": "No linked products. Link products in the Products tab first.",
  "shopee.inventory.col.shopee-stock": "Shopee Stock",
  "shopee.inventory.col.vmass-product": "VMASS Product",
  "shopee.inventory.col.sync-enabled": "Sync",
  "shopee.inventory.col.last-sync": "Last Synced",
  "shopee.logistics.ship-btn": "Ship",
  "shopee.logistics.track-btn": "Track",
  "shopee.logistics.ship.error": "Error arranging shipment",
  "shopee.logistics.track.error": "Error loading tracking info",
  "shopee.logistics.modal.title": "Logistics",
  "shopee.logistics.phone": "Phone",
  "shopee.logistics.address": "Address",
  "shopee.logistics.carrier": "Carrier",
  "shopee.logistics.tracking-no": "Tracking #",
  "shopee.logistics.arrange": "Arrange Shipment",
  "shopee.logistics.pickup-address": "Pickup address",
  "shopee.logistics.confirm-ship": "Confirm Shipment",
  "shopee.logistics.timeline": "Tracking Timeline",
  "shopee.logistics.no-tracking": "No tracking information available yet.",
  "shopee.tab.returns": "Returns",
  "shopee.tab.analytics": "Analytics",
  "shopee.tab.settings": "Settings",
  "shopee.tab.monitor": "Monitor",
  "shopee.returns.title": "Returns & Refunds",
  "shopee.returns.refresh": "Refresh",
  "shopee.returns.empty": "No return/refund requests.",
  "shopee.returns.col.sn": "Return #",
  "shopee.returns.col.order": "Order #",
  "shopee.returns.col.reason": "Reason",
  "shopee.returns.col.status": "Status",
  "shopee.returns.col.amount": "Refund Amount",
  "shopee.returns.col.date": "Date",
  "shopee.returns.col.buyer": "Buyer",
  "shopee.returns.accept": "Accept",
  "shopee.returns.dispute": "Dispute",
  "shopee.returns.load.error": "Error loading returns",
  "shopee.returns.detail.error": "Error loading return detail",
  "shopee.returns.detail.title": "Return Detail",
  "shopee.returns.confirm.prompt": "Are you sure you want to accept this return?",
  "shopee.returns.confirm.error": "Error confirming return",
  "shopee.returns.dispute.title": "Dispute Return",
  "shopee.returns.dispute.email": "Contact Email",
  "shopee.returns.dispute.reason": "Dispute Reason",
  "shopee.returns.dispute.submit": "Submit Dispute",
  "shopee.returns.dispute.success": "Dispute submitted successfully",
  "shopee.returns.dispute.error": "Error submitting dispute",
  "shopee.returns.buyer-note": "Buyer's Note",
  "shopee.analytics.title": "Shopee Analytics",
  "shopee.analytics.no-data": "No analytics data available.",
  "shopee.analytics.total-orders": "Total Orders",
  "shopee.analytics.revenue": "Revenue",
  "shopee.analytics.synced": "Synced to VMASS",
  "shopee.analytics.products-linked": "Products Linked",
  "shopee.analytics.by-status": "Orders by Status",
  "shopee.analytics.last-7-days": "Last 7 Days",
  "shopee.analytics.col.date": "Date",
  "shopee.analytics.col.orders": "Orders",
  "shopee.analytics.col.revenue": "Revenue",
  "shopee.analytics.date-range": "Date Range",
  "shopee.analytics.date-hint": "Shopee data searchable range cannot exceed 90 days (3 months). Select a date range to filter.",
  "shopee.analytics.max-range": "Date range cannot exceed 90 days (3 months)",
  "shopee.analytics.invalid-range": "Start date must be before end date",
  "shopee.settings.title": "Shopee Settings",
  "shopee.settings.auto-sync-orders": "Auto Sync Orders",
  "shopee.settings.auto-sync-orders.desc": "Automatically sync new orders from Shopee",
  "shopee.settings.sync-interval": "Sync Interval",
  "shopee.settings.sync-interval.desc": "How often to check for new orders",
  "shopee.settings.auto-bill": "Auto Create Bill",
  "shopee.settings.auto-bill.desc": "Automatically create VMASS bills from Shopee orders",
  "shopee.settings.auto-inventory": "Auto Sync Inventory",
  "shopee.settings.auto-inventory.desc": "Automatically push VMASS stock to Shopee",
  "shopee.settings.notifications": "Notifications",
  "shopee.settings.notify-new-order": "New Order Notification",
  "shopee.settings.notify-status": "Order Status Change",
  "shopee.settings.notify-return": "Return/Refund Request",
  "shopee.settings.save": "Save Settings",
  "shopee.settings.save.success": "Settings saved successfully",
  "shopee.settings.save.error": "Error saving settings",
  "shopee.monitor.health": "Connection Health",
  "shopee.monitor.no-shops": "No connected shops.",
  "shopee.monitor.last-sync": "Last Sync",
  "shopee.monitor.expiring-soon": "Expiring Soon",
  "shopee.monitor.activity": "Activity Log",
  "shopee.monitor.filter.all": "All Activity",
  "shopee.monitor.no-activity": "No recent activity.",
  "shopee.push.modal.title": "Push Product to Shopee",
  "shopee.push.step": "Step",
  "shopee.push.step.select": "Select VMASS Product",
  "shopee.push.step.category": "Choose Shopee Category",
  "shopee.push.step.details": "Product Details",
  "shopee.push.step.confirm": "Review & Push",
  "shopee.push.form.name": "Product Name (5-120 chars)",
  "shopee.push.form.description": "Description (min 25 chars)",
  "shopee.push.form.price": "Price",
  "shopee.push.form.weight": "Weight (kg)",
  "shopee.push.form.condition": "Condition",
  "shopee.push.form.condition.new": "New",
  "shopee.push.form.condition.used": "Used",
  "shopee.push.form.status": "Listing Status",
  "shopee.push.form.status.normal": "Active (NORMAL)",
  "shopee.push.form.status.unlist": "Unlisted (UNLIST)",
  "shopee.push.form.logistics": "Shipping Channels",
  "shopee.push.form.attributes": "Category Attributes",
  "shopee.push.form.category": "Shopee Category",
  "shopee.push.form.dimension": "Package Dimensions",
  "shopee.push.btn.next": "Next",
  "shopee.push.btn.back": "Back",
  "shopee.push.btn.push": "Push to Shopee",
  "shopee.push.btn.push-short": "Push to Shopee",
  "shopee.push.btn.select": "Select",
  "shopee.push.btn.cancel": "Cancel",
  "shopee.push.validate.name": "Product name must be 5-120 characters",
  "shopee.push.validate.description": "Description must be at least 25 characters",
  "shopee.push.validate.price": "Price must be greater than 0",
  "shopee.push.validate.weight": "Weight must be between 0.01 and 50 kg",
  "shopee.push.validate.category": "Please select a category",
  "shopee.push.validate.logistics": "Please select at least one shipping channel",

  "suggestion.title": "Suggestions",
  "suggestion.frequently-bought": "Bought together",
  "suggestion.bestseller": "Bestseller",
  "analytics.product_customers.title": "Customers who purchased",
  "analytics.product_customers.identified": "Identified customers",
  "analytics.product_customers.anonymous": "Guest orders",
  "analytics.product_customers.quantity": "Quantity",
  "analytics.product_customers.revenue": "Revenue",
  "analytics.product_customers.search": "Search",
  "analytics.product_customers.customer": "Customer",
  "analytics.product_customers.orders": "Orders",
  "analytics.product_customers.spent": "Spent",
  "analytics.product_customers.last_purchase": "Last purchase",
  "analytics.product_customers.empty": "No matching customers",
  "analytics.product_customers.customers": "customers",
  "analytics.summary.total_products_sold_period": "Products sold in period",
  "analytics.summary.total_quantity_sold_period": "Quantity sold in period",
  "analytics.summary.product_revenue_period": "Product revenue",
  "analytics.summary.product_cost_period": "Product cost",
  "analytics.summary.product_gross_profit_period": "Gross profit",
  "analytics.summary.product_margin_period": "Profit margin",
  "shopee.workspace.title": "Shopee Operations Center",
  "shopee.workspace.subtitle": "Orders, catalog, inventory, fulfillment and settlements per shop",
  "shopee.workspace.overview": "Overview",
  "shopee.workspace.catalog": "Catalog",
  "shopee.workspace.inventory": "Inventory",
  "shopee.workspace.fulfillment": "Fulfillment",
  "shopee.workspace.returns": "Returns",
  "shopee.workspace.finance": "Finance",
  "shopee.workspace.automation": "Automation",
  "shopee.workspace.logs": "Logs",
  "shopee.workspace.refresh": "Refresh",
  "shopee.workspace.search": "Search",
  "shopee.workspace.from-date": "From",
  "shopee.workspace.to-date": "To",
  "shopee.workspace.loading": "Loading Shopee data…",
  "shopee.workspace.no-data": "No matching data",
  "shopee.workspace.actions": "Actions",
  "shopee.workspace.gmv": "GMV",
  "shopee.workspace.refunds": "Refunds",
  "shopee.workspace.fees": "Shopee fees",
  "shopee.workspace.net-revenue": "Net revenue",
  "shopee.workspace.payout": "Released payout",
  "shopee.workspace.issues": "Issues",
  "shopee.workspace.issue-center": "Issue center",
  "shopee.workspace.order-issues": "order issues",
  "shopee.workspace.mapping-issues": "mapping issues",
  "shopee.workspace.job-issues": "failed jobs",
  "shopee.workspace.retry-selected-orders": "Retry selected orders",
  "shopee.workspace.auto-map-selected": "Auto-map exact SKUs",
  "shopee.workspace.create-selected-drafts": "Create selected drafts",
  "shopee.workspace.issue-reason": "Issue",
  "shopee.workspace.item-model": "Item / model",
  "shopee.workspace.job": "Job",
  "shopee.workspace.replay": "Replay",
  "shopee.workspace.no-issues": "No issues found",
  "shopee.workspace.confirm-remediation": "Confirm remediation",
  "shopee.workspace.confirm-remediation-detail": "This action only processes the selected records and is idempotent.",
  "shopee.workspace.sync": "Sync",
  "shopee.workspace.mapping": "Mapping",
  "shopee.workspace.sync-state": "Sync state",
  "shopee.workspace.amount": "Amount",
  "shopee.workspace.create-bill": "Create Bill",
  "shopee.workspace.import-catalog": "Import catalog",
  "shopee.workspace.map-product": "Map product",
  "shopee.workspace.mapping-wizard": "Map Shopee variant to VMASS",
  "shopee.workspace.search-product": "Search VMASS products",
  "shopee.workspace.choose-product": "Choose a VMASS product",
  "shopee.workspace.choose-variant": "Choose a VMASS variant",
  "shopee.workspace.create-draft": "Create VMASS draft",
  "shopee.workspace.update-listing": "Update listing",
  "shopee.workspace.list-listing": "List",
  "shopee.workspace.unlist-listing": "Unlist",
  "shopee.workspace.variant-prices": "Variant prices",
  "shopee.workspace.image-urls": "Image URLs",
  "shopee.workspace.image-help": "One approved VMASS asset URL per line; images are sent only after this field is edited.",
  "shopee.workspace.length": "Length (cm)",
  "shopee.workspace.width": "Width (cm)",
  "shopee.workspace.height": "Height (cm)",
  "shopee.workspace.vmass-product-id": "VMASS product ID",
  "shopee.workspace.vmass-variant-id": "VMASS variant ID (leave blank for a simple product)",
  "shopee.workspace.mapping-help": "The system verifies tenant ownership and variant membership before saving.",
  "shopee.workspace.sync-stock": "Sync stock",
  "shopee.workspace.shopee-stock": "Shopee stock",
  "shopee.workspace.state": "Status",
  "shopee.workspace.reservation": "Reservation",
  "shopee.workspace.tracking": "Tracking number",
  "shopee.workspace.ship": "Ship",
  "shopee.workspace.ship-confirm": "Confirm shipment",
  "shopee.workspace.shipping-params-error": "Could not load Shopee shipping parameters",
  "shopee.workspace.shipping-method": "Handover method",
  "shopee.workspace.pickup-address": "Pickup address",
  "shopee.workspace.pickup-time": "Pickup time",
  "shopee.workspace.confirm": "Confirm",
  "shopee.workspace.accept": "Accept",
  "shopee.workspace.dispute": "Dispute",
  "shopee.workspace.return-reason": "Return decision reason",
  "shopee.workspace.return-evidence": "Evidence (comma-separated image IDs)",
  "shopee.workspace.sync-finance": "Sync settlements",
  "shopee.workspace.create-income": "Create receipt",
  "shopee.workspace.save": "Save settings",
  "shopee.workspace.sync-interval": "Sync interval (minutes)",
  "shopee.workspace.resource": "Resource",
  "shopee.workspace.attempts": "Attempts",
  "shopee.workspace.created-at": "Created at",
  "shopee.workspace.retry": "Retry",
  "shopee.workspace.setting.auto_sync_orders": "Automatically sync orders",
  "shopee.workspace.setting.auto_create_bill": "Automatically create Bill when ready to ship",
  "shopee.workspace.setting.auto_sync_inventory": "Automatically sync inventory",
  "shopee.workspace.setting.auto_sync_catalog": "Automatically sync the product catalog",
  "shopee.workspace.catalog-sync-interval": "Catalog sync interval (minutes)",
  "shopee.workspace.catalog-sync-hint": "From 60 to 10080 minutes; default 1440 minutes (daily).",
  "shopee.workspace.catalog-last-sync": "Last successful catalog sync",
  "shopee.workspace.catalog-next-sync": "Next catalog sync",
  "shopee.workspace.select-shop-for-automation": "Select a specific shop to configure automation.",
  "shopee.workspace.select-shop-for-listing": "Select a specific shop before adding or editing products.",
  "shopee.workspace.listing-load-incomplete": "Some Shopee product data could not be loaded. You can review the available data and retry.",
  "shopee.workspace.listing-no-candidates": "There are no available VMASS products to publish to Shopee.",
  "shopee.workspace.setting.notify_new_order": "Notify new Shopee orders",
  "shopee.workspace.setting.notify_status_change": "Notify order status changes",
  "shopee.workspace.setting.notify_return": "Notify return requests",
  "shopee.workspace.inventory-safety-buffer": "Inventory safety buffer withheld from Shopee",
  "shopee.workspace.scope-not-granted": "The shop has not granted the required Shopee scope:",
  "shopee.workspace.group.overview": "OVERVIEW",
  "shopee.workspace.group.catalog": "STOCK & PRODUCTS",
  "shopee.workspace.group.logistics": "SHIPPING & FINANCE",
  "shopee.workspace.group.system": "SYSTEM",
  "shopee.workspace.tab.overview": "Overview",
  "shopee.workspace.tab.orders": "Orders",
  "shopee.workspace.tab.products": "Multichannel products",
  "shopee.workspace.tab.mappings": "Product mapping",
  "shopee.workspace.tab.inventory": "Channel stock",
  "shopee.workspace.tab.pricing": "Channel pricing",
  "shopee.workspace.tab.shipping": "Shipping & Packing",
  "shopee.workspace.tab.returns": "Returns & Refunds",
  "shopee.workspace.tab.reconciliation": "Reconciliation & Payouts",
  "shopee.workspace.tab.issues": "Issue Center",
  "shopee.workspace.tab.connections": "Channels & Connections",
  "shopee.workspace.tab.connections-short": "Sales channel",
  "shopee.workspace.tab.automation": "Automation",
  "shopee.workspace.tab.logs": "Task logs",
  "shopee.workspace.connect-required.title": "Shopee account connection required",
  "shopee.workspace.connect-required.desc": "Your account is not connected to any Shopee shop yet. Connect a Shopee shop to view reports, manage orders and products, and sync inventory.",
  "shopee.workspace.connect-required.feature.orders": "Automatic order sync",
  "shopee.workspace.connect-required.feature.mapping": "SKU mapping & inventory management",
  "shopee.workspace.connect-required.feature.shipping": "Shipping status updates",
  "shopee.workspace.connect-required.feature.finance": "Revenue reconciliation & payouts",
  "shopee.workspace.connect-required.connecting": "Connecting...",
  "shopee.workspace.connect-required.cta": "🚀 Connect your Shopee shop now",
  "shopee.workspace.sidebar.shops-header": "Shops",
  "shopee.workspace.sidebar.add-shop-title": "Connect a new Shopee shop",
  "shopee.workspace.sidebar.refresh-title": "Refresh data",
  "shopee.workspace.sidebar.all-shops": "📊 All shops ({count})",
  "shopee.workspace.sidebar.shop-fallback": "Shop {shopId}",
  "shopee.workspace.sidebar.connected-count": "{count} connected channels",
  "shopee.workspace.sidebar.not-connected": "Not connected",
  "shopee.workspace.common.sending-request": "Sending request...",
  "shopee.workspace.common.sync": "Sync",
  "shopee.workspace.common.edit": "Edit",
  "shopee.workspace.common.per-page": "{size} / page",
  "shopee.workspace.common.product-name": "Product name",
  "shopee.workspace.common.customer": "Customer",
  "shopee.workspace.common.previous": "Prev",
  "shopee.workspace.common.next": "Next",
  "shopee.workspace.common.loading": "Loading...",
  "shopee.workspace.common.page": "Page",
  "shopee.workspace.common.of": "of",
  "shopee.workspace.common.rows": "rows",
  "shopee.workspace.common.all-statuses": "All statuses",
  "shopee.workspace.common.all-channels": "All channels",
  "shopee.workspace.common.filter": "Filters",
  "shopee.workspace.common.tab-all-count": "All ({count})",
  "shopee.workspace.common.view-all": "View all",
  "shopee.workspace.common.total": "Total",
  "shopee.workspace.common.note": "Note",
  "shopee.workspace.common.optional": "optional",
  "shopee.workspace.common.note-placeholder": "Enter a note...",
  "shopee.workspace.common.last-7-days": "Last 7 days",
  "shopee.workspace.common.last-30-days": "Last 30 days",
  "shopee.workspace.catalog.channel-all": "All",
  "shopee.workspace.catalog.not-synced-yet": "Not synced",
  "shopee.workspace.catalog.minutes-ago": "{count} minutes ago",
  "shopee.workspace.catalog.hours-ago": "{count} hours ago",
  "shopee.workspace.catalog.channel-unlisted": "Unlisted",
  "shopee.workspace.catalog.publish-now": "Publish now",
  "shopee.workspace.catalog.sync-error-short": "Sync error",
  "shopee.workspace.catalog.out-of-stock": "Out of stock",
  "shopee.workspace.catalog.listed": "Listed",
  "shopee.workspace.catalog.view-error": "View error",
  "shopee.workspace.catalog.mapping-saved": "Product mapping updated",
  "shopee.workspace.catalog.mapping-cleared": "Removed the Shopee product mapping from VMASS",
  "shopee.workspace.catalog.inventory-sync-queued": "Inventory sync scheduled",
  "shopee.workspace.catalog.import-queued": "Catalog import scheduled",
  "shopee.workspace.catalog.kpi-total-listings": "Total listings",
  "shopee.workspace.catalog.kpi-total-listings-note": "{count} mapping rows",
  "shopee.workspace.catalog.kpi-mapped": "Mapped",
  "shopee.workspace.catalog.kpi-page-percent": "{percent}% on page",
  "shopee.workspace.catalog.kpi-unmapped": "Unmapped",
  "shopee.workspace.catalog.note-needs-action": "Needs action",
  "shopee.workspace.catalog.kpi-sync-errors": "Sync errors",
  "shopee.workspace.catalog.note-priority": "Priority handling",
  "shopee.workspace.catalog.kpi-out-of-stock": "Out of stock",
  "shopee.workspace.catalog.note-at-shopee": "On the Shopee channel",
  "shopee.workspace.catalog.kpi-price-pending": "Price update pending",
  "shopee.workspace.catalog.note-sync-price": "Price sync needed",
  "shopee.workspace.catalog.filter-aria": "Product filters",
  "shopee.workspace.catalog.search-placeholder": "Search products, SKU, barcode...",
  "shopee.workspace.catalog.channel-aria": "Sales channel",
  "shopee.workspace.catalog.mapping-state-aria": "Mapping status",
  "shopee.workspace.catalog.sync-state-aria": "Sync status",
  "shopee.workspace.catalog.mapping-all": "All mappings",
  "shopee.workspace.catalog.mapping-mapped": "Mapped",
  "shopee.workspace.catalog.mapping-unmapped": "Unmapped",
  "shopee.workspace.catalog.sync-state-all": "Sync state",
  "shopee.workspace.catalog.sync-state-error": "With errors",
  "shopee.workspace.catalog.add-product": "Add product",
  "shopee.workspace.catalog.select-all-aria": "Select all products",
  "shopee.workspace.catalog.col-product": "Product",
  "shopee.workspace.catalog.col-sku-vmass": "VMASS SKU",
  "shopee.workspace.catalog.col-price": "Selling price",
  "shopee.workspace.catalog.col-stock": "Stock",
  "shopee.workspace.catalog.col-sync-state": "Sync status",
  "shopee.workspace.catalog.col-last-update": "Last updated",
  "shopee.workspace.catalog.select-row-aria": "Select {name}",
  "shopee.workspace.catalog.no-vmass-mapping": "No VMASS mapping",
  "shopee.workspace.catalog.no-vmass-sku": "No VMASS SKU",
  "shopee.workspace.catalog.open-detail-aria": "Open details",
  "shopee.workspace.catalog.pagination-summary": "Showing {from} - {to} of {total} mapping rows",
  "shopee.workspace.catalog.detail-sku-label": "VMASS SKU:",
  "shopee.workspace.catalog.detail-item-label": "Shopee item:",
  "shopee.workspace.catalog.close-detail-aria": "Close details",
  "shopee.workspace.catalog.nav-stock": "Stock",
  "shopee.workspace.catalog.nav-history": "History",
  "shopee.workspace.catalog.unmapped-badge": "Unmapped",
  "shopee.workspace.catalog.sku-shopee": "Shopee SKU",
  "shopee.workspace.catalog.update-mapping": "Update mapping",
  "shopee.workspace.catalog.map-product-btn": "Map product",
  "shopee.workspace.catalog.no-channel-info": "No product information yet",
  "shopee.workspace.catalog.publish-to": "Publish to {channel}",
  "shopee.workspace.catalog.sync-shopee-catalog": "Sync Shopee catalog",
  "shopee.workspace.catalog.unmap": "Unmap",
  "shopee.workspace.catalog.sku-name-placeholder": "SKU / product name",
  "shopee.workspace.catalog.draft-created": "Created a VMASS product draft with zero stock",
  "shopee.workspace.catalog.listing-show-queued": "Listing display request queued",
  "shopee.workspace.catalog.listing-hide-queued": "Listing hide request queued",
  "shopee.workspace.fulfillment.ship-queued": "Shipping request queued",
  "shopee.workspace.returns.status.requested": "New request",
  "shopee.workspace.returns.status.in-inspection": "Inspecting",
  "shopee.workspace.returns.status.waiting-refund": "Awaiting refund",
  "shopee.workspace.returns.status.processing": "Processing",
  "shopee.workspace.returns.status.completed": "Completed",
  "shopee.workspace.returns.status.rejected": "Rejected",
  "shopee.workspace.returns.status.restocked": "Restocked",
  "shopee.workspace.returns.status.waiting-confirm": "Awaiting confirmation",
  "shopee.workspace.returns.inspection-confirmed": "Return inspection confirmed and stock updated",
  "shopee.workspace.returns.dispute-queued": "Dispute request queued",
  "shopee.workspace.returns.customer-fallback": "Customer",
  "shopee.workspace.returns.reason-other": "Other",
  "shopee.workspace.returns.reason-detail-fallback": "Return request",
  "shopee.workspace.returns.item-fallback": "Product",
  "shopee.workspace.returns.subtitle": "Manage all return requests, refunds and exchanges",
  "shopee.workspace.returns.export-excel": "Export Excel",
  "shopee.workspace.returns.report": "Report",
  "shopee.workspace.returns.create-request": "Create return request",
  "shopee.workspace.returns.kpi-requested-note": "New & awaiting confirmation",
  "shopee.workspace.returns.kpi-processing-note": "Inspection & processing",
  "shopee.workspace.returns.kpi-waiting-refund-note": "Waiting for refund",
  "shopee.workspace.returns.kpi-completed-note": "Fully processed",
  "shopee.workspace.returns.kpi-rejected-note": "Rejected requests",
  "shopee.workspace.returns.total-refund-today": "Total refunded (today)",
  "shopee.workspace.returns.return-value-today": "Returned goods value (today)",
  "shopee.workspace.returns.pipeline.customer-request": "Customer requests return",
  "shopee.workspace.returns.pipeline.inspect": "Goods inspection",
  "shopee.workspace.returns.pipeline.approve": "Approve return",
  "shopee.workspace.returns.pipeline.restock-dispose": "Restock / Dispose",
  "shopee.workspace.returns.pipeline.refund": "Refund",
  "shopee.workspace.returns.search-placeholder": "Search return code, order code, name, phone...",
  "shopee.workspace.returns.all-reasons": "All reasons",
  "shopee.workspace.returns.all-warehouses": "All warehouses",
  "shopee.workspace.returns.no-data": "No return requests found",
  "shopee.workspace.returns.detail-title": "Return details",
  "shopee.workspace.returns.original-order": "Original order",
  "shopee.workspace.returns.customer-media": "Customer photos/videos",
  "shopee.workspace.returns.no-media": "No photos attached by customer",
  "shopee.workspace.returns.returned-products": "Returned products",
  "shopee.workspace.returns.qty-label": "Qty",
  "shopee.workspace.returns.inspection-title": "Returned goods inspection",
  "shopee.workspace.returns.check.intact": "Items intact",
  "shopee.workspace.returns.check.packaging": "Packaging & labels",
  "shopee.workspace.returns.check.accessories": "Accessories complete",
  "shopee.workspace.returns.check.correct-product": "Correct product",
  "shopee.workspace.returns.check.defect": "Defect / Damage",
  "shopee.workspace.returns.processing-title": "Process return",
  "shopee.workspace.returns.action.restock": "Restock",
  "shopee.workspace.returns.action.exchange": "Exchange",
  "shopee.workspace.returns.action.discard": "Dispose",
  "shopee.workspace.returns.restock-warehouse": "Restock warehouse",
  "shopee.workspace.returns.confirm-continue": "Confirm & Continue",
  "shopee.workspace.returns.popular-reasons": "Popular return reasons",
  "shopee.workspace.returns.no-reason-data": "No reason data yet",
  "shopee.workspace.returns.top-returned": "Top returned products",
  "shopee.workspace.returns.times-suffix": "times",
  "shopee.workspace.returns.no-returned-products": "No returned products yet",
  "shopee.workspace.returns.refund-trend": "Refund value over time",
  "shopee.workspace.returns.performance": "Processing performance",
  "shopee.workspace.returns.avg-processing-time": "Avg processing time",
  "shopee.workspace.returns.on-time-rate": "On-time completion rate",
  "shopee.workspace.returns.sample-processing-time": "1.8 days",
  "shopee.workspace.returns.sample-processing-delta": "-0.3 days",
  "shopee.workspace.returns.dispute-modal-title": "Open Shopee dispute",
  "shopee.workspace.returns.inspection-modal-title": "Return inspection form",
  "shopee.workspace.returns.condition-placeholder": "Describe the actual condition of received goods...",
  "shopee.workspace.returns.stock-decision": "Stock decision",
  "shopee.workspace.returns.stock.resellable": "1. Intact -> Back to sellable stock",
  "shopee.workspace.returns.stock.defective": "2. Damaged / Dirty -> To defective stock",
  "shopee.workspace.returns.stock.discard": "3. Severely damaged / Discard -> Do not restock",
  "shopee.workspace.returns.stock.shortage": "4. Missing items / Swapped -> File shortage report",
  "shopee.workspace.returns.evidence-placeholder": "Inspection evidence photo / video links (URL 1, URL 2)...",
  "shopee.workspace.returns.col.sn": "Return code",
  "shopee.workspace.returns.col.order": "Original order",
  "shopee.workspace.returns.col.channel": "Channel",
  "shopee.workspace.returns.col.reason": "Return reason",
  "shopee.workspace.returns.col.refund-value": "Refund value",
  "shopee.workspace.returns.col.warehouse": "Warehouse",
  "shopee.workspace.returns.col.status": "Status",
  "shopee.workspace.returns.col.created-at": "Created at",
  "shopee.workspace.returns.action.inspect": "Inspect & Restock",
  "shopee.workspace.returns.action.dispute": "Create Shopee dispute",
  "shopee.workspace.returns.view-detail-title": "View details",
  "shopee.workspace.automation.settings-saved": "Automation settings saved",
  "shopee.workspace.logs.replayed": "Job replayed",
  "shopee.workspace.common.detail": "Details",
  "shopee.workspace.common.page-count": "/ {total} pages",
  "shopee.workspace.common.no-data": "No data yet",
  "shopee.workspace.common.close": "Close",
  "shopee.workspace.orders.status.all": "All",
  "shopee.workspace.orders.status.unpaid": "Unpaid",
  "shopee.workspace.orders.status.ready-to-ship": "Pending handling",
  "shopee.workspace.orders.status.processed": "Processed",
  "shopee.workspace.orders.status.shipped": "Shipping",
  "shopee.workspace.orders.status.to-confirm-receive": "Awaiting delivery confirmation",
  "shopee.workspace.orders.status.completed": "Delivered",
  "shopee.workspace.orders.status.in-cancel": "Cancelling",
  "shopee.workspace.orders.status.cancelled": "Cancelled",
  "shopee.workspace.orders.status-unknown": "Unknown",
  "shopee.workspace.orders.metric.total": "Total orders",
  "shopee.workspace.orders.metric.total-indicator": "{count} on page",
  "shopee.workspace.orders.metric.pending": "Pending handling",
  "shopee.workspace.orders.metric.pending-indicator": "{percent}% of page",
  "shopee.workspace.orders.metric.deadline": "Ship-by attention",
  "shopee.workspace.orders.metric.deadline-overdue": "{count} overdue",
  "shopee.workspace.orders.metric.deadline-window": "{risk}/{total} with deadline",
  "shopee.workspace.orders.metric.deadline-none": "No orders awaiting shipment",
  "shopee.workspace.orders.metric.gmv": "Order GMV",
  "shopee.workspace.orders.metric.gmv-indicator": "{paid}/{eligible} orders with amount",
  "shopee.workspace.orders.metric.delivered": "Delivered",
  "shopee.workspace.orders.tabs-region-aria": "Order status bar, scroll horizontally to see more",
  "shopee.workspace.orders.count-tooltip": "Orders on the current page",
  "shopee.workspace.orders.select-all-aria": "Select all orders",
  "shopee.workspace.orders.select-row-aria": "Select order {sn}",
  "shopee.workspace.orders.col.sn": "Order code",
  "shopee.workspace.orders.col.channel": "Channel",
  "shopee.workspace.orders.col.items": "Products",
  "shopee.workspace.orders.col.amount": "Total amount",
  "shopee.workspace.orders.col.tracking": "Tracking",
  "shopee.workspace.orders.col.time": "Time",
  "shopee.workspace.orders.phone-hidden": "Information hidden",
  "shopee.workspace.orders.items-count": "{count} items",
  "shopee.workspace.orders.items-total-x": "Total x{count}",
  "shopee.workspace.orders.paid-time": "Paid at {time}",
  "shopee.workspace.orders.paid-time-missing": "Shopee has not returned the payment time",
  "shopee.workspace.orders.sync-queued": "Order sync scheduled",
  "shopee.workspace.orders.sync-button": "Sync orders",
  "shopee.workspace.orders.selection-banner": "{count} orders selected.",
  "shopee.workspace.orders.export-selected": "Export selected",
  "shopee.workspace.orders.clear-selection": "Clear selection",
  "shopee.workspace.orders.empty": "No matching orders.",
  "shopee.workspace.orders.showing-summary": "Showing {shown} / {total} orders",
  "shopee.workspace.orders.filter-title": "Search Filters",
  "shopee.workspace.orders.clear-filters": "Clear filters",
  "shopee.workspace.orders.filter-status-label": "Order status",
  "shopee.workspace.orders.filter-search-label": "Search keyword",
  "shopee.workspace.orders.search-placeholder": "Order code or tracking code...",
  "shopee.workspace.orders.apply-filters": "Apply filters",
  "shopee.workspace.orders.chart-title": "Status Distribution On Page",
  "shopee.workspace.orders.detail-title": "Shopee Order Details #{orderSn}",
  "shopee.workspace.orders.detail-loading": "Loading order details...",
  "shopee.workspace.orders.detail-load-error": "Unable to load additional order details.",
  "shopee.workspace.orders.phone-label": "Phone number:",
  "shopee.workspace.orders.tracking-label": "Tracking code:",
  "shopee.workspace.orders.total-shopee": "Shopee total",
  "shopee.workspace.orders.created-at": "Order created at",
  "shopee.workspace.orders.ship-deadline": "Shopee ship-by date",
  "shopee.workspace.orders.items-title": "Product List ({count})",
  "shopee.workspace.orders.price-per-item": "{price} / item",
  "shopee.workspace.orders.create-bill": "Create VMASS Invoice",
  "shopee.workspace.orders.bill-created": "Invoice created from Shopee order",
  "shopee.workspace.orders.csv.order-code": "Order code",
  "shopee.workspace.orders.csv.phone": "Phone",
  "shopee.workspace.orders.csv.products": "Products",
  "shopee.workspace.orders.csv.amount": "Total amount",
  "shopee.workspace.overview.webhook.configured": "Configured",
  "shopee.workspace.overview.webhook.processing": "Processing",
  "shopee.workspace.overview.webhook.degraded": "Needs checking",
  "shopee.workspace.overview.webhook.not-configured": "Not configured",
  "shopee.workspace.overview.webhook.unknown": "Unknown",
  "shopee.workspace.overview.kpi.new-orders": "New orders",
  "shopee.workspace.overview.kpi.new-trend": "New",
  "shopee.workspace.overview.kpi.new-comparison": "New orders today",
  "shopee.workspace.overview.kpi.pending": "Pending / Packing",
  "shopee.workspace.overview.kpi.pending-trend": "Needs action",
  "shopee.workspace.overview.kpi.pending-comparison": "Ready to hand over",
  "shopee.workspace.overview.kpi.expiring": "Expiring hand-over deadline",
  "shopee.workspace.overview.kpi.expiring-priority": "Priority",
  "shopee.workspace.overview.kpi.expiring-safe": "Safe",
  "shopee.workspace.overview.kpi.expiring-comparison": "Handle soon",
  "shopee.workspace.overview.kpi.gmv": "Revenue today (GMV)",
  "shopee.workspace.overview.kpi.gmv-trend": "Total GMV",
  "shopee.workspace.overview.kpi.gmv-comparison": "Total revenue",
  "shopee.workspace.overview.kpi.ontime": "On-time delivery rate",
  "shopee.workspace.overview.kpi.ontime-trend": "On standard",
  "shopee.workspace.overview.kpi.ontime-comparison": "Performance metric",
  "shopee.workspace.overview.issue.orders": "Orders to handle",
  "shopee.workspace.overview.issue.orders-desc": "Orders needing handling to protect delivery time.",
  "shopee.workspace.overview.issue.mappings": "Mappings to handle",
  "shopee.workspace.overview.issue.mappings-desc": "SKUs not mapped yet or mapped incorrectly.",
  "shopee.workspace.overview.issue.jobs": "Failed jobs",
  "shopee.workspace.overview.issue.jobs-desc": "Sync tasks that failed and need checking.",
  "shopee.workspace.overview.issue.products": "Products missing info",
  "shopee.workspace.overview.issue.products-desc": "Products missing information on some channels.",
  "shopee.workspace.overview.issue.reconciliation": "Reconciliation variance",
  "shopee.workspace.overview.issue.reconciliation-desc": "Orders with variance requiring reconciliation.",
  "shopee.workspace.overview.shop-fallback": "Shopee - Shop {shopId}",
  "shopee.workspace.overview.shop-label": "Shop {shopId}",
  "shopee.workspace.overview.activity.sync-default": "Sync",
  "shopee.workspace.overview.activity.just-now": "Just now",
  "shopee.workspace.overview.activity.success": "Succeeded",
  "shopee.workspace.overview.activity.attempts": "{count} runs",
  "shopee.workspace.overview.banner-title": "Shopee Channel Health & Performance Overview",
  "shopee.workspace.overview.banner-healthy": "System normal",
  "shopee.workspace.overview.banner-attention": "Needs attention",
  "shopee.workspace.overview.banner-shops-updated": "{count} shops connected | Updated at: {time}",
  "shopee.workspace.overview.period.today": "Today",
  "shopee.workspace.overview.period.week": "7 days",
  "shopee.workspace.overview.period.month": "30 days",
  "shopee.workspace.overview.reload": "Reload data",
  "shopee.workspace.overview.mapping-title": "SKU Mapping Progress",
  "shopee.workspace.overview.mapping-tooltip": "Real stock sync between Shopee & VMASS",
  "shopee.workspace.overview.mapping-percent": "{percent}% Mapped",
  "shopee.workspace.overview.mapping-progress": "Mapped {mapped} / {total} product SKUs",
  "shopee.workspace.overview.mapping-note": "Auto-sync real inventory & prevent overselling on new orders.",
  "shopee.workspace.overview.mapping-action": "Map SKUs now",
  "shopee.workspace.overview.health-title": "Sync Health & Shopee Connection",
  "shopee.workspace.overview.last-sync": "Last sync:",
  "shopee.workspace.overview.sparkline-label": "Realtime connection status",
  "shopee.workspace.overview.oauth-label": "OAuth Token:",
  "shopee.workspace.overview.oauth-valid": "Valid",
  "shopee.workspace.overview.oauth-invalid": "Expired",
  "shopee.workspace.overview.api-label": "API Health:",
  "shopee.workspace.overview.api-good": "Good (Normal)",
  "shopee.workspace.overview.api-bad": "Needs checking",
  "shopee.workspace.overview.issues-title": "Issue center",
  "shopee.workspace.overview.manage-connections": "Manage connections",
  "shopee.workspace.overview.channels-title": "Sales channels",
  "shopee.workspace.overview.channel-active": "Active",
  "shopee.workspace.overview.channel-error": "Connection error",
  "shopee.workspace.overview.new-orders-colon": "New orders:",
  "shopee.workspace.overview.no-shops": "No connected shops yet",
  "shopee.workspace.overview.connect-more": "Connect another sales channel",
  "shopee.workspace.overview.view-logs": "View logs",
  "shopee.workspace.overview.activity-title": "Recent sync activity",
  "shopee.workspace.overview.no-activity": "No recent activity logs yet",
  "shopee.workspace.overview.top-products": "Top selling products",
  "shopee.workspace.overview.top-products-note": "by order quantity",
  "shopee.workspace.overview.top-period": "Last 7 days stats",
  "shopee.workspace.overview.product-unknown": "Unidentified product",
  "shopee.workspace.overview.sold-count": "{count} orders",
  "shopee.workspace.overview.no-products": "No product data yet",
  "shopee.workspace.overview.revenue-title": "Revenue by channel",
  "shopee.workspace.overview.revenue-period": "Last 7 days revenue",
  "shopee.workspace.overview.revenue-total-aria": "Total revenue {amount}",
  "shopee.workspace.overview.total-revenue": "Total revenue",
  "shopee.workspace.error.no-response": "The Shopee request did not respond. Check Redis and the Shopee worker, then try again.",
  "shopee.workspace.error.load-failed": "Unable to load Shopee data",
  "shopee.workspace.notice.job-completed": "Shopee task completed",
  "shopee.workspace.notice.job-ended-status": "Shopee task ended with status {status}",
  "shopee.workspace.notice.job-status-updated": "Job {status}",
  "shopee.workspace.notice.job-status-default": "updated",
  "shopee.workspace.notice.new-order": "New order received from Shopee",
  "shopee.workspace.notice.action-queued": "Task queued successfully",
  "shopee.workspace.notice.action-success": "Updated successfully",
  "shopee.workspace.common.back": "Back",
  "shopee.workspace.common.next-step": "Next",
  "shopee.workspace.connections.title": "Sales channels & connected shops",
  "shopee.workspace.connections.subtitle": "Manage OAuth authorization, sync policies and Shopee shop connections",
  "shopee.workspace.connections.add-shop-wizard": "Add a new Shopee shop (6-step wizard)",
  "shopee.workspace.connections.status-active": "ACTIVE",
  "shopee.workspace.connections.region-id": "Region: {region} | Shop ID: {shopId}",
  "shopee.workspace.connections.scopes-label": "Authorized scopes:",
  "shopee.workspace.connections.scope.orders": "Orders",
  "shopee.workspace.connections.scope.catalog": "Catalog",
  "shopee.workspace.connections.scope.stock": "Stock",
  "shopee.workspace.connections.scope.finance": "Finance",
  "shopee.workspace.connections.scope.return": "Returns",
  "shopee.workspace.connections.last-sync-colon": "Last sync:",
  "shopee.workspace.connections.reauth-title": "Re-authorize",
  "shopee.workspace.connections.reauth": "Re-run OAuth",
  "shopee.workspace.connections.disconnect-title": "Disconnect",
  "shopee.workspace.connections.disconnected-notice": "Disconnected shop {shop}",
  "shopee.workspace.connections.disconnect-btn": "Remove",
  "shopee.workspace.connections.empty": "No Shopee shops connected yet.",
  "shopee.workspace.connections.connect-new": "+ Connect a new Shopee shop",
  "shopee.workspace.connections.wizard.title": "Shopee shop connection & activation wizard (step {step}/6)",
  "shopee.workspace.connections.wizard.step1-title": "Step 1: Connect & authorize OAuth with Shopee",
  "shopee.workspace.connections.wizard.step1-desc": "You will be redirected to the official Shopee Partner Platform authorization gateway to sign in to your shop.",
  "shopee.workspace.connections.wizard.step1-permissions": "Access includes:",
  "shopee.workspace.connections.wizard.step1-permissions-detail": "Read/write orders, catalog sync, stock quantity updates and settlement history.",
  "shopee.workspace.connections.wizard.open-oauth": "Go to the Shopee sign-in & authorization page",
  "shopee.workspace.connections.wizard.step2-title": "Step 2: Choose initial data import",
  "shopee.workspace.connections.wizard.step2-desc": "Choose which data types to import from Shopee into VMASS:",
  "shopee.workspace.connections.wizard.step2-products": "All products & variants from Shopee",
  "shopee.workspace.connections.wizard.step2-orders": "Orders from the last 30 days",
  "shopee.workspace.connections.wizard.step2-logistics": "Pickup address & logistics partners",
  "shopee.workspace.connections.wizard.step3-title": "Step 3: Set the source of truth",
  "shopee.workspace.connections.wizard.step3-desc": "The source of truth decides which system owns the master stock quantity:",
  "shopee.workspace.connections.wizard.step3-vmass-strong": "VMASS as source of truth (recommended):",
  "shopee.workspace.connections.wizard.step3-vmass-desc": "VMASS stock is pushed to Shopee automatically after orders are processed.",
  "shopee.workspace.connections.wizard.step3-shopee-strong": "Shopee as initial source:",
  "shopee.workspace.connections.wizard.step3-shopee-desc": "Use the current Shopee stock quantity as baseline for the first sync.",
  "shopee.workspace.connections.wizard.step4-title": "Step 4: Review SKU mapping",
  "shopee.workspace.connections.wizard.step4-info": "85% of Shopee SKUs exactly match VMASS warehouse SKUs. These SKUs will be mapped automatically.",
  "shopee.workspace.connections.wizard.step4-note": "Unmapped SKUs can be managed in the \"Product mapping\" tab after activation.",
  "shopee.workspace.connections.wizard.step5-title": "Step 5: Configure stock & price policy",
  "shopee.workspace.connections.wizard.allocation-label": "Stock allocation mode",
  "shopee.workspace.connections.wizard.option-shared": "SHARED (share 100% of sellable stock)",
  "shopee.workspace.connections.wizard.option-allocated": "ALLOCATED (reserve a fixed quota)",
  "shopee.workspace.connections.wizard.option-percentage": "PERCENTAGE (split by percentage)",
  "shopee.workspace.connections.wizard.safety-buffer-label": "Safety buffer stock",
  "shopee.workspace.connections.wizard.safety-buffer-hint": "Prevents overselling when selling on multiple channels.",
  "shopee.workspace.connections.wizard.step6-title": "Step 6: Verify & activate shop",
  "shopee.workspace.connections.wizard.step6-ready-strong": "Ready to activate!",
  "shopee.workspace.connections.wizard.step6-ready-detail": "All settings are valid with no critical conflicts.",
  "shopee.workspace.connections.wizard.check-oauth": "✔ Authorized with Shopee Partner API v2",
  "shopee.workspace.connections.wizard.check-sot": "✔ Source of truth: {value}",
  "shopee.workspace.connections.wizard.check-stock-mode": "✔ Stock mode: {mode} (Safety buffer: {buffer})",
  "shopee.workspace.connections.wizard.opening-shopee": "Opening the Shopee gateway...",
  "shopee.workspace.connections.wizard.connect-now": "Connect Shopee OAuth now",
  "shopee.workspace.connections.wizard.activate-done": "New Shopee shop activated successfully",
  "shopee.workspace.connections.wizard.activate-now": "Activate shop now",
  "shopee.workspace.inventory.status.unknown": "Not enough data",
  "shopee.workspace.inventory.status.unmapped": "Unmapped in VMASS",
  "shopee.workspace.inventory.status.error": "Sync error",
  "shopee.workspace.inventory.status.out-of-stock": "Out of stock on Shopee",
  "shopee.workspace.inventory.status.variance": "Variance",
  "shopee.workspace.inventory.status.synced": "Synced",
  "shopee.workspace.inventory.no-name": "Shopee does not provide a product name",
  "shopee.workspace.inventory.sub.on-page": "On current page",
  "shopee.workspace.inventory.sub.by-filter": "By current filter",
  "shopee.workspace.inventory.sub.from-loaded-mappings": "From loaded mapping data",
  "shopee.workspace.inventory.kpi.total": "Total Shopee mappings",
  "shopee.workspace.inventory.kpi.synced-sub": "Of {count} loaded rows",
  "shopee.workspace.inventory.kpi.variance": "Stock variance",
  "shopee.workspace.inventory.kpi.errors-sub": "{count} sync errors",
  "shopee.workspace.inventory.kpi.last-sync": "Last updated",
  "shopee.workspace.inventory.col.vmass-stock": "VMASS stock",
  "shopee.workspace.inventory.col.total": "Total",
  "shopee.workspace.inventory.col.diff-formula": "Shopee - VMASS",
  "shopee.workspace.inventory.col.condition": "Condition",
  "shopee.workspace.inventory.col.updated": "Updated",
  "shopee.workspace.inventory.col.last": "Last",
  "shopee.workspace.inventory.img-placeholder-aria": "No product image",
  "shopee.workspace.inventory.title": "Shopee stock",
  "shopee.workspace.inventory.subtitle": "Compare VMASS sellable stock with the synced Shopee catalog.",
  "shopee.workspace.inventory.manage-mapping": "Manage product mapping",
  "shopee.workspace.inventory.search-placeholder": "Search products or Shopee SKU...",
  "shopee.workspace.inventory.filter.all": "All conditions",
  "shopee.workspace.inventory.shop-colon": "Shop:",
  "shopee.workspace.inventory.no-shop-selected": "No shop selected",
  "shopee.workspace.inventory.loading": "Loading Shopee data...",
  "shopee.workspace.inventory.empty": "No Shopee mappings match the filter.",
  "shopee.workspace.inventory.pagination-summary": "Showing {from} - {to} of {total} Shopee mappings",
  "shopee.workspace.inventory.side.overview-title": "Stock overview",
  "shopee.workspace.inventory.legend.filtered": "Mappings by filter",
  "shopee.workspace.inventory.legend.synced-page": "Synced on page",
  "shopee.workspace.inventory.legend.variance-page": "Variance on page",
  "shopee.workspace.inventory.side.top-variance": "Top stock variance",
  "shopee.workspace.inventory.side.no-variance": "No stock variance in loaded data.",
  "shopee.workspace.inventory.side.alerts-title": "Stock alerts",
  "shopee.workspace.inventory.alert.out-of-stock": "{count} products out of stock on Shopee",
  "shopee.workspace.inventory.alert.variance": "{count} products with stock variance",
  "shopee.workspace.inventory.alert.variance-desc": "Shopee differs from VMASS",
  "shopee.workspace.inventory.alert.unmapped": "{count} products unmapped in VMASS",
  "shopee.workspace.inventory.alert.unmapped-desc": "Map products before comparing",
  "shopee.workspace.pricing.kpi.total": "Total SKUs",
  "shopee.workspace.pricing.kpi.synced": "Synced prices",
  "shopee.workspace.pricing.kpi.variance": "Price variance",
  "shopee.workspace.pricing.kpi.pending": "Not updated",
  "shopee.workspace.pricing.kpi.pending-sub": "Missing Shopee or VMASS price",
  "shopee.workspace.pricing.kpi.errors": "Price errors",
  "shopee.workspace.pricing.subtitle": "Manage and sync product prices between VMASS and sales channels",
  "shopee.workspace.pricing.search-placeholder": "Search product name, SKU, barcode...",
  "shopee.workspace.pricing.category.all": "All categories",
  "shopee.workspace.pricing.category.fashion": "Fashion",
  "shopee.workspace.pricing.category.electronics": "Electronics",
  "shopee.workspace.pricing.category.food": "Food",
  "shopee.workspace.pricing.warehouse.main": "Main warehouse",
  "shopee.workspace.pricing.warehouse.hanoi": "Hanoi warehouse",
  "shopee.workspace.pricing.warehouse.hcm": "HCMC warehouse",
  "shopee.workspace.pricing.pagination-summary": "Showing {from} - {to} of {total} Shopee products",
  "shopee.workspace.pricing.col.vmass-price": "VMASS price",
  "shopee.workspace.pricing.col.price-small": "Selling price",
  "shopee.workspace.pricing.col.diff-range": "Highest - Lowest",
  "shopee.workspace.pricing.action.adjust-price": "Adjust price",
  "shopee.workspace.pricing.action.sync-price-list": "Sync price list",
  "shopee.workspace.pricing.action.cancel-rule": "Cancel price rule",
  "shopee.workspace.pricing.action.sync-price": "Sync prices",
  "shopee.workspace.pricing.action.batch-update": "Batch update",
  "shopee.workspace.pricing.action.price-rules": "Price rules",
  "shopee.workspace.pricing.alert.higher": "{count} products priced higher",
  "shopee.workspace.pricing.alert.lower": "{count} products priced lower",
  "shopee.workspace.pricing.alert.unavailable": "{count} products missing price data",
  "shopee.workspace.pricing.alert.threshold-desc": "vs VMASS > 10%",
  "shopee.workspace.pricing.sub.on-page-short": "On page",
  "shopee.workspace.pricing.side.variance-title": "Price variance overview",
  "shopee.workspace.pricing.side.top-variance": "Top price variance",
  "shopee.workspace.pricing.side.no-variance": "No price variance in loaded Shopee data.",
  "shopee.workspace.pricing.side.alerts-title": "Price alerts",
  "shopee.workspace.pricing.rule.title": "Channel price policy builder",
  "shopee.workspace.pricing.rule.policy-mode": "Policy mode",
  "shopee.workspace.pricing.rule.option-direct": "Use VMASS price directly",
  "shopee.workspace.pricing.rule.option-percent": "Percentage markup",
  "shopee.workspace.pricing.rule.option-fixed": "Fixed amount markup",
  "shopee.workspace.pricing.rule.option-cost-plus": "Cost plus fees and margin",
  "shopee.workspace.pricing.rule.markup-percent-label": "Markup percent (%)",
  "shopee.workspace.pricing.rule.markup-amount-label": "Fixed markup amount (VND)",
  "shopee.workspace.pricing.rule.fee-label": "Estimated channel fee (%)",
  "shopee.workspace.pricing.rule.packaging-label": "Packaging cost (VND)",
  "shopee.workspace.pricing.rule.rounding-label": "Rounding rule",
  "shopee.workspace.pricing.rule.rounding-none": "No rounding",
  "shopee.workspace.pricing.rule.rounding-thousand": "Round to thousand (.000)",
  "shopee.workspace.pricing.rule.rounding-nine-thousand": "Ending 9.000 (.9.000)",
  "shopee.workspace.pricing.rule.formula-strong": "Applied formula:",
  "shopee.workspace.pricing.rule.formula-text": "Channel price = [VMASS price + fixed fee] / (1 - channel fee %) -> rounding applied.",
  "shopee.workspace.pricing.rule.preview-no-base": "No VMASS price available in loaded Shopee data for preview.",
  "shopee.workspace.pricing.rule.preview-from": "Preview from VMASS price {base}: {result}",
  "shopee.workspace.pricing.rule.save-preview": "Save rule & preview",
  "shopee.workspace.pricing.approve.title": "Confirm approving & pushing the bulk price list to Shopee",
  "shopee.workspace.pricing.approve.warning-strong": "Safety warning:",
  "shopee.workspace.pricing.approve.warning-detail": "This action applies the new price rule and syncs the product price list to Shopee.",
  "shopee.workspace.pricing.approve.items-total": "Total items",
  "shopee.workspace.pricing.approve.rule-applied": "Applied rule",
  "shopee.workspace.pricing.approve.fee-deducted": "Channel fee deducted",
  "shopee.workspace.pricing.approve.queued": "Bulk price list update task started for Shopee",
  "shopee.workspace.pricing.approve.confirm": "Approve & update prices",
  "shopee.workspace.mapping.model-simple": "Simple product",
  "shopee.workspace.mapping.draft-created-from-listing": "Created a VMASS product from the Shopee listing",
  "shopee.workspace.mapping.no-provider-data": "Shopee provides no data",
  "shopee.workspace.mapping.tooltip-full": "SKU {sku} · Price {price} · Stock {stock}",
  "shopee.workspace.mapping.tooltip-price-stock": "Price {price} · Stock {stock}",
  "shopee.workspace.mapping.stock-colon": "Stock:",
  "shopee.workspace.mapping.price-label": "Price",
  "shopee.workspace.mapping.col.vmass-product": "VMASS product",
  "shopee.workspace.mapping.col.mapping": "Mapping",
  "shopee.workspace.mapping.pick-product-aria": "Choose a VMASS product to map",
  "shopee.workspace.mapping.no-mapping-permission": "You do not have permission to map products",
  "shopee.workspace.common.pick-product": "Choose product",
  "shopee.workspace.common.retry": "Retry",
  "shopee.workspace.common.yes": "Yes",
  "shopee.workspace.common.no": "No",
  "shopee.workspace.mapping.state-conflict": "Conflict",
  "shopee.workspace.mapping.auto-map-launched": "Auto-mapping started for {count} Shopee mappings",
  "shopee.workspace.mapping.inventory-sync-queued": "Shopee product inventory sync scheduled",
  "shopee.workspace.mapping.no-shop-selected": "No Shopee shop selected. Connect or select a shop to load real mapping data.",
  "shopee.workspace.mapping.kpi.total-sub": "{count} mapping rows from API",
  "shopee.workspace.mapping.kpi.rate-page": "{percent}% on current page",
  "shopee.workspace.mapping.kpi.rate": "Mapping rate",
  "shopee.workspace.mapping.search-placeholder": "Search SKU, barcode, product name...",
  "shopee.workspace.mapping.title": "Shopee mapping",
  "shopee.workspace.mapping.data-scope-banner": "Data from shop {shop}; status metrics are computed on the current page.",
  "shopee.workspace.mapping.shop-unselected": "not selected",
  "shopee.workspace.mapping.loading": "Loading mapping data from Shopee...",
  "shopee.workspace.mapping.empty": "Shopee returned no mappings matching the shop and current filter.",
  "shopee.workspace.mapping.detail-title": "Mapping details",
  "shopee.workspace.mapping.tab-info": "Info",
  "shopee.workspace.mapping.tab-history": "History",
  "shopee.workspace.mapping.status.disabled": "Sync disabled",
  "shopee.workspace.mapping.status.error": "Sync error",
  "shopee.workspace.mapping.status.healthy": "Healthy",
  "shopee.workspace.mapping.status.mapping-required": "Unmapped",
  "shopee.workspace.mapping.status.out-of-stock": "Out of stock",
  "shopee.workspace.mapping.section-vmass": "VMASS information",
  "shopee.workspace.mapping.section-shopee": "Shopee data",
  "shopee.workspace.mapping.available-stock": "Available stock",
  "shopee.workspace.mapping.shopee-name-colon": "Name on Shopee:",
  "shopee.workspace.mapping.not-linked": "Not linked to the Shopee channel",
  "shopee.workspace.mapping.sync-enabled-colon": "Sync allowed:",
  "shopee.workspace.mapping.auto-map-this": "Auto-map this SKU",
  "shopee.workspace.mapping.change": "Change mapping",
  "shopee.workspace.mapping.remove": "Remove mapping",
  "shopee.workspace.mapping.history-created": "Mapping created:",
  "shopee.workspace.mapping.history-updated": "Mapping updated:",
  "shopee.workspace.mapping.history-last-sync": "Last Shopee sync:",
  "shopee.workspace.mapping.sync-stock-to-shopee": "Sync stock to Shopee",
  "shopee.workspace.mapping.modal-title": "Choose a VMASS product to map",
  "shopee.workspace.mapping.candidate-search-placeholder": "Search by VMASS name, SKU or barcode",
  "shopee.workspace.mapping.candidates-loading": "Loading VMASS products...",
  "shopee.workspace.mapping.choose-product": "Choose a VMASS product",
  "shopee.workspace.mapping.nameless-product": "Unnamed product",
  "shopee.workspace.mapping.choose-variant": "Choose a VMASS variant",
  "shopee.workspace.mapping.no-variants-note": "This VMASS product has no variants; mapping will use the base product stock.",
  "shopee.workspace.mapping.no-candidates": "No VMASS products match the search.",
  "shopee.workspace.mapping.create-product": "Create new product",
  "shopee.workspace.mapping.save": "Save mapping",
  "shopee.workspace.mapping.auto-map-selected": "Auto-map selected ({count})",
  "einvoice.filter.issuance-status": "Issuance Status",
  "einvoice.filter.invoice-status": "Invoice Status",
  "einvoice.filter.all": "All",
  "einvoice.issuance-status.pending": "Pending",
  "einvoice.issuance-status.success": "Success",
  "einvoice.issuance-status.failed": "Failed",
  "einvoice.invoice-status.draft": "Draft",
  "einvoice.invoice-status.issued": "Issued",
  "template.badge": "Sample data",
  "template.convert": "Convert to real data",
  "product.btn-update": "Update product",
  "template.profile.title": "Guided sample data",
  "template.profile.description": "Sample products and ingredients help you explore the system. You can hide or show them as needed.",
  "template.profile.dismiss": "Hide sample data",
  "template.profile.show": "Show sample data",
  "template.profile.confirm": "Sample data and orders created from it will be hidden, and used sample inventory will be restored. Continue?",
  "template.profile.show-confirm": "Are you sure you want to show sample data again?",
  "template.profile.success": "Sample data hidden successfully",
  "template.profile.show-success": "Sample data shown successfully!",
  "shopee.workspace.shipping.customer-fallback": "Customer {number}",
  "shopee.workspace.shipping.product-fallback": "Shopee product",
  "shopee.workspace.shipping.service-standard": "Standard delivery",
  "shopee.workspace.shipping.status.ready-pickup": "Awaiting pickup",
  "shopee.workspace.shipping.status.processing": "Processing",
  "shopee.workspace.shipping.checklist.inspect": "Inspect products",
  "shopee.workspace.shipping.checklist.protect": "Shock-proof packing",
  "shopee.workspace.shipping.col.order-sub": "Order code | Channel",
  "shopee.workspace.shipping.col.phone-sub": "Phone",
  "shopee.workspace.shipping.col.amount": "Goods value",
  "shopee.workspace.shipping.col.progress-sub": "Progress",
  "shopee.workspace.shipping.print-slip-title": "Print slip",
  "shopee.workspace.shipping.alert.print-slip": "Print delivery slip for order {sn}",
  "shopee.workspace.shipping.alert.update-status": "Update status of order {sn}",
  "shopee.workspace.shipping.action.update-status": "Update status",
  "shopee.workspace.shipping.alert.cancel-order": "Cancel order {sn}",
  "shopee.workspace.shipping.action.cancel-order": "Cancel order",
  "shopee.workspace.shipping.subtitle": "Manage processing, packing and delivery for orders across all channels.",
  "shopee.workspace.shipping.create-shipping-order": "Create delivery order",
  "shopee.workspace.shipping.alert.print-labels-bulk": "Bulk print labels",
  "shopee.workspace.shipping.action.print-bulk": "Bulk print",
  "shopee.workspace.shipping.alert.export-excel": "Export list to Excel",
  "shopee.workspace.shipping.alert.syncing-orders": "Syncing new orders from channels...",
  "shopee.workspace.shipping.kpi.overdue": "{count} overdue orders",
  "shopee.workspace.shipping.kpi.packing": "Packing",
  "shopee.workspace.shipping.kpi.packing-sub": "1 in progress",
  "shopee.workspace.shipping.kpi.pickup-today": "Pickup today",
  "shopee.workspace.shipping.kpi.handover": "Handed over",
  "shopee.workspace.shipping.kpi.shipping": "Out for delivery",
  "shopee.workspace.shipping.kpi.shipping-sub": "In transit",
  "shopee.workspace.shipping.step.delivered": "Completed",
  "shopee.workspace.shipping.step.picking": "Picking",
  "shopee.workspace.shipping.action.print-label": "Print tracking label",
  "shopee.workspace.shipping.search-placeholder": "Search order code, customer name, phone...",
  "shopee.workspace.shipping.filter.all-carriers": "All carriers",
  "shopee.workspace.common.yesterday": "Yesterday",
  "shopee.workspace.common.this-month": "This month",
  "shopee.workspace.shipping.pagination-summary": "Showing 1 - {count} of {total} orders",
  "shopee.workspace.shipping.perf.performance-today": "Today's performance",
  "shopee.workspace.shipping.perf.updated-at": "Updated 10:30",
  "shopee.workspace.shipping.perf.processed": "Processed",
  "shopee.workspace.shipping.perf.orders-value": "{count} orders",
  "shopee.workspace.shipping.perf.on-time": "On time",
  "shopee.workspace.shipping.perf.overdue": "Overdue",
  "shopee.workspace.shipping.perf.success-rate": "Delivery success rate",
  "shopee.workspace.shipping.perf.returns": "Returned orders",
  "shopee.workspace.shipping.perf.top-carriers": "Top carriers",
  "shopee.workspace.shipping.alert.close-detail": "Close details panel",
  "shopee.workspace.shipping.section-customer": "Customer information",
  "shopee.workspace.shipping.title.call": "Call",
  "shopee.workspace.shipping.alert.call": "Call {phone}",
  "shopee.workspace.shipping.title.address": "View address",
  "shopee.workspace.shipping.section-products": "Products ({count})",
  "shopee.workspace.shipping.section-shipping-info": "Shipping information",
  "shopee.workspace.shipping.col.carrier": "Carrier",
  "shopee.workspace.shipping.title.copy-code": "Copy code",
  "shopee.workspace.shipping.alert.copied": "Copied: {code}",
  "shopee.workspace.shipping.col.service": "Service",
  "shopee.workspace.shipping.col.shipping-fee": "Shipping fee",
  "shopee.workspace.shipping.col.cod": "COD amount",
  "shopee.workspace.shipping.col.total-collect": "Total collect",
  "shopee.workspace.shipping.checklist-title": "Packing checklist",
  "shopee.workspace.shipping.alert.print-label": "Print tracking label for {sn}",
  "shopee.workspace.shipping.action.print-slip": "Print packing slip",
  "shopee.workspace.shipping.alert.print-slip-order": "Print packing slip for {sn}",
  "shopee.workspace.shipping.action.packed-done": "Packed completely",
  "shopee.workspace.shipping.notice.packed-handover": "Packing completed; moved to Awaiting hand-over status",
  "shopee.workspace.shipping.alert.packed-done": "Packing completed for order {sn}",
  "shopee.workspace.shipping.action.complete-handover": "Complete & move to awaiting hand-over",
  "shopee.workspace.shipping.action.report-shortage": "Report shortage",
  "shopee.workspace.shipping.action.delay-packing": "Delay packing",
  "shopee.workspace.shipping.scan.title": "Packing station - Scan order code",
  "shopee.workspace.shipping.scan.desc": "Scan the barcode or enter the tracking / Shopee order code to verify & print labels instantly:",
  "shopee.workspace.shipping.scan.label": "Order code / Tracking code",
  "shopee.workspace.shipping.scan.placeholder": "e.g. SP24072201 or GHN1234567890...",
  "shopee.workspace.shipping.alert.not-found": "No order found with code: {code}",
  "shopee.workspace.shipping.scan.now": "Scan now",
  "shopee.workspace.finance.channel-pos": "POS - Store",
  "shopee.workspace.finance.status.paid": "Paid",
  "shopee.workspace.finance.status.pending-payment": "Awaiting payment",
  "shopee.workspace.finance.status.discrepancy": "Discrepancy",
  "shopee.workspace.finance.status.dispute": "Dispute",
  "shopee.workspace.finance.bank-encrypted": "Encrypted account",
  "shopee.workspace.finance.payout.transferred": "Transferred",
  "shopee.workspace.finance.payout.processing": "Processing",
  "shopee.workspace.finance.sync-queued": "Reconciliation sync scheduled",
  "shopee.workspace.finance.subtitle": "Track, reconcile and manage payments from all sales channels",
  "shopee.workspace.finance.forecast": "Payout forecast",
  "shopee.workspace.finance.export-report": "Export report",
  "shopee.workspace.finance.action.sync": "Sync reconciliation",
  "shopee.workspace.finance.kpi.revenue": "Revenue",
  "shopee.workspace.finance.kpi.vs-prev-period": "vs previous period",
  "shopee.workspace.finance.kpi.pending-reconciliation": "Pending reconciliation",
  "shopee.workspace.finance.kpi.holding": "On hold",
  "shopee.workspace.finance.kpi.refund": "Refunds",
  "shopee.workspace.finance.kpi.fees": "Fees & deductions",
  "shopee.workspace.finance.cashflow-title": "Cash flow",
  "shopee.workspace.finance.net-received": "Net received",
  "shopee.workspace.finance.forecast.tomorrow": "Tomorrow",
  "shopee.workspace.finance.forecast.next-3-days": "Next 3 days",
  "shopee.workspace.finance.forecast.next-week": "Next week",
  "shopee.workspace.finance.forecast.view-detail": "View forecast details →",
  "shopee.workspace.finance.filter.all-banks": "All bank accounts",
  "shopee.workspace.finance.col.sn": "Settlement code",
  "shopee.workspace.finance.col.period": "Settlement period",
  "shopee.workspace.finance.col.order-count": "Orders",
  "shopee.workspace.finance.col.payout-date": "Payment date",
  "shopee.workspace.finance.action.export-excel-file": "Export Excel file",
  "shopee.workspace.finance.detail-title": "Settlement details",
  "shopee.workspace.finance.meta.period": "Settlement period:",
  "shopee.workspace.finance.meta.payout-date": "Payment date:",
  "shopee.workspace.finance.meta.bank-account": "Receiving account:",
  "shopee.workspace.finance.meta.transaction-code": "Transaction code:",
  "shopee.workspace.finance.meta.status": "Status:",
  "shopee.workspace.finance.tab-orders": "Order details ({count})",
  "shopee.workspace.finance.bd.gross-revenue": "Total revenue",
  "shopee.workspace.finance.bd.platform-deduction": "Platform deductions ^",
  "shopee.workspace.finance.bd.voucher": "Platform vouchers",
  "shopee.workspace.finance.bd.shipping-buyer": "Shipping fee (paid by buyer)",
  "shopee.workspace.finance.bd.seller-discount": "Platform discounts",
  "shopee.workspace.finance.bd.payment-fee": "Payment fee",
  "shopee.workspace.finance.bd.service-fee": "Service fee",
  "shopee.workspace.finance.bd.tax": "Tax",
  "shopee.workspace.finance.bd.refunds": "Refunds / Returns ^",
  "shopee.workspace.finance.bd.refund-fee": "Refund fee",
  "shopee.workspace.finance.bd.other-deductions": "Other deductions",
  "shopee.workspace.finance.action.view-documents": "View reconciliation documents",
  "shopee.workspace.finance.action.download-statement": "Download statement",
  "shopee.workspace.finance.discrepancy.alert": "Discrepancy needs checking:",
  "shopee.workspace.finance.discrepancy.desc": "{count} orders have discrepancies between VMASS and the channel.",
  "shopee.workspace.finance.widget.success-rate": "Reconciliation success rate",
  "shopee.workspace.finance.legend.success": "Success:",
  "shopee.workspace.finance.legend.failed": "Failed:",
  "shopee.workspace.finance.widget.top-revenue-channels": "Highest revenue channels",
  "shopee.workspace.finance.channel-others": "Others",
  "shopee.workspace.finance.widget.popular-refund-reasons": "Popular refund reasons",
  "shopee.workspace.finance.reason.wrong-color": "Wrong color/shade:",
  "shopee.workspace.finance.reason.wrong-size": "Wrong size:",
  "shopee.workspace.finance.reason.defect": "Product defect:",
  "shopee.workspace.finance.reason.not-liked": "Did not like it:",
  "shopee.workspace.finance.insight.unpaid-orders": "You have {count} Shopee orders delivered more than 10 days ago with no payout yet.",
  "shopee.workspace.finance.insight.transfer-tomorrow": "Shopee will transfer around 42 million tomorrow ({date}).",
  "shopee.workspace.finance.insight.fee-increase": "TikTok Shop shipping fees increased {percent} vs last month.",
  "shopee.workspace.finance.insight.view-more": "View more insights →",
  "shopee.workspace.issues.channel-other": "Other channel",
  "shopee.workspace.common.order-hash": "Order",
  "shopee.workspace.common.product-hash": "Product",
  "shopee.workspace.tab.shipping-short": "Shipping",
  "shopee.workspace.issues.subtitle": "Track, handle and fix connection, sync and system issues",
  "shopee.workspace.issues.severity.critical": "Critical",
  "shopee.workspace.issues.severity.high": "High",
  "shopee.workspace.issues.severity.medium": "Medium",
  "shopee.workspace.issues.severity.low": "Low",
  "shopee.workspace.issues.status.unresolved": "Unresolved",
  "shopee.workspace.issues.status.in-progress": "In progress",
  "shopee.workspace.issues.status.waiting": "Waiting",
  "shopee.workspace.issues.status.resolved": "Resolved",
  "shopee.workspace.issues.status.ignored": "Ignored",
  "shopee.workspace.issues.type.order-sync": "Order sync",
  "shopee.workspace.issues.type.product-sync": "Product sync",
  "shopee.workspace.issues.type.system-task": "System task",
  "shopee.workspace.issues.type.system": "System",
  "shopee.workspace.issues.type.stock-sync": "Stock sync",
  "shopee.workspace.issues.type.api-connection": "API connection",
  "shopee.workspace.issues.type.payment": "Payment",
  "shopee.workspace.issues.filter.all-types": "All issue types",
  "shopee.workspace.issues.filter.all-severities": "All severities",
  "shopee.workspace.issues.error.order-sync": "Order sync error",
  "shopee.workspace.issues.error.check-order-status": "Check order status",
  "shopee.workspace.issues.error.sku-mapping": "SKU mapping error",
  "shopee.workspace.issues.error.sku-unmapped": "SKU not mapped in VMASS or stock sync error",
  "shopee.workspace.issues.error.job-ended-status": "Job ended with status {status}",
  "shopee.workspace.issues.error.retried-times": "Retried {count} times",
  "shopee.workspace.issues.action.process-label": "Handle issue {id}",
  "shopee.workspace.issues.action.process-now": "Handle now",
  "shopee.workspace.issues.action.ignore-label": "Ignore issue {id}",
  "shopee.workspace.issues.action.ignore": "Ignore",
  "shopee.workspace.issues.action.mark-resolved": "Mark as resolved",
  "shopee.workspace.issues.empty": "No matching issue data found",
  "shopee.workspace.issues.pagination-of": "of {total} issues",
  "shopee.workspace.issues.total-errors": "Total issues",
  "shopee.workspace.issues.chart.by-channel": "Issues by channel",
  "shopee.workspace.issues.chart.by-type": "Issues by type",
  "shopee.workspace.issues.chart.by-severity": "Issues by severity",
  "shopee.workspace.issues.chart.timeline": "Issue timeline",
  "shopee.workspace.issues.chart.top-errors": "Top issues",
  "shopee.workspace.issues.times-count": "{count} times",
  "shopee.workspace.issues.top.order-list": "Unable to fetch order list",
  "shopee.workspace.issues.top.invalid-data": "Invalid data",
  "shopee.workspace.issues.top.negative-stock": "Negative stock",
  "shopee.workspace.issues.top.payment-not-found": "Payment transaction not found",
  "shopee.workspace.issues.activity.processed": "handled the TikTok Shop - Product sync issue",
  "shopee.workspace.issues.activity.resolved": "resolved the issue",
  "shopee.workspace.issues.drawer.title": "Issue details",
  "shopee.workspace.issues.drawer.info-title": "Issue information",
  "shopee.workspace.issues.drawer.error-code": "Error code",
  "shopee.workspace.issues.drawer.request": "Request",
  "shopee.workspace.issues.drawer.request-detail": "Request detail",
  "shopee.workspace.issues.drawer.response-detail": "Response detail",
  "shopee.workspace.issues.drawer.impact-title": "Impact",
  "shopee.workspace.issues.drawer.impact-orders": "Orders affected",
  "shopee.workspace.issues.drawer.impact-products": "Products affected",
  "shopee.workspace.issues.drawer.impact-revenue": "Revenue affected",
  "shopee.workspace.issues.drawer.suggestions-title": "Suggested fixes",
  "shopee.workspace.issues.suggest.check-api": "Check the Shopee API connection",
  "shopee.workspace.issues.suggest.check-status": "Check Shopee system status",
  "shopee.workspace.issues.suggest.retry-sync": "Retry sync in a few minutes",
  "shopee.workspace.issues.suggest.contact-support": "Contact support if the issue persists",
  "shopee.workspace.issues.drawer.note-title": "Internal note",
  "shopee.workspace.issues.confirm.title": "Confirm issue handling",
  "shopee.workspace.issues.confirm.desc": "Are you sure you want to perform this action?",
  "shopee.workspace.issues.confirm.items": "{label} ({count} items)",
  "shopee.workspace.issues.confirm.ok": "Confirm",
  "shopee.workspace.issues.confirm.queued": "Remediation task queued",
  "shopee.workspace.issues.kpi.all": "All issues",
  "shopee.workspace.issues.kpi.all-sub": "Total detected problems",
  "shopee.workspace.issues.kpi.unresolved-sub": "Needs immediate check",
  "shopee.workspace.issues.kpi.in-progress": "Issues in progress",
  "shopee.workspace.issues.kpi.in-progress-sub": "Currently being processed",
  "shopee.workspace.issues.kpi.resolved": "Resolved issues",
  "shopee.workspace.issues.kpi.resolved-sub": "Successfully fixed",
  "shopee.workspace.issues.kpi.critical": "Critical issues",
  "shopee.workspace.issues.kpi.critical-sub": "High & critical severity",
  "shopee.workspace.issues.action.configure-alerts": "Configure alerts",
  "shopee.workspace.issues.action.system-logs": "System logs",
  "shopee.workspace.issues.col.channel-source": "Channel / Source",
  "shopee.workspace.issues.col.type": "Issue type",
  "shopee.workspace.issues.col.severity": "Severity",
  "shopee.workspace.issues.col.object": "Object",
  "shopee.workspace.issues.col.message": "Error message",
  "shopee.workspace.listing.description-template": "{name} - High quality product",
  "shopee.workspace.listing.err.no-shop": "No Shopee shop selected",
  "shopee.workspace.listing.err.no-product": "No VMASS product selected",
  "shopee.workspace.listing.err.name-length": "Product name must be 5-120 characters",
  "shopee.workspace.listing.err.desc-length": "Description must be at least 25 characters",
  "shopee.workspace.listing.err.price": "Price must be greater than 0",
  "shopee.workspace.listing.err.variant-price": "Every variant price must be greater than 0",
  "shopee.workspace.listing.err.weight": "Weight must be between 0.01 and 50 kg",
  "shopee.workspace.listing.err.no-category": "No Shopee category selected",
  "shopee.workspace.listing.err.brand-load-failed": "Shopee brands could not be loaded",
  "shopee.workspace.listing.err.no-brand": "No Shopee brand selected",
  "shopee.workspace.listing.err.no-logistics": "No shipping channel selected",
  "shopee.workspace.listing.err.missing-attribute": "Missing attribute: {attribute}",
  "shopee.workspace.listing.err.dimensions": "All three dimensions must be filled in and greater than 0",
  "shopee.workspace.listing.update-queued": "Listing update request queued",
  "shopee.workspace.listing.publish-queued": "Product queued for publishing to Shopee",
  "shopee.workspace.listing.label.shop": "Shopee shop *",
  "shopee.workspace.listing.no-shops": "No Shopee shop available",
  "shopee.workspace.listing.primary-mark": "Primary",
  "shopee.workspace.listing.shop-hint": "Category, brand and shipping data will load based on the selected shop.",
  "shopee.workspace.listing.label.brand": "Shopee brand",
};

export default enUs;
